import * as THREE from "three";
import { CheckLegsByResponse } from "./pricingReducer";
import * as cuBuilding from './pricingReducer';
import * as cuComponent from './componentReducer';

import { params, const_var,calculateLegsCount } from "./reducer"
import { GrassBackground, GrayBackground, GROUND_IMG, MetalStripeImg, NormalStripeImg, SKY_IMG, TrimTexture, LapSiding, BoardBatten, ReflectLegTexturePX, ReflectLegTextureNX, ReflectLegTexturePY, ReflectLegTextureNY, ReflectLegTexturePZ, ReflectLegTextureNZ } from "../../utils/Textures";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { controls } from "./eventReducer";



  const loader = new THREE.TextureLoader();
  const loadTextureAsync = async (url) => {
    return new Promise((resolve, reject) => {
      loader.load(
        process.env.REACT_APP_BASE_URL+url,
        (texture) => {
          resolve(texture);
        },
        undefined,
        (error) => {
          reject(error);
        }
      );
    });
  };

  const setDimensions = (widthRatio, heightRatio,manufacturerLogoFront,manufacturerLogoBack ,manufacturerLogoCenter) => {
    
      // set dimention for front logo
      manufacturerLogoFront.name = "manufacturerLogoFront";
      if(const_var.crmSetting.main_domain_url == "eaglebuildings.com" || const_var.crmSetting.parent_api_token == "Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG"){
        manufacturerLogoFront.scale.set(2.5,0.9,4);
        manufacturerLogoFront.position.set(0, params.p_h + (params.p_w/2*(params.p_r_p/12))/2, params.p_d/2+0.3);
        manufacturerLogoFront.rotation.y = 0
        if(params.singleSlope){
            manufacturerLogoFront.position.set(params.p_w/2 + 0.1,params.p_h - 1.5, 0);
            manufacturerLogoFront.rotation.y = Math.PI/2
        }
      }else{
        manufacturerLogoFront.scale.set(widthRatio,heightRatio,4);
        manufacturerLogoFront.position.set(0, params.p_h + ((params.p_w/2*(params.p_r_p/12))/1.1) - ((heightRatio)/2) - ((widthRatio)/2*(params.p_r_p/12)) - 0.2, params.p_d/2+0.3);
        if(params.singleSlope) manufacturerLogoFront.position.y = params.p_h - (params.p_w*(params.p_r_p/12))/2 - ((heightRatio)/2) - ((widthRatio)/2*(params.p_r_p/12)) - 0.2  
      }
      if(params.p_f_w == "Open" && params.p_u_c == true && !params.singleSlope) manufacturerLogoFront.position.z = params.p_d/-2 + Number(params.p_u_t) + 0.3

      // set dimention for back logo
      manufacturerLogoBack.scale.set(manufacturerLogoFront.scale.x , manufacturerLogoFront.scale.y , manufacturerLogoFront.scale.z);
      manufacturerLogoBack.position.set(manufacturerLogoFront.position.x , manufacturerLogoFront.position.y , params.p_d/-2-0.3);
      manufacturerLogoBack.rotation.set(manufacturerLogoFront.rotation.x , Math.PI , manufacturerLogoFront.rotation.z)

      // set dimention for center logo
      manufacturerLogoCenter.scale.set(manufacturerLogoFront.scale.x + 5 , manufacturerLogoFront.scale.y + 5, manufacturerLogoFront.scale.z);
      manufacturerLogoCenter.position.set(0 , 0.15 , 0);
      manufacturerLogoCenter.rotation.set(Math.PI/-2 , 0 , 0)
  }

  export const logoTexture = async() =>{
    
    if (const_var.scene != undefined && const_var.scene != "" && const_var.scene.getObjectByName("manufacturerLogoFront")!=undefined && const_var.crmSetting.parent_api_token !== undefined && const_var.crmSetting.parent_api_token !== ""  && const_var.crmSetting.parent_api_token !==null ) {

    let widthRatio = params.logoWidth*params.p_w
    let heightRatio = params.logoHeight*params.p_w
    let waterMarkLogo = const_var.crmSetting.parent_api_token

    let manufacturerLogoFront = const_var.scene.getObjectByName("manufacturerLogoFront")
    let manufacturerLogoBack = const_var.scene.getObjectByName("manufacturerLogoBack")
    let manufacturerLogoCenter = const_var.scene.getObjectByName("manufacturerLogoCenter")

    if(waterMarkLogo != undefined){
      try{
          let fileURL = require(`../../assets/images/newWatermark/${waterMarkLogo}.svg`);

          setDimensions(widthRatio, heightRatio,manufacturerLogoFront,manufacturerLogoBack ,manufacturerLogoCenter);

          let manufacturerTexture
          if((const_var.crmSetting.main_domain_url == "eaglebuildings.com" || const_var.crmSetting.parent_api_token == "Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG")){
          let eagleInvertImg = require(`../../assets/images/newWatermark/${waterMarkLogo}-invert.svg`);
            manufacturerTexture = await loadTextureAsync(eagleInvertImg)
            manufacturerTexture.anisotropy = Math.min(const_var.renderer.capabilities.getMaxAnisotropy(), 5);
            manufacturerTexture.wrapS = THREE.RepeatWrapping;
            manufacturerTexture.wrapT = THREE.RepeatWrapping;
            
          }

          let texture = await loadTextureAsync(fileURL)
          
          texture.anisotropy = Math.min(const_var.renderer.capabilities.getMaxAnisotropy(), 5);
          params.logoWidth = (texture.image.width/1000)/20;
          params.logoHeight = (texture.image.height/1000)/20;
          manufacturerLogoFront.material.map = texture;
          if(const_var.crmSetting.main_domain_url == "eaglebuildings.com" || const_var.crmSetting.parent_api_token == "Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG"){
            manufacturerLogoFront.material.displacementMap = manufacturerTexture;
            manufacturerLogoFront.material.displacementScale = 0.05;
          }
          manufacturerLogoFront.renderOrder = new Date().getTime() + (3600 * 24 * 5000);
          manufacturerLogoFront.material.map.wrapS = THREE.RepeatWrapping;
          manufacturerLogoFront.material.map.wrapT = THREE.RepeatWrapping;
          manufacturerLogoFront.material.transparent = true
          manufacturerLogoFront.material.opacity = 1
          manufacturerLogoFront.material.needsUpdate = true
          manufacturerLogoFront.visible = ((const_var.crmSetting.main_domain_url != "eaglebuildings.com" && const_var.crmSetting.parent_api_token != "Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG"))?(((params.p_f_w == "Close") || (params.p_f_w == "Open" && params.p_u_c == true)) && manufacturerLogoFront.material.map != null && manufacturerLogoFront.material.map != undefined) ? true : false:(((params.p_f_w != "Open") || (params.p_f_w == "Open" && params.p_u_c == true)) && params.singleSlope == false && manufacturerLogoFront.material.map != null && manufacturerLogoFront.material.map != undefined)?true: (params.p_r_w != "Open" && params.singleSlope == true) ? true : false;

          widthRatio = params.logoWidth*params.p_w
          heightRatio = params.logoHeight*params.p_w
          setDimensions(widthRatio, heightRatio,manufacturerLogoFront,manufacturerLogoBack ,manufacturerLogoCenter);

          if(const_var.crmSetting.main_domain_url != "eaglebuildings.com" && const_var.crmSetting.parent_api_token != "Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG"){

            manufacturerLogoBack.material =  manufacturerLogoFront.material
            manufacturerLogoBack.visible = ((params.p_b_w == "Close") && manufacturerLogoFront.material.map != null && manufacturerLogoFront.material.map != undefined)
            manufacturerLogoBack.name = "manufacturerLogoBack"
            manufacturerLogoBack.renderOrder = new Date().getTime() + (3600 * 24 * 5000);
        }else{
            manufacturerLogoBack.visible = false
        }
        if(const_var.crmSetting.main_domain_url == "eaglebuildings.com" || const_var.crmSetting.parent_api_token == "Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG"){
            let eagleFileURL = require(`../../assets/images/newWatermark/${waterMarkLogo}-ground.svg`);
            let eagleTexture = await loadTextureAsync(eagleFileURL)
            manufacturerLogoCenter.material.map = eagleTexture;
            manufacturerLogoCenter.renderOrder = new Date().getTime() + (3600 * 24 * 5000);
            manufacturerLogoCenter.material.map.wrapS = THREE.RepeatWrapping;
            manufacturerLogoCenter.material.map.wrapT = THREE.RepeatWrapping;
            manufacturerLogoCenter.material.transparent = true
            manufacturerLogoCenter.material.opacity = 1
            manufacturerLogoCenter.material.needsUpdate = true
        }else{
            manufacturerLogoCenter.material =  manufacturerLogoFront.material
        }
            manufacturerLogoCenter.name = "manufacturerLogoCenter"
            manufacturerLogoCenter.visible =  (manufacturerLogoFront.material.map != null && manufacturerLogoFront.material.map != undefined)
            manufacturerLogoCenter.renderOrder = new Date().getTime() + (3600 * 24 * 5000);


        } catch (error) {
            if(manufacturerLogoFront != undefined) manufacturerLogoFront.visible = false
            if(manufacturerLogoBack != undefined) manufacturerLogoBack.visible = false
            if(manufacturerLogoCenter != undefined) manufacturerLogoCenter.visible = false

            console.log("Watermark not found")
        }
      }else{
        if(manufacturerLogoFront != undefined) manufacturerLogoFront.visible = false
        if(manufacturerLogoBack != undefined) manufacturerLogoBack.visible = false
        if(manufacturerLogoCenter != undefined) manufacturerLogoCenter.visible = false
        if("undefined" != typeof const_var.scene.getObjectByName("manufacturerLogoFront") && const_var.scene.getObjectByName("manufacturerLogoFront").visible == true) const_var.scene.getObjectByName("manufacturerLogoFront").visible = false;
        if("undefined" != typeof const_var.scene.getObjectByName("manufacturerLogoBack") && const_var.scene.getObjectByName("manufacturerLogoBack").visible == true) const_var.scene.getObjectByName("manufacturerLogoBack").visible = false;
        if("undefined" != typeof const_var.scene.getObjectByName("manufacturerLogoCenter") && const_var.scene.getObjectByName("manufacturerLogoCenter").visible == true) const_var.scene.getObjectByName("manufacturerLogoCenter").visible = false;
      }
    }
  }



export const installationSurface = (installationSurfaceValue) =>{
        // Center Building ground
        if (const_var.scene.getObjectByName("ground")!=undefined) {
            try{
                const groundTextureUrl = require(`../../assets/images/installation-surface/${installationSurfaceValue}.jpg`).default;
                let leftLeanWidth = params.lean_p_w;
                let rightLeanWidth = params.leanR_p_w;
                let cover = 2
                let borderWidth = 0.25
                let repeatX = params.p_w
                let repeatY = params.p_d
                let borderWidthLeft = params.p_w/-2
                let borderWidthRight = params.p_w/2
                let borderLengthFront = params.p_d/-2
                let borderLengthBack = params.p_d/2

                if(params.leanStyle.left == "gable"){
                    leftLeanWidth = params.lean_p_d;
                }
                if(params.leanStyle.right == "gable"){
                    rightLeanWidth = params.leanR_p_d;
                }

                let ground = const_var.scene.getObjectByName("ground")
                ground.name = "ground";
                ground.scale.set((params.p_w) + cover, (params.p_d) + cover, 1)
                ground.position.set(0, 0.05, 0)

                if(params.add_left_lean == true && params.add_right_lean == false){
                ground.scale.x = (params.p_w + leftLeanWidth) + cover
                ground.position.x = -leftLeanWidth/2
                repeatX = params.p_w + leftLeanWidth
                borderWidthLeft = (params.p_w/-2) - leftLeanWidth
                }else if(params.add_left_lean == false && params.add_right_lean == true){
                ground.scale.x = (params.p_w + rightLeanWidth) + cover
                ground.position.x = rightLeanWidth/2
                repeatX = params.p_w + rightLeanWidth
                borderWidthRight = (params.p_w/2) + rightLeanWidth
                }else if(params.add_left_lean == true && params.add_right_lean == true){
                ground.scale.x = (params.p_w + rightLeanWidth + leftLeanWidth) + cover
                ground.position.x = -leftLeanWidth/2 + rightLeanWidth/2
                repeatX = params.p_w + rightLeanWidth + leftLeanWidth
                borderWidthLeft = (params.p_w/-2) - leftLeanWidth
                borderWidthRight = (params.p_w/2) + rightLeanWidth
                }else{
                ground.scale.x = (params.p_w) + cover
                ground.position.x = 0
                }

                if(params.add_front_lean == true && params.add_back_lean == false){
                ground.scale.y = (params.p_d + params.leanF_p_w) + cover
                ground.position.z = params.leanF_p_w/2
                repeatY = params.p_d + params.leanF_p_w
                borderLengthFront = (params.p_d/-2) - params.leanF_p_w
                }else if(params.add_front_lean == false && params.add_back_lean == true){
                ground.scale.y = (params.p_d + params.leanB_p_w) + cover
                ground.position.z = -params.leanB_p_w/2
                repeatY = params.p_d + params.leanB_p_w
                borderLengthBack = (params.p_d/2) + params.leanB_p_w
                }else if(params.add_front_lean == true && params.add_back_lean == true){
                ground.scale.y = (params.p_d + params.leanB_p_w + params.leanF_p_w) + cover
                ground.position.z = -params.leanB_p_w/2 + params.leanF_p_w/2
                repeatY = params.p_d + params.leanB_p_w + params.leanF_p_w
                borderLengthFront = (params.p_d/-2) - params.leanF_p_w
                borderLengthBack = (params.p_d/2) + params.leanB_p_w
              }else{
                ground.scale.y = (params.p_d) + cover
                ground.position.z = 0
              }

              if(params.isShowCenter){
                ground.scale.set((params.p_w) + cover, (params.p_d) + cover, 1)
                ground.position.set(0, 0.05, 0)
                borderWidthLeft = params.p_w/-2
                borderWidthRight = params.p_w/2
                borderLengthFront = params.p_d/-2
                borderLengthBack = params.p_d/2
              }

              ground.rotation.x = Math.PI/-2
              ground.visible = true
              let loader = new THREE.TextureLoader();
              let groundTexture = loader.load(`${process.env.REACT_APP_BASE_URL}${groundTextureUrl}`, function(textureImg) {
                groundTexture.anisotropy = Math.min(const_var.renderer.capabilities.getMaxAnisotropy(), 5);
                ground.material.map = textureImg
                ground.material.bumpMap = textureImg
                ground.material.bumpScale = 1
                ground.material.map.wrapS = THREE.RepeatWrapping;
                ground.material.map.wrapT = THREE.RepeatWrapping;
                ground.material.map.repeat.set(repeatX/10,repeatY/10);
                ground.material.needsUpdate = true
              })


            // if (const_var.scene.getObjectByName("groundBorder")!=undefined) {
            //     let groundBorder = const_var.scene.getObjectByName("groundBorder");

            //     let groundBorderGeo = new THREE.Shape();
            //     groundBorderGeo.moveTo((borderWidthRight)  + (cover/2),(borderLengthBack)  + (cover/2)); //bottom left
            //     groundBorderGeo.lineTo((borderWidthLeft) - (cover/2),(borderLengthBack)  + (cover/2));//top left
            //     groundBorderGeo.lineTo((borderWidthLeft) - (cover/2),(borderLengthFront) - (cover/2)); // top right
            //     groundBorderGeo.lineTo((borderWidthRight)  + (cover/2),(borderLengthFront) - (cover/2)); // bottom right
            //     groundBorderGeo.closePath()

            //     let groundBorderHoles = new THREE.Shape();
            //     groundBorderHoles.moveTo((borderWidthRight)  + (cover/2) - borderWidth,(borderLengthBack)  + (cover/2) - borderWidth); //bottom left
            //     groundBorderHoles.lineTo((borderWidthLeft) - (cover/2) + borderWidth,(borderLengthBack)  + (cover/2) - borderWidth);//top left
            //     groundBorderHoles.lineTo((borderWidthLeft) - (cover/2) + borderWidth,(borderLengthFront) - (cover/2) + borderWidth); // top right
            //     groundBorderHoles.lineTo((borderWidthRight)  + (cover/2) - borderWidth,(borderLengthFront) - (cover/2) + borderWidth); // bottom right
            //     groundBorderHoles.closePath()

            //     groundBorderGeo.holes.push(groundBorderHoles)
        
            //     let extrudeSettingsgroundBorder = {
            //         depth: 0.2, // height of the raft
            //         bevelEnabled: false, // no bevel on edges
            //         };
            //     let groundBorderGeometry = new THREE.ExtrudeGeometry(
            //         groundBorderGeo,
            //         extrudeSettingsgroundBorder
            //     );

            //     groundBorder.geometry = groundBorderGeometry
            //     groundBorder.rotation.x = Math.PI/-2
            //     groundBorder.visible = true;
            //     let groundBorderTexture = loader.load(`${process.env.REACT_APP_BASE_URL}${groundTextureUrl}`, function(textureImg) {
            //         groundBorderTexture.anisotropy = Math.min(const_var.renderer.capabilities.getMaxAnisotropy(), 5);
            //         groundBorder.material.map = textureImg
            //         ground.material.bumpMap = textureImg
            //         ground.material.bumpScale = 1
            //         groundBorder.material.map.wrapS = THREE.RepeatWrapping;
            //         groundBorder.material.map.wrapT = THREE.RepeatWrapping;
            //         groundBorder.material.map.repeat.set(0.2,0.2);
            //         groundBorder.material.needsUpdate = true
            //       })

            // }


            } catch(error) {
              console.log("Error loading file:", error)
            }
          }
}

export const updateCenterBuildingInsulation = (insulation,checkCompare) =>{
    if(checkCompare!=undefined && checkCompare == "forCompare"){
        if(insulation && insulation.length > 0) {
            const_var.insulationJsonCompare = [];
            // const_var.insulationJsonCompare[0] = 'Select';
            for(var i=0;i<insulation.length;i++) {
                const_var.insulationJsonCompare[insulation[i].insulation_id] = insulation[i].name;
            }
        }
        
    }else{
        if(insulation && insulation.length > 0) {
            const_var.a_p_d_a.insulation = insulation;
            params.insulation.center.showInsulation = true;
            const_var.insulationJson = [];
            // const_var.insulationJson[0] = 'Select';
            for(var i=0;i<insulation.length;i++) {
                const_var.insulationJson[insulation[i].insulation_id] = insulation[i].name;
                const_var.insulationPriceJson[insulation[i].insulation_id] = insulation[i];
            }
        } 
    }
}

export const getSelectedNavTab = (buildingData) => {
    const buildingType = buildingData?.display_building_type_name;
    if (buildingType?.includes('Carport')) {
        return 'carports';
    } else if (buildingType?.includes('Garage')) {
        return 'garages';
    } else if (buildingType?.includes('Commercial')) {
        return 'commercial';
    } else if (buildingType?.includes('Barn')) {
        return 'barns';
    } else if (buildingType?.includes('RV')) {
        return 'rvcover';
    } else if (buildingType?.includes('Standing')) {
        return 'freestanding';
    } else {
        return 'garages'; // Default case
    }
}

export const mapPopularColors = (colors = [],popularColor = []) => {
    popularColor.forEach(cl => {
        cl.wallColor = [...colors].find(c => c.hex_value == cl.wall_hex_value);
        cl.trimColor = [...colors].find(c => c.hex_value == cl.trim_hex_value);
        cl.roofColor = [...colors].find(c => c.hex_value == cl.roof_hex_value);
    });
    return popularColor;
  }

export const insulationForCompare = (compareInsulation, fullBuilding, roofOnly, leanType, storage, sideWall) => {
    // console.log({compareInsulation, fullBuilding, roofOnly, leanType, storage, sideWall},const_var.wallsData[leanType]);
    let insulation, insulationPrice, roofCost = 0, endWallsCost = 0, sideWallsCost = 0, sideWallsCount = 0,closedSideWalls = 0;
     if (const_var.isInsulaltionForOldQuotes && !fullBuilding && !roofOnly) {
        fullBuilding = params.p_f_i;
        roofOnly = params.p_r_o;
     }

    if (fullBuilding) {
        closedSideWalls = const_var.wallsData[leanType].closedSideWalls;
        sideWallsCount = storage ? closedSideWalls - 2 : closedSideWalls;
        if (Object.keys(const_var.wallsData[leanType]).length>0) {
            roofCost = compareInsulation.roof_insulation_cost != undefined ? parseFloat(compareInsulation.roof_insulation_cost) : 0 ;
            endWallsCost = compareInsulation.end_cost != undefined ? (parseFloat(compareInsulation.end_cost) * parseFloat(const_var.wallsData[leanType].closedEndWalls)) : 0;
            sideWallsCost =  compareInsulation.side_cost != undefined ? (parseFloat(compareInsulation.side_cost) * parseFloat(sideWallsCount)) : 0;
            
            if(storage && compareInsulation.utility_side != undefined && compareInsulation.utility_side != 0 ) {
                sideWallsCost =  parseFloat(sideWallsCost) + (parseFloat(compareInsulation.utility_side)*2);
                if (sideWall != 'Open') sideWallsCost = parseFloat(sideWallsCost) + parseFloat(compareInsulation.side_cost) - parseFloat(compareInsulation.utility_side);
            }
            insulationPrice = parseFloat(roofCost) + parseFloat(endWallsCost) + parseFloat(sideWallsCost);
        } else {
            insulationPrice = parseFloat(compareInsulation.roof_insulation_cost);
        }
        insulation = "full";
    }
    if (roofOnly) {
      insulationPrice = parseFloat(compareInsulation.roof_insulation_cost);
      insulation = "roof_only";
    }

    return {insulation, insulationPrice};
}
export const commonFunctionForRoofandFullBuildingInsulationPrice = (data,type,insulationId,params, isCompare = false)=>
{
                // ############################## Heritage Leanto's cases ##############################
              let insulationPrice = 0;
              let editCheckForHeritage = editCaseHeritage();

              let heritageNoInsulationCaseLeftLean = false;
              let heritageNoInsulationCaseRightLean = false;
              let heritageNoInsulationCaseFrontLean = false;
              let heritageNoInsulationCaseBackLean =false
          
              // ################################# Heritage Manufacture check for Front Lean ################################
              if (params.add_front_lean) {
                  heritageNoInsulationCaseFrontLean = heritageNoInsulation(params, editCheckForHeritage, isCompare, "frontLean");
              }
          
              // ################################# Heritage Manufacture check for Back Lean ################################
              if (params.add_back_lean) {
                  heritageNoInsulationCaseBackLean = heritageNoInsulation(params, editCheckForHeritage, isCompare, "backLean");
              }
          
              // ################################# Heritage Manufacture check for Left Lean ################################
              if(params.add_left_lean) {
                  heritageNoInsulationCaseLeftLean = heritageNoInsulation(params, editCheckForHeritage,isCompare, "leftLean");
              }
          
              // ################################# Heritage Manufacture check for Right Lean ################################
              if(params.add_right_lean) {  
                  heritageNoInsulationCaseRightLean = heritageNoInsulation(params, editCheckForHeritage,isCompare, "rightLean");
                }
              let finalPrice = 0;  
              if(data.leanto==undefined && isCompare != true)
              {
                data.leanto = const_var.leanto;
              }
            //   console.log('finalPrice --',data.leanto);
                if(data.leanto!=undefined && data.leanto.length>0)
                {
                    let insArrayForFrontLeanArray = const_var.insulationArrayForLeantoFront
                    let insArrayForBackLeanArray = const_var.insulationArrayForLeantoBack
                    let insArrayForLeftLeanArray = const_var.insulationArrayForLeantoLeft
                    let insArrayForRightLeanArray = const_var.insulationArrayForLeantoRight
                    // console.log('finalPrice --',isCompare);
                    if(isCompare == true){
                        for(let i=0;i<data.leanto.length;i++){
                            // console.log('finalPrice --',isCompare,insArrayForLeftLeanArray);
                            if(data.leanto[i].leanto_type == 1){
                                // console.log('finalPrice --',insArrayForLeftLeanArray,data.leanto[i].insulation_type);
                                insArrayForLeftLeanArray = data.leanto[i].insulation_type
                            }
                            if(data.leanto[i].leanto_type == 2){
                                insArrayForRightLeanArray = data.leanto[i].insulation_type
                            }
                            if(data.leanto[i].leanto_type == 3){
                                insArrayForFrontLeanArray = data.leanto[i].insulation_type
                            }
                            if(data.leanto[i].leanto_type == 4){
                                insArrayForBackLeanArray = data.leanto[i].insulation_type
                            }
                        }
                    }
                    // console.log('finalPrice --',params.add_left_lean,heritageNoInsulationCaseLeftLean);
                    if(type=="fullBuilding")
                    {
                        // console.log('finalPrice --',insArrayForLeftLeanArray, insulationId,type);
                        if(isCompare == true){
                            if(params.add_front_lean && !heritageNoInsulationCaseFrontLean && insulationId != 0 && insArrayForFrontLeanArray != undefined){
                                
                                const insulationRes = calculateInsulation(insArrayForFrontLeanArray, params.p_f_i, params.p_r_o, 'frontLean', params.add_storage_check_front, params.p_b_c_b_f_l, params.p_b_c_b_f_f, params.p_b_c_b_f_b );
      
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice)
                            }
                            if(params.add_back_lean && !heritageNoInsulationCaseBackLean && insulationId != 0 && insArrayForBackLeanArray != undefined){
                                const insulationRes = calculateInsulation(insArrayForBackLeanArray, params.p_f_i, params.p_r_o, 'backLean', params.add_storage_check_back, params.p_b_c_b_b_l, params.p_b_c_b_b_f, params.p_b_c_b_b_b);
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice)
                            }
                            if(params.add_left_lean && !heritageNoInsulationCaseLeftLean && insulationId != 0 && insArrayForLeftLeanArray != undefined ){
                                const insulationRes = calculateInsulation(insArrayForLeftLeanArray,  params.p_f_i, params.p_r_o, 'leftLean', params.add_storage_check, params.p_b_c_b_l, params.p_b_c_b_l_f, params.p_b_c_b_l_b )
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice)
                            }
                            if(params.add_right_lean && !heritageNoInsulationCaseRightLean && insulationId != 0 && insArrayForRightLeanArray != undefined){
                                const insulationRes = calculateInsulation(insArrayForRightLeanArray,  params.p_f_i, params.p_r_o, 'rightLean', params.add_storage_check_right, params.p_b_c_b_r, params.p_b_c_b_r_f, params.p_b_c_b_r_b ); 
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice)
                            }
                        }
                        else{
                            if(params.add_front_lean && !heritageNoInsulationCaseFrontLean && insulationId != 0 && insArrayForFrontLeanArray && insArrayForFrontLeanArray[insulationId] != undefined){
                                
                                const insulationRes = calculateInsulation(insArrayForFrontLeanArray[insulationId], params.p_f_i, params.p_r_o, 'frontLean', params.add_storage_check_front, params.p_b_c_b_f_l, params.p_b_c_b_f_f, params.p_b_c_b_f_b );
      
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice)
                            }
                            if(params.add_back_lean && !heritageNoInsulationCaseBackLean && insulationId != 0 && insArrayForBackLeanArray && insArrayForBackLeanArray[insulationId] != undefined){
                                const insulationRes = calculateInsulation(insArrayForBackLeanArray[insulationId], params.p_f_i, params.p_r_o, 'backLean', params.add_storage_check_back, params.p_b_c_b_b_l, params.p_b_c_b_b_f, params.p_b_c_b_b_b);
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice)
                            }
                            if(params.add_left_lean && !heritageNoInsulationCaseLeftLean && insArrayForLeftLeanArray && insulationId != 0 && insArrayForLeftLeanArray[insulationId] != undefined ){
                                const insulationRes = calculateInsulation(insArrayForLeftLeanArray[insulationId],  params.p_f_i, params.p_r_o, 'leftLean', params.add_storage_check, params.p_b_c_b_l, params.p_b_c_b_l_f, params.p_b_c_b_l_b )
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice)
                            }
                            if(params.add_right_lean && !heritageNoInsulationCaseRightLean && insulationId != 0 && insArrayForRightLeanArray && insArrayForRightLeanArray[insulationId] != undefined){
                                const insulationRes = calculateInsulation(insArrayForRightLeanArray[insulationId],  params.p_f_i, params.p_r_o, 'rightLean', params.add_storage_check_right, params.p_b_c_b_r, params.p_b_c_b_r_f, params.p_b_c_b_r_b ); 
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationRes.insulationPrice)
                            }
                        }
                    }if(type=="roofOnly")
                    {
                        if(isCompare == true){
                            if(params.add_front_lean && !heritageNoInsulationCaseFrontLean && insulationId != 0 && insArrayForFrontLeanArray != undefined){
                                // let insulationPriceLeanObj = (const_var.leanGetDataFront.insulation.filter(data=>data.insulation_id==insulationId ));
                                // insulationPriceLeanObj = insulationPriceLeanObj[0]
                                finalPrice = parseFloat(finalPrice) + parseFloat(insArrayForFrontLeanArray.roof_insulation_cost)
                            }
                            if(params.add_back_lean && !heritageNoInsulationCaseBackLean && insulationId != 0 && insArrayForBackLeanArray != undefined){
                                // let insulationPriceLeanObj = (const_var.leanGetDataBack.insulation.filter(data=>data.insulation_id==insulationId ));
                                // insulationPriceLeanObj = insulationPriceLeanObj[0]
                                finalPrice = parseFloat(finalPrice) + parseFloat(insArrayForBackLeanArray.roof_insulation_cost)
                            }
                            if(params.add_left_lean && !heritageNoInsulationCaseLeftLean && insArrayForLeftLeanArray != undefined ){
                                // let insulationPriceLeanObj = (const_var.leanGetDataLeft.insulation.filter(data=>data.insulation_id==insulationId ));
                                // insulationPriceLeanObj = insulationPriceLeanObj[0]
                                finalPrice = parseFloat(finalPrice) + parseFloat(insArrayForLeftLeanArray.roof_insulation_cost)
                            }
                            if(params.add_right_lean && !heritageNoInsulationCaseRightLean && insulationId != 0 && insArrayForRightLeanArray != undefined){
                                // let insulationPriceLeanObj = (const_var.leanGetDataRight.insulation.filter(data=>data.insulation_id==insulationId ));
                                // insulationPriceLeanObj = insulationPriceLeanObj[0];
                                finalPrice = parseFloat(finalPrice) + parseFloat(insArrayForRightLeanArray.roof_insulation_cost)
                                
                            }
                        }
                        else{
                            if(params.add_front_lean && !heritageNoInsulationCaseFrontLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront[params.p_i_o] != undefined){
                                let insulationPriceLeanObj = (const_var.leanGetDataFront.insulation.filter(data=>data.insulation_id==params.p_i_o ));
                                insulationPriceLeanObj = insulationPriceLeanObj[0]
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
                            }
                            if(params.add_back_lean && !heritageNoInsulationCaseBackLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack[params.p_i_o] != undefined){
                                let insulationPriceLeanObj = (const_var.leanGetDataBack.insulation.filter(data=>data.insulation_id==params.p_i_o ));
                                insulationPriceLeanObj = insulationPriceLeanObj[0]
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
                            }
                            if(params.add_left_lean && !heritageNoInsulationCaseLeftLean && const_var.insulationArrayForLeantoLeft && params.p_i_o != 0 && const_var.insulationArrayForLeantoLeft[params.p_i_o] != undefined ){
                                let insulationPriceLeanObj = (const_var.leanGetDataLeft.insulation.filter(data=>data.insulation_id==params.p_i_o ));
                                insulationPriceLeanObj = insulationPriceLeanObj[0]
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
                            }
                            if(params.add_right_lean && !heritageNoInsulationCaseRightLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight[params.p_i_o] != undefined){
                                let insulationPriceLeanObj = (const_var.leanGetDataRight.insulation.filter(data=>data.insulation_id==params.p_i_o ));
                                insulationPriceLeanObj = insulationPriceLeanObj[0];
                                finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
                                
                            }
                        }
                    }
                }
                // console.log(finalPrice,"finalPricefinalPricefinalPricefinalPrice")
                return finalPrice;
}

export const calculateInsulation = (buildingInsulation, fullBuilding, roofOnly, leanType, storage, sideWall, frontWall, backWall) => {
    let insulation = "roof_only", insulationPrice = 0, roofCost = 0, endWallsCost = 0, sideWallsCost = 0, sideWallsCount = 0 , closedSideWalls = 0;
     if (const_var.isInsulaltionForOldQuotes && !fullBuilding && !roofOnly) {
        fullBuilding = params.p_f_i;
        roofOnly = params.p_r_o;
     }

    if (fullBuilding) {
        closedSideWalls = const_var.wallsData[leanType].fullclosedSideWalls;
        sideWallsCount = storage ? closedSideWalls - 2 : closedSideWalls;
        sideWallsCount = Math.abs(sideWallsCount)
        // console.log('sideWallsCount',storage,sideWallsCount,closedSideWalls);
        // console.log('sideWallsCount',const_var.wallsData[leanType]);
        if (buildingInsulation.end_cost != undefined && Object.keys(const_var.wallsData[leanType]).length>0) {
            roofCost = buildingInsulation.roof_insulation_cost != undefined ? parseFloat(buildingInsulation.roof_insulation_cost) : 0 ;
            endWallsCost = buildingInsulation.end_cost != undefined ? (parseFloat(buildingInsulation.end_cost) * parseFloat(const_var.wallsData[leanType].fullclosedEndWalls)) : 0;
            if(sideWall != 'Close'){
                sideWallsCost =  buildingInsulation.utility_side != undefined ? (parseFloat(buildingInsulation.utility_side) * parseFloat(sideWallsCount)) : 0;
            }
            else{
                sideWallsCost =  buildingInsulation.side_cost != undefined ? (parseFloat(buildingInsulation.side_cost) * parseFloat(sideWallsCount)) : 0;
            }
            // console.log('sideWallsCost',sideWallsCost,endWallsCost,roofCost);
            //     if(storage && buildingInsulation.utility_side != undefined && buildingInsulation.utility_side != 0 ) {
            //         sideWallsCost =  parseFloat(sideWallsCost) + (parseFloat(buildingInsulation.utility_side)*2);
            //         console.log('sideWallsCost',sideWallsCost);
            //         if (sideWall != 'Open') sideWallsCost = parseFloat(sideWallsCost) + parseFloat(buildingInsulation.side_cost) - parseFloat(buildingInsulation.utility_side);
            //     }
            if(storage && buildingInsulation.utility_opposite_side_cost != undefined && buildingInsulation.utility_opposite_side_cost != 0 ) {
                sideWallsCost =  parseFloat(sideWallsCost) + (parseFloat(buildingInsulation.utility_opposite_side_cost));
                // console.log('sideWallsCost',sideWallsCost);
                // if (sideWall != 'Open') sideWallsCost = parseFloat(sideWallsCost) + parseFloat(buildingInsulation.side_cost) - parseFloat(buildingInsulation.utility_side);
            }
            // console.log('sideWallsCost',storage);
            insulationPrice = parseFloat(roofCost) + parseFloat(endWallsCost) + parseFloat(sideWallsCost);
           // const_var.UpdatedPriceData.insulation_price_changed=true;
        
        } else {
            
            if(storage || (frontWall!= "Open" || backWall != "Open" || sideWall != "Open")){
                insulationPrice = parseFloat(buildingInsulation.full_building_insulation_cost);
            } else {
                insulationPrice = parseFloat(buildingInsulation.roof_insulation_cost);
            }
        }
        insulation = "full";
    }
    if (roofOnly) {
      insulationPrice = parseFloat(buildingInsulation.roof_insulation_cost);
      insulation = "roof_only";
      
    }
    // const_var.UpdatedPriceData.insulation_price = undefined;
    // const_var.UpdatedPriceData.insulation_price_changed=true;
    return {insulation, insulationPrice};
}
export const fourFeetOnCenterPriceWithExtraBowsPriceForCompare = (pricingData, doubleLegs, legstype, distanceOnCenter, name ) => {
    let extraBowsPrice =0, eqiDis = 0;
    if (pricingData.extra_items != undefined && pricingData.extra_items[0].checkbox_quantity != undefined && pricingData.extra_items[0].checkbox_quantity.length > 0 ){
        let extrabow = pricingData.extra_items[0].checkbox_quantity.find( cbq => cbq.name == "bows");
        const length =  parseFloat(const_var.lengthData[name].length) + parseFloat(const_var.lengthData[name].porchLength);
        if (extrabow) {
            eqiDis = (params.oncenter_val_with_action!='')?((length)/parseInt(params.oncenter_val_with_action)).toFixed(0):((length)/parseInt(distanceOnCenter)).toFixed(0);
            eqiDis = parseFloat(eqiDis) +1;

            const numberOfLegs = Math.abs(const_var.count_numberofLegs - eqiDis);
            if (doubleLegs &&  legstype.includes("double") && extrabow.double_leg != undefined && extrabow.double_leg !=0) {
                extraBowsPrice = parseFloat(extrabow.double_leg) * numberOfLegs;
            } else if (doubleLegs &&  legstype.includes("ladder") && extrabow.ladder_leg != undefined && extrabow.ladder_leg != 0) {
                extraBowsPrice = parseFloat(extrabow.ladder_leg) * numberOfLegs;
            } else {
                extraBowsPrice = parseFloat(extrabow.cost) * numberOfLegs;
            }
        }

    }

    return extraBowsPrice;
}

export const updateFourFeetOnCenterPriceWithExtraBowsOnLeanRemoval = () => {
    if (params.fourth_center_cost && const_var.ExtraItemsFeaturesArray.length > 0) {
        const_var.a_p_d_a.extra_items[0].checkbox.map((val, index) => {
          const_var.ExtraItemsFeaturesArray.map(item => {
                if (item != null && item.label == val.label && item.name == "fourth_center_cost") {
                    item.cost = params.isDefaultfourFeet ? item.cost : val.cost;
                }
            });
        })
        calculateLegsCount();
    }  
}
export const calculateFourthCenterCostwithExtraBows = ()=>{
  if(params.p_e_i=='other' || params.p_e_i=="Select" || params.p_e_i=="")return;
  let exactNum = 0;
  if((const_var.a_p_d_a.extra_items) && const_var.a_p_d_a.extra_items.length>0 && const_var.a_p_d_a.extra_items[0].checkbox!=undefined)
  {
      let eqiDis = 0;
      if(params.fourth_center_cost == true){
      if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
      {
          eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
      }
      } else {
          if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
          {
              eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0)
          }
      }
      let dataNew = JSON.parse(JSON.stringify(const_var.a_p_d_a.extra_items[0].checkbox));
      dataNew.map((val, index)=> {
          if(val.name == "fourth_center_cost" || val.label == "4ft on Center")
          {
              if(params.fourth_center_cost==true)
              {
                  const_var.ExtraItemsFeaturesArray[index] = val;
                  const_var.ExtraItemsFeaturesArray[index].quantity = 1;
                  const_var.ExtraItemsFeaturesArray[index].is_checked = (params.fourth_center_cost==true)?true:false;
                  const_var.ExtraItemsFeaturesArray[index].cost = 0;
                  if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                      const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                      const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = 0;
                  }
              }else{
                  if(const_var.ExtraItemsFeaturesArray!=undefined && const_var.ExtraItemsFeaturesArray[index]!=undefined)
                  {
                      const_var.ExtraItemsFeaturesArray[index].cost = val.cost;
                      const_var.ExtraItemsFeaturesArray[index] = val;
                      const_var.ExtraItemsFeaturesArray[index].is_checked = false;
                      const_var.ExtraItemsFeaturesArray[index].quantity = 1;
                      if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                          const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                          const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = val.cost;
                      }
                  }
              }
              if(const_var.ExtraItemsFeaturesArray[index]!=undefined && const_var.ExtraItemsFeaturesArray[index].cost==0 && params.fourth_center_cost)
              {
                  let checkCost = '';
                  if(const_var.a_p_d_a.extra_items!=undefined && const_var.a_p_d_a.extra_items[0].checkbox_quantity!=undefined)
                  {
                      let dataNew = JSON.parse(JSON.stringify(const_var.a_p_d_a.extra_items[0].checkbox_quantity));
                      dataNew.map((val, index)=> {
                      if(val.name=="bows")
                      {
                          if(val.cost!=0 || val.double_leg!=0 || val.ladder_leg!=0)
                          {
                              exactNum = Math.abs(const_var.count_numberofLegs - eqiDis);
                              let price = (params.p_e_l && const_var.legstype.includes("double") && val.double_leg != 0)?parseFloat(val.double_leg):(params.p_e_l && const_var.legstype.includes("ladder") && val.ladder_leg != 0 )?parseFloat(val.ladder_leg):parseFloat(val.cost);
                              
                              if(const_var.ExtraItemsFeaturesArray[index]!=undefined)
                              {
                                  const_var.ExtraItemsFeaturesArray[index].cost = const_var.ExtraItemsFeaturesArray[index].cost==0?parseFloat(price * exactNum):const_var.ExtraItemsFeaturesArray[index].cost;
                                 
                                  if(params.fourth_center_cost && const_var.defaultDistanceOnCenter==4)
                                  {
                                      const_var.ExtraItemsFeaturesArray[index].cost = 0;
                                  }
                                  if(params.fourth_center_cost && const_var.c_f_aCer[params.p_e_i].distance_on_center==4)
                                  {
                                      const_var.ExtraItemsFeaturesArray[index].cost = 0;
                                  }
                              }
                                if(val.name == "bows")
                                {
                                    if(params.fourth_center_cost==true)
                                    {
                                        const_var.ExtraItemsFeaturesQuantityArray[index] = val;
                                        //params.isDefaultfourFeet = false;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].quantity = 1;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_checked = (params.fourth_center_cost==true)?true:false;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].cost = 0;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].double_leg = 0;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].ladder_leg = 0;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_edit = false;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_disabled = true;
                                        if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                            const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                            const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = 0;
                                        }
                                    }else{
                                        const_var.ExtraItemsFeaturesQuantityArray[index].cost = val.cost;
                                        const_var.ExtraItemsFeaturesQuantityArray[index] = val;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_checked = false;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].quantity = 1;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_edit = false;
                                        const_var.ExtraItemsFeaturesQuantityArray[index].is_disabled = true;
                                        if (const_var.UpdatedPriceData['elements']!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()]!=undefined && const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit!= undefined){
                                            const_var.UpdatedPriceData['elements'][val.label.toString()].is_edit = false;
                                            const_var.UpdatedPriceData['elements'][val.label.toString()].item_price = val.cost;
                                        }
                                        
                                    }
                                }
                                 
                          }
                      }
                  })
                  }
              }else{
                  if(const_var.ExtraItemsFeaturesQuantityArray.length>0)
                  {
                      let FilterIndex = const_var.ExtraItemsFeaturesQuantityArray.findIndex(data=> data && data.name=="bows" && data.is_disabled!=undefined);
                       if (FilterIndex >= 0){
                          const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_checked = false;
                          const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].quantity = 1;
                          const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_edit = false;
                          const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_disabled = false;
                          //const_var.ExtraItemsFeaturesQuantityArray.splice(FilterIndex,1);
                      }
                  }
                  
              }

          }
      })
      
      if(params.fourth_center_cost && const_var.c_f_aCer[params.p_e_i].distance_on_center==4 && params.isDefaultfourFeet==true && const_var.defaultDistanceOnCenter==4) 
      {
          if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
          if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
          if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
          if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
      }
      if(params.fourth_center_cost && const_var.c_f_aCer[params.p_e_i].distance_on_center!=4)
      {
          if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront,'frontLean');
          if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft,'leftLean');
          if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight,'rightLean');
          if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack,'backLean'); 
      }
      if(params.fourth_center_cost && const_var.c_f_aCer[params.p_e_i].distance_on_center==4)
      {
         let FilterIndex = const_var.ExtraItemsFeaturesArray.findIndex(data=> data.name == "fourth_center_cost" || data.label == "4ft on Center");
          if(params.isDefaultfourFeet!=true && FilterIndex >= 0)
          {
              if(const_var.ExtraItemsFeaturesArray[FilterIndex].is_checked == true)
              {
              if(params.add_front_lean)
              {
                  if(const_var.leanGetDataFront!=undefined)
                  {
                      if(const_var.leanGetDataFront.building_structure.distance_on_center!=4)
                      {
                          calculateLegsCount(const_var.leanGetDataFront,'frontLean')
                      }
                  }
              }if(params.add_left_lean)
              {
                  if(const_var.leanGetDataLeft!=undefined)
                  {
                      if(const_var.leanGetDataLeft.building_structure.distance_on_center!=4)
                      {
                          calculateLegsCount(const_var.leanGetDataLeft,'leftLean')
                      }
                  }
              }if(params.add_right_lean)
              {
                  if(const_var.leanGetDataRight!=undefined)
                  {
                      if(const_var.leanGetDataRight.building_structure.distance_on_center!=4)
                      {
                          calculateLegsCount(const_var.leanGetDataRight,'rightLean')
                      }
                  }
              }if(params.add_back_lean)
              {
                  if(const_var.leanGetDataBack!=undefined)
                  {
                      if(const_var.leanGetDataBack.building_structure.distance_on_center!=4)
                      {
                          calculateLegsCount(const_var.leanGetDataBack,'backLean')
                      }
                  }
              }
          }
          }
      }
      
      
  }
}
export function findNearestMultipleOfFour(number) {
    let remainder = number % 4;
    let nearestMultiple = number - remainder;
  
    if (remainder > 2) {
      nearestMultiple += 4;
    }
  
    return nearestMultiple;
  }

 export function findNearestMultipleOfFive(number) {
    const remainder = number % 5;
  
    if (remainder <= 2) {
      return number - remainder;
    }
  
    return number + (5 - remainder);
  }


  export const updateWalkinWindowlegCutPrice = (uniqueId) => {
    let doorAPIPrice, isPriceChanged = false, onVerticalSideCost, onSideCost;
    const_var.entry_points.map(_door => {
        if (_door.uniqueId == uniqueId && _door.entry_doorNewType == undefined) {
             doorAPIPrice = (const_var.newComponentArray[_door.parent_array_key][_door.child_array_key]!=undefined && const_var.newComponentArray[_door.parent_array_key][_door.child_array_key][_door.nested_array_key]!=undefined && const_var.newComponentArray[_door.parent_array_key][_door.child_array_key][_door.nested_array_key]["Size"][_door.name]!=undefined)?const_var.newComponentArray[_door.parent_array_key][_door.child_array_key][_door.nested_array_key]["Size"][_door.name]:undefined;
            if(_door.cutLegCount != undefined && _door.cutLegCount != 0){
                params.legCutFee = true
            }
            else{
                params.legCutFee = false
            }
             if (doorAPIPrice){
                    onSideCost = _door.is_price_updated ? _door.entry_price : doorAPIPrice.on_side_cost != undefined ? (parseFloat(doorAPIPrice.on_side_cost) + parseFloat(doorAPIPrice.cost)) :  doorAPIPrice.cost;
                    onVerticalSideCost = _door.is_price_updated ? _door.entry_price : doorAPIPrice.vertical_side_cost != undefined ? (doorAPIPrice.vertical_side_cost == 0 ? parseFloat(doorAPIPrice.on_side_cost) + parseFloat(doorAPIPrice.cost) : parseFloat(doorAPIPrice.vertical_side_cost) + parseFloat(doorAPIPrice.cost)) :  doorAPIPrice.cost;
                    const checkPrice = params.p_v_w ? onVerticalSideCost : onSideCost;

                    // if(const_var.crmSetting.is_Edit != true){
                        if (params.legCutFee && _door.entry_price != checkPrice) {
                            _door.entry_price =  params.p_v_w ? onVerticalSideCost : onSideCost;
                            isPriceChanged = true;
                        } 
                        if (!params.legCutFee && parseFloat(_door.entry_price) !== parseFloat(doorAPIPrice.cost)){
                            _door.entry_price = _door.is_price_updated ? _door.entry_price : (doorAPIPrice.cost != undefined ? doorAPIPrice.cost : _door.entry_price);
                            isPriceChanged = true;
                        }
                    // }

                }


            }
        });
        if(const_var.legCutFlag!=undefined && const_var.legCutFlag ==true){
            setTimeout(() => {
               cuBuilding.cP();
            }, 2000);
        };
    return isPriceChanged;
}

export const onForceLeantoRemoval = () => {
    if(params.p_w_c_n){
        if((params.p_f_w=="Close" || params.p_b_w=="Close" || params.p_l_w=="Close" || params.p_r_w=="Close" || params.p_u_c || params.cB_addStorage_check_left || params.cB_addStorage_check_right)
        || (params.p_b_c_b_l_f=="Close" || params.p_b_c_b_l=="Close" || params.p_b_c_b_l_b=="Close" || params.add_storage_check) 
        || (params.p_b_c_b_r_f=="Close" || params.p_b_c_b_r=="Close" || params.p_b_c_b_r_b=="Close" || params.add_storage_check_right)
        || (params.p_b_c_b_f_f=="Close" || params.p_b_c_b_f_b=="Close" || params.p_b_c_b_f_l=="Close" || params.add_storage_check_front)
        || (params.p_b_c_b_b_f=="Close" || params.p_b_c_b_b_b=="Close" || params.p_b_c_b_b_l=="Close" || params.add_storage_check_back)
        || (params.p_f_w=="Half Dutch End" || params.p_f_w=="Half End" || params.p_b_w=="Half Dutch End" || params.p_b_w=="Half End")
        || (params.p_b_c_b_l_f=="Half Dutch End" || params.p_b_c_b_l_f=="Half End" || params.p_b_c_b_l_b=="Half Dutch End" || params.p_b_c_b_l_b=="Half End")
        || (params.p_b_c_b_b_f=="Half Dutch End" || params.p_b_c_b_b_f=="Half End" || params.p_b_c_b_b_b=="Half Dutch End" || params.p_b_c_b_b_b=="Half End")
        || (params.p_b_c_b_f_f=="Half Dutch End" || params.p_b_c_b_f_f=="Half End" || params.p_b_c_b_f_b=="Half Dutch End" || params.p_b_c_b_f_b=="Half End")
        || (params.p_b_c_b_r_f=="Half Dutch End" || params.p_b_c_b_r_f=="Half End" || params.p_b_c_b_r_b=="Half Dutch End" || params.p_b_c_b_r_b=="Half End")
        ){
            const_var.showWainscotJSX = true;
        } else {
            const_var.showWainscotJSX = false;
            params.p_w_c_n = false;
        }
    }
}

export const createTexture = (geometry,repeatX,repeatY,image) =>{
    let geometryLoader = new THREE.TextureLoader();
    let geometryTexture = geometryLoader.load( process.env.REACT_APP_BASE_URL+image, function(texture1) {
    geometryTexture.anisotropy = Math.min(const_var.renderer.capabilities.getMaxAnisotropy(), 5);
    // geometry.material.color.set(0xFFFFFF)
    geometry.material.map = texture1;
    geometry.material.bumpMap = texture1;
    geometry.material.bumpScale = 0.02
    geometry.material.metalness = 1
    geometry.material.roughness = 0.5
    geometry.material.anisotropy = 10;
    geometry.material.emissiveMap = texture1;
    geometry.material.emissiveIntensity = 1;
    geometry.material.map.wrapS = THREE.RepeatWrapping;
    geometry.material.map.wrapT = THREE.RepeatWrapping; 
    geometry.material.map.rotation = Math.PI
    geometry.material.map.offset.x = 0.981
    // if (params.p_v_w==true) {
    //     // geometry.material.map.repeat.set((2*Math.round((((repeatX/2)+(repeatX/2/3))*2)/2))/repeatX,0.01);
    //     geometry.material.map.repeat.set(1.34,1.34);
    // } else {
    //     // geometry.material.map.repeat.set(0.01,(Math.round((repeatY/1.5)*2)/(repeatY)));
    //     geometry.material.map.repeat.set(1.34,1.34);
    // }
    geometry.material.map.repeat.set(1.2735,1.34);
    geometry.material.needsUpdate = true

    });
}


export const wallHeightCalculation = (wallValue,totalHeight,direction) =>{
    let wall_hight = 0
    let hdfp = totalHeight - (Math.abs(String(wallValue).replace(/\D/g, "")) * 3)
    switch(wallValue)
    {
        case "Extended Gable":
            wall_hight = totalHeight - 3;
            break;
        case "Gable":
            wall_hight = totalHeight - 0.15;
            break;
        case "One_Fourth_Close":
            wall_hight = totalHeight * 3/4;
            break;
        case "Three_Fourth_Close":
            wall_hight = totalHeight/4;
            break;
        case "Half_Close":
            wall_hight = totalHeight/2;
            break;   
        case "Open":
            wall_hight = totalHeight;
            break;               
        case "Close":
            wall_hight = 0;
            break;
        case "Half End":
            wall_hight = 0;
            break;
        case "Half Dutch End":
            wall_hight = 0;
            break;
        default:
            // panel Height
            wall_hight = totalHeight - (Math.abs(String(Math.round(wallValue)).replace(/\D/g, "")) * 3)
            switch(direction)
            {
                case "right":
                    hdfp = params.p_h - (params.leanR_p_h + (parseInt(params.b_l_t_r_pR)/12) * params.leanR_p_w);
                    if(params.leanStyle.right == "gable") hdfp = params.p_h - (params.leanR_p_h + (parseInt(params.b_l_t_r_pR)/12) * params.leanR_p_w/2);
                    // let additionalHeightR = ((params.leanR_p_d == params.p_d) || (params.leantoAlignmentRight == "2")) ? 0.22 : 0;
                    if(params.add_right_lean && hdfp > 0  &&  (Math.abs(params.p_r_w) * 3) -hdfp < 3){
                        //wall_hight = totalHeight - hdfp - additionalHeightR;
                        wall_hight = totalHeight - hdfp - 0.22 /*- additionalHeightR */
                    }
                    break;
                case "left":
                    hdfp = params.p_h - (params.lean_p_h + (parseInt(params.b_l_t_r_p)/12) * params.lean_p_w);
                    if(params.leanStyle.left == "gable") hdfp = params.p_h - (params.lean_p_h + (parseInt(params.b_l_t_r_p)/12) * params.lean_p_w/2);
                    // let additionalHeightL = ((params.lean_p_d == params.p_d) || (params.leantoAlignmentLeft == "2")) ? 0.22 : 0;
                    if(params.add_left_lean && hdfp > 0 &&  (Math.abs(params.p_l_w) * 3) -hdfp < 3){
                        //wall_hight = totalHeight - hdfp - additionalHeightL
                        wall_hight = totalHeight - hdfp - 0.22/* - additionalHeightL */
                    }
                    break;
                default:
                    // panel Height
                    wall_hight = totalHeight - (Math.abs(String(wallValue).replace(/\D/g, "")) * 3)
                    break;
            }
            
        break;
    }
    // let showCenterBuildingTrimH = (params.isShowCenter) ? 0 : 0.22;
    if(direction == "front" && ((params.add_front_lean ==true && Object.values(const_var.wallArray["front"])[0] == params.p_f_w )|| (params.add_front_lean ==true && params.p_f_w == "Open")))
    {
        hdfp = params.p_h - (params.leanF_p_h + (parseInt(params.b_l_t_r_pF)/12) * params.leanF_p_w);
        wall_hight = totalHeight - hdfp - 0.22;
        // wall_hight = totalHeight - hdfp - showCenterBuildingTrimH
    }

    if(direction == "back" && ((params.add_back_lean && Object.values(const_var.wallArray["back"])[0] == params.p_b_w) || (params.add_back_lean ==true && params.p_b_w == "Open")))
    {
        hdfp = params.p_h - (params.leanB_p_h + (parseInt(params.b_l_t_r_pB)/12) * params.leanB_p_w);
        wall_hight = totalHeight - hdfp - 0.22;
        // wall_hight = totalHeight - hdfp - showCenterBuildingTrimH
    }

    if(params.p_c_p_l && direction == "left" && wall_hight - 1.5 >= 0){
        wall_hight = wall_hight - 1.5
    }
    if(params.p_c_p_r && direction == "right" && wall_hight - 1.5 >= 0){
        wall_hight = wall_hight - 1.5
    }
    

    return wall_hight
}

export const updateFunctionsOnLeantoRemoval = (leanType) => {
  if (leanType == "frontLean") {
    params.add_front_lean = params.add_storage_check_front = false;
    const_var.leanFHasDoublelegshow = params.leanF_p_e_l = false;
    params.insulation.frontLean = {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,}
    params.isShowCenter = false;
    params.leanF_p_d = 21;
    params.leanF_p_h = const_var.b_m_i_hlean;
    params.b_l_t_r_pF = "2";
    params.p_b_c_b_f_f = params.p_b_c_b_f_b = params.p_b_c_b_f_l = "Open";
    if (params.add_left_front_lean_porch || params.add_right_front_lean_porch ){
        if(params.add_left_front_lean_porch) {
            params.add_left_front_lean_porch = false;
            // cuBuilding.UpdateLeftLean();
        }
        if(params.add_right_front_lean_porch) {
            params.add_right_front_lean_porch = false;
            // cuBuilding.UpdateRightLean(); 
        }
        // cuBuilding.UpdateLeanPorches();
    }
    // cuBuilding.UpdateFrontLean();
    cuBuilding.removeDataFromArray(3);
  }
  if (leanType == "backLean") {
    params.add_back_lean = params.add_storage_check_back = false;
    const_var.leanBHasDoublelegshow = params.leanB_p_e_l = false;
    params.insulation.backLean = {showInsulation :false, isCheked:false, insulationId:0, roofOnly:false, fullBuilding:false, showInsulationOptions:false, isDisableFullInsulation:false,}
    params.isShowCenter = false;
    params.leanB_p_d = 21;
    params.leanB_p_h = const_var.b_m_i_hlean;
    params.b_l_t_r_pB = "2";
    params.p_b_c_b_b_f = params.p_b_c_b_b_b = params.p_b_c_b_b_l = "Open";
    if (params.add_left_back_lean_porch || params.add_right_back_lean_porch ){
        if(params.add_left_back_lean_porch){
            params.add_left_back_lean_porch = false;
            // cuBuilding.UpdateLeftLean();
        } 
        if(params.add_right_back_lean_porch) {
            params.add_right_back_lean_porch = false;
            // cuBuilding.UpdateRightLean();
        }
        // cuBuilding.UpdateLeanPorches();
    }
    // cuBuilding.UpdateBackLean();
    cuBuilding.removeDataFromArray(3);
 }

 onForceLeantoRemoval()
 cuBuilding.cP();
}

export const updateCenterBuildingPricesOnLeanAPICalls = (state, leanType, mainType) => {
    if ( (leanType == "leanGetDataLeft" || leanType == "leanGetDataRight") && const_var[leanType] != undefined && const_var[leanType].central_panel != undefined && const_var[leanType].central_panel.length > 0) {
        const_var.a_p_d_a.panel = const_var[leanType].central_panel;
        if (const_var.checkPanelForLean.left && leanType == "leanGetDataLeft") const_var.UpdatedPriceData.left_wall_price_changed = true;
        if (const_var.checkPanelForLean.right && leanType == "leanGetDataRight") const_var.UpdatedPriceData.right_wall_price_changed = true;
    }
    if (const_var[leanType] != undefined && const_var[leanType].central_building_structure != undefined && const_var[leanType].central_building_structure.length > 0) {
        const_var.a_p_d_a.building_structure = const_var[leanType].central_building_structure;
        if(const_var.a_p_d_a.building_structure[0].conditions!=undefined && const_var.a_p_d_a.building_structure[0].conditions['condition']!=undefined)
        {
          let checkCenterLeg = const_var.a_p_d_a.building_structure[0].conditions['condition'].find((s)=> s.legs_type == const_var.legstype)
              if(checkCenterLeg == undefined){
                      let reinforeced = const_var.a_p_d_a.building_structure[0].conditions['condition'].find((data)=>data.legs_type == "Single" || data.legs_type == "single")
                      if(reinforeced!=undefined){
                          reinforeced.legs_type = 'reinforced';
                      }
                  checkLegsDataAccordingtoResponse(const_var.ConditionArr[params.p_b_t][params.p_r_s]);
              }
          checkReinforcedLeg(const_var.ConditionArr[params.p_b_t][params.p_r_s])
          cuBuilding.CheckLegsByResponse(state);
        }
    }
}

export function zigZagLegs (width, length, height, leftGroup, rightGroup, eqiDis, leftLegsForCut, rightLegsForCut) {
    // console.log({width, length, height, leftGroup, rightGroup, eqiDis, leftLegsForCut, rightLegsForCut});
    for (let i = 0; i < height; i = i+2) {
        for (let e = length/2 -0.12, j = 0; e > (length/-2 )-1; e = e - (length / eqiDis ), j++) {
            if( e < length / -2 + 0.12 ) e = (length /-2) + 0.12;
            if(e >= (length/2) - 2) e = (length/2)-0.12;

            if (leftGroup != undefined){
                if (i>1){
                    const leftTopZigZagConnector = const_var.b_t_M_L.getObjectByName("zigZagConnector").clone();
                    leftTopZigZagConnector.name = `${leftLegsForCut}${"TopZigZagConnector"}${j}${'x'}${i}`;
                    leftTopZigZagConnector.material = leftTopZigZagConnector.material.clone();
                    leftTopZigZagConnector.scale.set(1.35,0.2,0.3);
                    leftTopZigZagConnector.position.set(width/-2+0.54,i-0.3,e);
                    leftTopZigZagConnector.rotation.z = Math.PI/-3.4;
                    leftGroup.add(leftTopZigZagConnector);
                    const_var.legsForCut[leftLegsForCut][leftTopZigZagConnector.name] = leftTopZigZagConnector;
                }
                
                const leftBottomZigZagConnector = const_var.b_t_M_L.getObjectByName("zigZagConnector").clone();
                leftBottomZigZagConnector.name = `${leftLegsForCut}${"BottomZigZagConnector"}${j}${'x'}${i}`;
                leftBottomZigZagConnector.material = leftBottomZigZagConnector.material.clone();
                leftBottomZigZagConnector.scale.set(1.4,0.2,0.3);
                leftBottomZigZagConnector.position.set(width/-2+0.54,i+0.7,e);
                leftBottomZigZagConnector.rotation.z = Math.PI/3.4;
                if (i < height - 2) {
                    leftGroup.add(leftBottomZigZagConnector);   
                    const_var.legsForCut[leftLegsForCut][leftBottomZigZagConnector.name] = leftBottomZigZagConnector;
                }
                
                if (i == 0){
                    const leftBaseRailLegConnector = const_var.b_t_M_L.getObjectByName("legConnector").clone();
                    leftBaseRailLegConnector.name = `${leftLegsForCut}${"BaseRailLegConnector"}${j}${'x'}${i}`;
                    leftBaseRailLegConnector.material = leftBaseRailLegConnector.material.clone();
                    leftBaseRailLegConnector.scale.set(0.97,0.2,0.3);
                    leftBaseRailLegConnector.position.set(width/-2+0.5,i+0.08,e);
                    leftGroup.add(leftBaseRailLegConnector);
                    const_var.legsForCut[leftLegsForCut][leftBaseRailLegConnector.name] = leftBaseRailLegConnector;
                }
            }

            if (rightGroup != undefined){
                if (i>1){
                    const rightTopZigZagConnector = const_var.b_t_M_L.getObjectByName("zigZagConnector").clone();
                    rightTopZigZagConnector.name = `${rightLegsForCut}${"TopZigZagConnector"}${j}${'x'}${i}`;
                    rightTopZigZagConnector.material = rightTopZigZagConnector.material.clone();
                    rightTopZigZagConnector.scale.set(1.35,0.2,0.3);
                    rightTopZigZagConnector.position.set(width/2-0.54,i-0.3,e);
                    rightTopZigZagConnector.rotation.z = Math.PI/3.4;
                    rightGroup.add(rightTopZigZagConnector);
                    const_var.legsForCut[rightLegsForCut][rightTopZigZagConnector.name] = rightTopZigZagConnector;
                }

                const rightBottomZigZagConnector = const_var.b_t_M_L.getObjectByName("zigZagConnector").clone();
                rightBottomZigZagConnector.name = `${rightLegsForCut}${"BottomZigZagConnector"}${j}${'x'}${i}`;
                rightBottomZigZagConnector.material = rightBottomZigZagConnector.material.clone();
                rightBottomZigZagConnector.scale.set(1.4,0.2,0.3);
                rightBottomZigZagConnector.position.set(width/2-0.54,i+0.7,e);
                rightBottomZigZagConnector.rotation.z = Math.PI/-3.4;
                if (i < height - 2) {
                    rightGroup.add(rightBottomZigZagConnector);   
                    const_var.legsForCut[rightLegsForCut][rightBottomZigZagConnector.name] = rightBottomZigZagConnector;
                } 
                
                if (i == 0){
                    const rightBaseRailLegConnector = const_var.b_t_M_L.getObjectByName("legConnector").clone();
                    rightBaseRailLegConnector.name = `${rightLegsForCut}${"BaseRailLegConnector"}${j}${'x'}${i}`;
                    rightBaseRailLegConnector.material = rightBaseRailLegConnector.material.clone();
                    rightBaseRailLegConnector.scale.set(0.97,0.2,0.3);
                    rightBaseRailLegConnector.position.set(width/2-0.5,i+0.08,e);
                    rightGroup.add(rightBaseRailLegConnector);
                    const_var.legsForCut[rightLegsForCut][rightBaseRailLegConnector.name] = rightBaseRailLegConnector;
                }
            }
        }
    }
  
}

export const commonFunctionForInsulationCalculations = (price)=>{
    if(const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n]!=undefined && const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n].length>0)
        {
            for(var i=0;i<const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n].length;i++)
            {
                if(const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n][i].category!=undefined || const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n][i].category!=null && const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n][i].category == params.selectedInsulationId)
                { 
                   
                    if(const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n][i].component=="insulation")
                    {
                        if(params.selectedInsulationId!=0)
                        {
                            if(const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n][i].category!=undefined || const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n][i].category!=null)
                            {
                                if(params.selectedInsulationId == const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n][i].category)
                                {
                                    if(price>= parseInt(const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n][i].from) && price <=parseInt(const_var.stateManufacturerAcordingAPIDiscount['commissions'][params.m_s_n][i].to) )
                                    {
                                        const_var.UpdatedPriceData.custom_insulation_down_payment_rate = undefined;
                                        return true;
                                    }
                                }
                            }
                            
                        }
                    }
                }
                
            }
        }
}
export const checkAdditionalFeaturesValue = (val)=>{
    let splitVal = "";
    if(val.percentage_of!=undefined && val.percentage_of!="")
    {
        splitVal =val.percentage_of.split(",");
    }else
    {
        splitVal =val.percentage_of.split(",");
    }
    let CHKCalculation = {width:false,length:false,height:false};
    
    if(splitVal.includes("5")!=false)
    {
        CHKCalculation.width = true;
    }
    if(splitVal.includes("7")!=false)
    {
        CHKCalculation.length = true;
    }
    if(splitVal.includes("6")!=false)
    {
        CHKCalculation.height = true;
    }
    return CHKCalculation;
}
export const updateWainscotOnWallCahnge = () => {
    if(params.p_w_c_n){
        if((params.p_f_w=="Close" || params.p_b_w=="Close" || params.p_l_w=="Close" || params.p_r_w=="Close" || params.p_u_c || params.cB_addStorage_check_left || params.cB_addStorage_check_right)
        || (params.p_b_c_b_l_f=="Close" || params.p_b_c_b_l=="Close" || params.p_b_c_b_l_b=="Close" || params.add_storage_check) 
        || (params.p_b_c_b_r_f=="Close" || params.p_b_c_b_r=="Close" || params.p_b_c_b_r_b=="Close" || params.add_storage_check_right)
        || (params.p_b_c_b_f_f=="Close" || params.p_b_c_b_f_b=="Close" || params.p_b_c_b_f_l=="Close" || params.add_storage_check_front)
        || (params.p_b_c_b_b_f=="Close" || params.p_b_c_b_b_b=="Close" || params.p_b_c_b_b_l=="Close" || params.add_storage_check_back)
        || (params.p_f_w=="Half Dutch End" || params.p_f_w=="Half End" || params.p_b_w=="Half Dutch End" || params.p_b_w=="Half End")
        || (params.p_b_c_b_l_f=="Half Dutch End" || params.p_b_c_b_l_f=="Half End" || params.p_b_c_b_l_b=="Half Dutch End" || params.p_b_c_b_l_b=="Half End")
        || (params.p_b_c_b_b_f=="Half Dutch End" || params.p_b_c_b_b_f=="Half End" || params.p_b_c_b_b_b=="Half Dutch End" || params.p_b_c_b_b_b=="Half End")
        || (params.p_b_c_b_f_f=="Half Dutch End" || params.p_b_c_b_f_f=="Half End" || params.p_b_c_b_f_b=="Half Dutch End" || params.p_b_c_b_f_b=="Half End")
        || (params.p_b_c_b_r_f=="Half Dutch End" || params.p_b_c_b_r_f=="Half End" || params.p_b_c_b_r_b=="Half Dutch End" || params.p_b_c_b_r_b=="Half End")
        ){
            const_var.showWainscotJSX = true;
        } else {
            const_var.showWainscotJSX = false;
            params.p_w_c_n = false;
            const_var.UpdatedPriceData.wainscot_price_changed = true;
            //const_var.UpdatedPriceData.color_price_changed = true;
        }
    }
}

export const manageOverheadDoorObject = (response)=>{
  if (response.data.data.pricing_data.garage_door_v3 != undefined && response.data.data.pricing_data.garage_door_v3.overhead_door_door != undefined) {
                let overhead = response.data.data.pricing_data.garage_door_v3.overhead_door_door.find(e => e.name == "Overhead");
                if (overhead) {
                    overhead.data.forEach((e) => {
                        if (e.door_add_ons) {
                            let windowOptions = e.door_add_ons.find(i => i.door == "window_option");
                            if (windowOptions) {
                                windowOptions.category = windowOptions.category.map((item) => {
                                    if (typeof(item) == 'string') {

                                        return {
                                            category: item,
                                            cost: windowOptions.cost,
                                            cost_type: windowOptions.cost_type,
                                            is_cost: windowOptions.is_cost,
                                        }
                                    } else {
                                        return item;
                                    }
                                })
 
                                delete windowOptions.cost
                                delete windowOptions.cost_type
                                delete windowOptions.is_cost
                            }
 
                            let motorOptions = e.door_add_ons.find(i => i.door == "motor");
                            if (motorOptions) {
                                motorOptions.category = motorOptions.category.map((item, index) => {
                                    if (typeof(item) == 'string') {

                                        return {
                                            category: item,
                                            cost: motorOptions.cost.split(',')[index],
                                            cost_type: motorOptions.cost_type,
                                            is_cost: motorOptions.is_cost,
                                        }
                                    } else {
                                        return item;
                                    }
                                })
 
                                delete motorOptions.cost
                                delete motorOptions.cost_type
                                delete motorOptions.is_cost
                            }
 
                            let insulatedOptions = e.door_add_ons.find(i => i.door == "insulated");
                            if (insulatedOptions) {
                                insulatedOptions.category = insulatedOptions.category.map((item) => {
                                    if (typeof(item) == 'string') {

                                        return {
                                            category: item,
                                            cost: insulatedOptions.cost,
                                            cost_type: insulatedOptions.cost_type,
                                            is_cost: insulatedOptions.is_cost,
                                        }
                                    } else {
                                        return item;
                                    }
                                })
 
                                delete insulatedOptions.cost
                                delete insulatedOptions.cost_type
                                delete insulatedOptions.is_cost
                            }
                            let isAddOnOptionsOld = false;
                            let addOnOptions = e.door_add_ons.filter(i => i.door == "add_on_options");
                            addOnOptions.map((addOnOption) => {
                                addOnOption.category = addOnOption.category.map((item) => {
                                    if (typeof(item) == 'string') {

                                        isAddOnOptionsOld = true;
                                        return {
                                            category: item,
                                            cost: addOnOption.cost,
                                            cost_type: addOnOption.cost_type,
                                            is_cost: addOnOption.is_cost,
                                        }
                                    } else {
                                        return item;
                                    }
                                })
 
                                delete addOnOption.cost
                                delete addOnOption.cost_type
                                delete addOnOption.is_cost
                            })
 
                            if (isAddOnOptionsOld) {
                                e.door_add_ons = e.door_add_ons.filter(i => i.door != "add_on_options");
                                e.door_add_ons.push({door: "add_on_options", category: addOnOptions.map((e) => e.category[0])})
                            }
                        }
                    })
                }
            }
 
            if (response.data.data.request_data.building != undefined && response.data.data.request_data.building.entry_points != undefined) {    
                response.data.data.request_data.building.entry_points.forEach((item) => {
                        let e = item.entry_size;
                        if (e.door_add_ons) {
                            let windowOptions = e.door_add_ons.find(i => i.door == "window_option");
                            if (windowOptions) {
                                windowOptions.category = windowOptions.category.map((item) => {
                                    if (typeof(item) == 'string') {
                                        const_var.isShowAlert = true;
                                        const_var.alertUsedFor = "showOverheadOldQuoteOrderMsg";
                                        return {
                                            category: item,
                                            cost: windowOptions.cost,
                                            cost_type: windowOptions.cost_type,
                                            is_cost: windowOptions.is_cost,
                                        }
                                    } else {
                                        return item;
                                    }
                                })
 
                                delete windowOptions.cost
                                delete windowOptions.cost_type
                                delete windowOptions.is_cost
                            }
 
                            let motorOptions = e.door_add_ons.find(i => i.door == "motor");
                            if (motorOptions) {
                                motorOptions.category = motorOptions.category.map((item, index) => {
                                    if (typeof(item) == 'string') {
                                        const_var.isShowAlert = true;
                                        const_var.alertUsedFor = "showOverheadOldQuoteOrderMsg";
                                        return {
                                            category: item,
                                            cost: motorOptions.cost.split(',')[index],
                                            cost_type: motorOptions.cost_type,
                                            is_cost: motorOptions.is_cost,
                                        }
                                    } else {
                                        return item;
                                    }
                                })
 
                                delete motorOptions.cost
                                delete motorOptions.cost_type
                                delete motorOptions.is_cost
                            }
 
                            let insulatedOptions = e.door_add_ons.find(i => i.door == "insulated");
                            if (insulatedOptions) {
                                insulatedOptions.category = insulatedOptions.category.map((item) => {
                                    if (typeof(item) == 'string') {
                                        const_var.isShowAlert = true;
                                        const_var.alertUsedFor = "showOverheadOldQuoteOrderMsg";
                                        return {
                                            category: item,
                                            cost: insulatedOptions.cost,
                                            cost_type: insulatedOptions.cost_type,
                                            is_cost: insulatedOptions.is_cost,
                                        }
                                    } else {
                                        return item;
                                    }
                                })
 
                                delete insulatedOptions.cost
                                delete insulatedOptions.cost_type
                                delete insulatedOptions.is_cost
                            }
                            let isAddOnOptionsOld = false;
                            let addOnOptions = e.door_add_ons.filter(i => i.door == "add_on_options");
                            addOnOptions.map((addOnOption) => {
                                addOnOption.category = addOnOption.category.map((item) => {
                                    if (typeof(item) == 'string') {
                                        const_var.isShowAlert = true;
                                                                                const_var.alertUsedFor = "showOverheadOldQuoteOrderMsg";
                                        isAddOnOptionsOld = true;
                                        return {
                                            category: item,
                                            cost: addOnOption.cost,
                                            cost_type: addOnOption.cost_type,
                                            is_cost: addOnOption.is_cost,
                                        }
                                    } else {
                                        return item;
                                    }
                                })
 
                                delete addOnOption.cost
                                delete addOnOption.cost_type
                                delete addOnOption.is_cost
                            })
 
                            if (isAddOnOptionsOld) {
                                e.door_add_ons = e.door_add_ons.filter(i => i.door != "add_on_options");
                                e.door_add_ons.push({door: "add_on_options", category: addOnOptions.map((e) => e.category[0])})
                            }
                        }
                    })
               
            }
}

export const convertToTwoDecimalNumber = (price) =>{
    
    price = parseFloat(price);
    let convertToTwoDecimal = Number.isInteger(price) ? price : price.toFixed(2);
    let convertToNumber = parseFloat(convertToTwoDecimal);

    return convertToNumber;
}

export const checkLegsDataAccordingtoResponse = (dataObj,key)=>{
   let chkLegs = '';
    if(key == undefined && dataObj!=undefined && dataObj.length>0)
    {
        chkLegs = dataObj.filter((data)=>data.legs_type==const_var.legstype && (data.min_height!='' || data.min_height!=null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
        if(chkLegs.length==0)
        {
            let newData = dataObj.filter((data)=>((data.min_height!='' || data.min_height!=null) && (data.min_height <= params.p_h) && (data.max_height >= params.p_h)))
            chkLegs = (newData.length==0)?'single':(newData.length>1)?newData.filter(data=>data.is_default=="Y")[0].legs_type:newData[0].legs_type;
        }else{
            chkLegs = chkLegs[0]?.legs_type;
        }
    }
    if(key !=undefined && key == 'dimension' && dataObj!=undefined && dataObj.length>0){
        chkLegs = dataObj.filter((data)=>data.is_default=="Y" && (data.min_height!='' || data.min_height!=null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
        if(chkLegs.length>0)
        {
            chkLegs = chkLegs[0].legs_type;
        }else{
            chkLegs = dataObj.filter((data)=>(data.min_height!='' || data.min_height!=null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
            chkLegs = (chkLegs!=undefined && chkLegs.length>0) ? chkLegs[0]?.legs_type :'single' ;
        }   
    }
    if(const_var.crmSetting.is_Edit == true){
        const_var.reinforcedtype['center'] = chkLegs=='reinforced' ? 'reinforced' : 'single'
        const_var.legstype = (chkLegs!='')?chkLegs:'single';
    }else{
        const_var.reinforcedtype['center'] = chkLegs=='reinforced' ? 'reinforced' : 'single'
        const_var.legstype = (chkLegs!='')?chkLegs=='reinforced'?'double':chkLegs:'single';   
    }
    const_var.legstype = const_var.legstype.toLowerCase()
}
export const checkleanLegsDataAccordingtoResponse = (dataObj,type,key)=>{
    let lean_Type = "";
    let lean_Height = "";

   if( type == "front"){
    lean_Type =  const_var.leanFLegstype 
    lean_Height =  params.leanF_p_h
   }
   if( type == "back"){
    lean_Type =  const_var.leanBLegstype 
    lean_Height =  params.leanB_p_h
   }
   if( type == "left"){
    lean_Type =  const_var.leanLegstype 
    lean_Height =  params.lean_p_h
   }
   if( type == "right"){
    lean_Type =  const_var.leanRLegstype 
    lean_Height =  params.leanR_p_h
   }
    let chkLegs = '';
    let chkLegsName = 'single';
     if(key == undefined && dataObj!=undefined && dataObj.length>0)
     {
         chkLegs = dataObj.filter((data)=>data.legs_type==lean_Type && (data.min_height!='' || data.min_height!=null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
         if(chkLegs.length==0)
         {
             let newData = dataObj.filter((data)=>((data.min_height!='' || data.min_height!=null) && (data.min_height <= lean_Height) && (data.max_height >= lean_Height)))

             chkLegs = (newData.length==0)?'single':(newData.length>1)?newData.filter(data=>data.is_default=="Y")[0].legs_type:newData[0].legs_type;
             chkLegsName = (newData.length==0)?'single':(newData.length>1)?newData.filter(data=>data.is_default=="Y")[0].name:newData[0].name
         }else{
            chkLegsName = chkLegs[0]?.name
            chkLegs = chkLegs[0]?.legs_type;
        }
     }
     if(key !== undefined && key == 'dimension' && dataObj!=undefined && dataObj.length>0)
        {
            let leanChkLegs = dataObj.filter((data)=> data.is_default=="Y" && ((data.min_height!='' || data.min_height!=null) && (data.min_height <= lean_Height) && (data.max_height >= lean_Height)));
            if(leanChkLegs.length>0)
            {
                chkLegsName = leanChkLegs[0]?.name
                chkLegs = leanChkLegs[0]?.legs_type;
                
            }else{
                let newData = dataObj.filter((data)=>((data.min_height!='' || data.min_height!=null) && (data.min_height <= lean_Height) && (data.max_height >= lean_Height)))
   
                chkLegs = (newData.length==0)?'single':(newData.length>1)?newData.filter(data=>data.is_default=="Y")[0].legs_type:newData[0].legs_type;
                chkLegsName = (newData.length==0)?'single':(newData.length>1)?newData.filter(data=>data.is_default=="Y")[0].name:newData[0].name
           }
        }
     if( type == "front"){
            const_var.reinforcedtype['front'] = chkLegs=='reinforced' ? 'reinforced' : 'single'
            const_var.leanFLegstype = (chkLegs!='')?chkLegs=='reinforced'?'double':chkLegs:'single';
            const_var.leanFHasDoublelegName = (chkLegsName!='')? chkLegsName:'single';
       }
       if( type == "back"){
            const_var.reinforcedtype['back'] = chkLegs=='reinforced' ? 'reinforced' : 'single'
            const_var.leanBLegstype = (chkLegs!='')?chkLegs=='reinforced'?'double':chkLegs:'single';
            const_var.leanBHasDoublelegName = (chkLegsName!='')? chkLegsName:'single';
       }
       if( type == "left"){
            const_var.reinforcedtype['left'] = chkLegs=='reinforced' ? 'reinforced' : 'single'
            const_var.leanLegstype = (chkLegs!='')?chkLegs=='reinforced'?'double':chkLegs:'single';
            const_var.leanHasDoublelegName = (chkLegsName!='')? chkLegsName:'single';
       }
       if( type == "right"){
            const_var.reinforcedtype['right'] = chkLegs=='reinforced' ? 'reinforced' : 'single'
            const_var.leanRLegstype = (chkLegs!='')?chkLegs=='reinforced'?'double':chkLegs:'single';
            const_var.leanRHasDoublelegName = (chkLegsName!='')? chkLegsName:'single';
       }


 }
export const checkReinforcedLeg = (reinforcedLeg)=>{
        if(reinforcedLeg!=undefined && reinforcedLeg.length>0)
        {
                let reinforeced = reinforcedLeg.find((data)=>(data.name.includes('Reinforced') || data.name.includes('reinforced')) && (data.legs_type == "Single" || data.legs_type == "single"))
                if(reinforeced!=undefined){
                    reinforeced.legs_type = 'reinforced';
                    const_var.legstype = reinforeced.legs_type;
                    const_var.legstype = const_var.legstype.toLowerCase()
                }
        }
}
export const setOldRoofStyleData =(oldresponse,newresponse)=>{

    let checkRoof = oldresponse.data.data.building_data.building.find((s)=> s.building_type.building_id == oldresponse.data.data.request_data.building.building_type && s.building_type.heavy_snow == oldresponse.data.data.request_data.building.heavy_snow);
    let roofID = checkRoof?.roof_style.find((s)=>s.roof_id == oldresponse.data.data.request_data.building.roof_style);
    if(checkRoof != undefined && roofID != undefined){
        newresponse.data.data.building.filter((building, index) => {
            if(building.building_type.building_id === oldresponse.data.data.request_data.building.building_type ){
                building.roof_style = checkRoof.roof_style;
            }
        })
    }
} 
export const updateColorObj = (response)=>{
    if(response.manufacture_data && response.manufacture_data.length > 0 && response.manufacture_data[0].id != 153){
        for (var i = 0; i <= response.color.length - 1; i++) {
             if(response.color[i].color_add_ons!=undefined && response.color[i].color_add_ons.length>0)
             {
                 // let isNotPremium = isJsonString(response.color[i].color_add_ons).find(obj => obj.cost != 0)
                 // if(isNotPremium == undefined){
                 //     response.color[i].color_add_ons = [];
                 //     response.color_object[response.color[i].id] = [];
                 // }
                 isJsonString(response.color[i].color_add_ons).map((data,index)=>{
                     if(data.cost==0 && data.price_of.length==0 && data.cost_type==0)
                     {
                         response.color[i].color_add_ons = [];
                         response.color_object[response.color[i].id].color_add_ons = [];
                     }
                 })
             }
         }
    }
}
export const editOldQuotes = (response,is_check,priceresponse,response1 ) => {
    if((response.data.data.request_data.building.manufacturer==2 || response.data.data.request_data.building.manufacturer==17) && response1 !== undefined){
        response.data.data.building_data.building = response1.data.data.building
        response.data.data.building_data.default_building = response1.data.data.default_building
    }
    let editBuildingData = response.data.data.request_data.building
    // if(editBuildingData.manufacturer != 3)return;
    let buildingData = response.data.data.building_data.building
    let buildingIndex = null
    let filterBuilding = buildingData.filter((building, index) => {
        if(building.building_type.building_id === editBuildingData.building_type){
            buildingIndex = index
            return building
        }
    })
    if(filterBuilding[0]?.fixed_new_leg_width?.length >= 0)return;

    filterBuilding.forEach((building) => {
        if(building.building_type.building_id === editBuildingData.building_type){
               if(building.fixed_new_leg_width !== undefined && building.fixed_new_leg_width.length > 0 && building.fixed_new_leg_width[0][editBuildingData.width] == undefined){
                   building.fixed_new_leg_width = []
               }
               if(building.fixed_new_leg_width !== undefined && building.fixed_new_leg_width.length > 0 && building.fixed_new_leg_width[0][editBuildingData.height] == undefined){
                    building.fixed_new_leg_width = []
               }
               if(building.fixed_new_leg_width !== undefined && building.fixed_new_leg_width.length > 0 && building.fixed_new_leg_width[0][editBuildingData.length] == undefined){
                        building.fixed_new_leg_width = []
                }
           }
   })
   
    if(is_check!=undefined && is_check=="edit")
    {
      const_var.oldFreeStandingData = undefined;
    }
    if(const_var.oldFreeStandingData === undefined && (filterBuilding[0].fixed_new_leg_width === undefined || filterBuilding[0].fixed_new_leg_width.length === 0 )){
        const_var.oldFreeStandingData = JSON.parse(JSON.stringify(response))
        if(filterBuilding.length > 0){
            let filterRoofStyle = filterBuilding[0].roof_style.filter((roof) => {
                if(roof.roof_id === editBuildingData.roof_style){
                    return roof
                }
            })
            let defaultBuildingDataFilter = response.data.data.building_data.default_building.filter((item) => {
                if((item.building_id === editBuildingData.building_type) || (item.name.includes("Free Standing Lean-to") || item.name.includes("Free Standing Building"))){
                 return item   
                }
            })
            defaultBuildingDataFilter.forEach((item) => {
                item.size = `${editBuildingData.width}x${editBuildingData.length}x${editBuildingData.height}`
                item.central_roof_pitch = editBuildingData.roof_pitch;
            })
            filterRoofStyle[0].min_height = editBuildingData.height
            filterRoofStyle[0].max_height = editBuildingData.height
            filterRoofStyle[0].start_height = editBuildingData.height
    
            filterRoofStyle[0].min_start_width = editBuildingData.width
            filterRoofStyle[0].min_width = editBuildingData.width
            filterRoofStyle[0].max_width =  editBuildingData.width
            
            filterRoofStyle[0].start_length = editBuildingData.length
            filterRoofStyle[0].min_start_length = editBuildingData.length
            filterRoofStyle[0].end_length = editBuildingData.length
            filterRoofStyle[0].building_max_length = editBuildingData.length
            filterRoofStyle[0].default_gauge = editBuildingData.gauge
            filterBuilding[0].roof_style = filterRoofStyle            
            buildingData.forEach((building) => {
                if((building.building_type.name.includes("Free Standing Lean-to") || building.building_type.name.includes("Free Standing Building")) && (building?.fixed_new_leg_width !== undefined || building?.fixed_new_leg_width == 0)){
                    building.roof_style = filterRoofStyle
                }
            })
        }
        let filterRoofpitch = response.data.data.pricing_data.roof_pitch.filter((roof) => {
            if(roof.roof_pitch == editBuildingData.roof_pitch){
                return roof
            }
        })

        response.data.data.pricing_data.roof_pitch = filterRoofpitch
    
        let filterGauge = response.data.data.pricing_data.base.filter((base) => {
            if(base.gauge === editBuildingData.gauge){
                return(base)
            }
        })

        response.data.data.pricing_data.roof_pitch[0].is_default = 'yes'
        response.data.data.pricing_data.base = filterGauge
        response.data.data.pricing_data.building_structure[0] = filterBuilding[0].roof_style[0];
        response.data.data.building_data.building[buildingIndex] = filterBuilding[0];
       
        if(is_check!=undefined && is_check=="edit" && priceresponse !== null)
        {
          priceresponse.data.data.base = filterGauge;
          priceresponse.data.data.building_structure[0] = filterBuilding[0].roof_style[0];
          priceresponse.data.data.roof_pitch = response.data.data.pricing_data.roof_pitch;
        }    
        const_var.infoMessage = true
    }else{
          let checkBuildingType = ((response.data.data.request_data !=undefined && response.data.data.request_data.building.display_building_type_name.includes('Free Standing Buildings') || response.data.data.request_data.building.display_building_type_name.includes('Free Standing Lean-to')))
        if(!checkBuildingType && filterBuilding[0].fixed_new_leg_width?.length === 0 && const_var.oldFreeStandingData !== undefined && filterBuilding.length > 0 ){
            const_var.AllBuildingData.data = const_var.oldFreeStandingData.data.data.building_data;
            const_var.editAPIDataByResponse.data.building_data = const_var.oldFreeStandingData.data.data.building_data;
            let oldVarData  = const_var.AllBuildingData?.data?.building?.filter((building) => {
                if(building.building_type.building_id === params.p_b_t){
                    return building
                }
            })
            if(oldVarData.length > 0){
                const_var.c_m_a[params.p_b_t].roof_style = oldVarData[0].roof_style
            }
            const_var.infoMessage = false
        }
    }
    return response
}
// "This function updates the alert pop-up message based on the alert use case."
export const updateAlertMessage = (alertUsedFor) =>{

    let alertMessage = "";

    if (alertUsedFor == "restrictedBuildingHeight") {    
        alertMessage = "Please increase the building's height or adjust the roof pitch to design the building with the selected width.";
     }
     if (alertUsedFor == "restrictedBuildingHeight1") {    
       alertMessage = "Please decrease the building's width or adjust the roof pitch to design the building with the selected height.";
     }
      
     if (alertUsedFor == "noSpaceForComponent") {    
       alertMessage = "To add or modify a component, the building dimensions need to be increased.";  
     }
     if (alertUsedFor == "noSpaceForComponentDuringLoading") {    
       alertMessage = "Overlapping doors and windows added during building design will be subject to automatic removal.";  
     }
     if (alertUsedFor == "publicAccessURL") {    
       alertMessage = const_var.alertPubliMessage;  
     }
     if (alertUsedFor == "ManageKlinkExpire") {    
       alertMessage = const_var.alertExpireMessage;  
     }
     if (alertUsedFor == "ManageKlinkMessage") {    
       alertMessage = "Please note that updating the quote will deactivate the current K-link. You will need to generate a new K-link for sharing.";  
     }

     if (alertUsedFor == "showOverheadOldQuoteOrderMsg") {    
        alertMessage = "This manufacturer's prices have been updated. Please review the total cost of this building before making any updates.";  
      }
    if (alertUsedFor == "noSpaceToAddCupola") {    
       alertMessage = "This item doesn’t fit and can’t be placed on the selected wall.";  
     }
    if (alertUsedFor == "noSpaceToUpdateCupola") {    
       alertMessage = "This item size doesn’t fit and can’t be placed on the selected wall.";  
     }
    if (alertUsedFor == "removeCupola") {    
       alertMessage = "Are you sure you want to remove this cupola?";  
     }
    if (alertUsedFor == "FULLYENCLOSED") {    
      alertMessage = "This action will revert your selections in CUSTOM walls to default. Click 'Ok' to continue.";  
    }if (alertUsedFor == "ADDUTILITY") {
      alertMessage = "If you add Utility Storage, all your selections in the Custom Walls will be set to default. Click Done if you still want to continue.";  
    }
    if (alertUsedFor == "captuareIMG") {
      alertMessage = "Psst! You can only click 5 photos. Consider removing an OK photo to make room for a better one. Thank you!";  
    }
    if (alertUsedFor == "CancelOrderQuote") {
       if(const_var.crmSetting.is_module_name == "inventory"){
          alertMessage = "This action will reset your current selections. Please confirm if you want to proceed.";  
       }
       else{
          alertMessage = "This action will reset your current selections. Please confirm if you want to proceed.";  
       }
    }  
    if (alertUsedFor =="customBuildings") {
       alertMessage = "This action will reset your current selections. Please confirm if you want to proceed.";       
    }
     if (alertUsedFor == "REMOVECOMPONENT") {
     alertMessage = "Are you sure you want to delete this component?";  
    }  if (alertUsedFor == "noSpaceAvailableOnWall") {
      alertMessage = "No more components can fit on this wall. Please consider changing the wall or increasing its size.";  
    } if (alertUsedFor == "overHeightLeanTo") {
        alertMessage = "This component's height exceeds the lean-to height. Please increase the height of the lean-to.";
    } if (alertUsedFor == "NoMoreGarageDoorsCanBeAdded") {
      alertMessage = "No more garage doors can be added with selected dimensions.";  
     }  if (alertUsedFor == "NoMoreWalkInDoorsCanBeAdded") {
      alertMessage = "No more walk-in doors can be added with the selected dimensions. Please increase the width, length, or height to add this walk-in door.";  
     }  if (alertUsedFor == "YourCanNotAddLeanTo") {
      alertMessage = "You cannot add a lean-to with the selected height. Please increase the height to add this lean-to.";  
     }if (alertUsedFor == "YourCanNotAddPorch") {
       alertMessage = "Please ensure lean-tos are attached to the corners of the adjoining walls to add a wrap-around porch.";  
      } if (alertUsedFor == "YourCanNotChangePorch") {
       alertMessage = "Changing the building size will remove the wrap-around and disconnect the lean-tos.";  
      }if (alertUsedFor == "YourCanNotAlignPorch") {
       alertMessage = "Changing the lean-to's alignment will remove the wrap-around and disconnect the lean-tos.";  
      }if (alertUsedFor == "YouCanNotAddPorch") {
       alertMessage = "Please ensure lean-tos are attached to the corners of the adjoining walls to add a wrap-around porch.";  
      }
     if (alertUsedFor == "addComponentOnWall") {
      alertMessage = "Oops!! Did you forget to add a door to your fully enclosed building? Please see the doors and windows tab given under options panel and proceed with ordering";  
     }if (alertUsedFor == "RoofPitchAction") {
      alertMessage = "You can't add this roof pitch with selected dimensions";  
     }if (alertUsedFor == "onSubmitLoginApiErrorhandling") {
      alertMessage = const_var.loginErrorHandlingMessage;  
     }if (alertUsedFor == "RoofStyleLength") {
       alertMessage = "This roof style is not available with selected size.";
     }if (alertUsedFor == "RegularRoofStyle") {
       alertMessage = "Vertical panels can't be added with a regular roof style. Please change your roof style to A-frame or vertical to add these panels vertically.";
     }if (alertUsedFor == "regularRoofStyleHeight") {
       alertMessage = "This roof style is not available with selected height, please increase height to change the roof style.";
     }if (alertUsedFor == "nonVerticalRoofStyleForTubulerBuildingMnf") {
       alertMessage = "Changing the roof style will remove end lean-tos, do you still want to change?";
     } if (alertUsedFor == "endLeantosForTubulerBuildingMnf") {
       alertMessage = "Please select the Vertical Roof Style for your building to add End Lean Tos.";
     }if (alertUsedFor == "endLeantoPorchessForTubulerBuildingMnf") {
       alertMessage = "Wrap-around can’t be added with this roof style, please switch to Vertical roof style to add wrap-around.";
    
     }if (alertUsedFor == "clearComponent") {
       alertMessage = "This action will remove all building components. Do you want to proceed?";
     }
    // ################ To handle show modal when manufacture or state changes #############
    if(alertUsedFor == "changeStateOrManufacture") {
        alertMessage = "Changing the manufacturer or state will reset your building changes, requiring you to design a new building from scratch.";
    }
    if(alertUsedFor == "NoMfgExsist") {
        alertMessage = "This link is not valid/expired. Please contact to the sales executive person.";
    }
    if (alertUsedFor == "noBuildingFromInspirationGallery") {
       alertMessage = "This building configuration is unavailable for the selected state and manufacturer.";
    }
    if (alertUsedFor == "REMOVEPOSITIONCOMPONENT") {
        alertMessage = "Do you really want to delete lean-to's."
    }
    if (alertUsedFor == "changeInstallationSurface") {
        alertMessage = "A concrete surface is required to accommodate a residential door in the building. Please choose from the options below";
    }
    //   if (alertUsedFor == "overHeightComponent") {
    //    alertMessage = "Component height is greater than building height. Please increase the height of the building or decrease the height of the component.";
    // }
    
     if(alertMessage =="" && const_var.stripeErrorHandlingMessage!="")
     {
        alertMessage = const_var.stripeErrorHandlingMessage;
     }


    return alertMessage
}

export function sortArrayStrings(array, property) {
    if (array.length === 0) return array; // Return empty array as is
  
    if (typeof array[0] === 'string') {
      // Array of strings
      return array.sort((a, b) => a.localeCompare(b));
    } else if (typeof array[0] === 'object' && property) {
      // Array of objects
      return array.sort((a, b) => {
        const valA = a[property] ? a[property].toLowerCase() : '';
        const valB = b[property] ? b[property].toLowerCase() : '';
        
        if (valA < valB) return -1;
        if (valA > valB) return 1;
        return 0;
      });
    } else {
      throw new Error("Unsupported array type or missing property for object sorting.");
    }
  }

// ########## Function to calculate price of premium color ########## buildingData == post_data['building']
export function calcColorPriceWithCostType(costObj, leantoPriceCalculation, totalPriceWithoutAdditionalItem, calcfor, paramsData, buildingData,totalCost, pricingData = undefined){
    let finalCost = 0
    // if(const_var.checkmoreCustomizeFlag==true && (costObj.cost_type == 'sqft' || costObj.cost_type == '2')){
    //     return 0
    // }
    if(const_var.checkmoreCustomizeFlag == false || parseFloat(totalPriceWithoutAdditionalItem) != 0){
        
        // const_var.UpdatedPriceData.roof_color_price_changed = const_var.colorPrice.roof_color_price_changed == true ? const_var.UpdatedPriceData.roof_color_price_changed : true
        // const_var.UpdatedPriceData.wall_color_price_changed = const_var.colorPrice.wall_color_price_changed == true ? const_var.UpdatedPriceData.wall_color_price_changed : true
        // const_var.UpdatedPriceData.trim_color_price_changed = const_var.colorPrice.trim_color_price_changed == true ? const_var.UpdatedPriceData.trim_color_price_changed : true
        // const_var.UpdatedPriceData.wainscot_price_changed = const_var.colorPrice.wainscot_color_price_changed == true ? const_var.UpdatedPriceData.wainscot_price_changed : true

        if(const_var.colorPrice.roof_color_price_changed == false && calcfor== "roof"){
            const_var.UpdatedPriceData.roof_color_price_changed = true
        }
        if(const_var.colorPrice.wall_color_price_changed == false && calcfor== "wall"){
            const_var.UpdatedPriceData.wall_color_price_changed = true
        }
        if(const_var.colorPrice.trim_color_price_changed == false && calcfor== "trim"){
            const_var.UpdatedPriceData.trim_color_price_changed = true
        }
        if(const_var.colorPrice.wainscot_color_price_changed == false && calcfor== "wainscot"){
            const_var.UpdatedPriceData.wainscot_price_changed = true
        }
        if(costObj.cost_type == '%' || costObj.cost_type == '1'){
            var splitVal = costObj.price_of != undefined && costObj.price_of.length > 0 ? costObj.price_of : 0;
            var splval = 0;         
            if(splitVal!=0)
            { 
                if(splitVal.includes("full_building_price")!=false)
                {
                    splval = parseFloat(splval) + parseFloat(totalCost);
                    // splval = parseFloat(splval) + parseFloat(totalCost) + parseFloat(leantoPriceCalculation.totalLeanPrice);
                }
                if(splitVal.includes("base_price")!=false)
                {
                    splval = parseFloat(splval) + parseFloat(buildingData.roof_style_price) + parseFloat(leantoPriceCalculation.totalBasePrice);
                }
                if(splitVal.includes("wall_price")!=false)
                {
                    if(calcfor == 'wainscot'){
                        let allPricingData = pricingData != undefined ? pricingData : const_var.a_p_d_a
                        let cbPanelPrice = 0
                        let cbGabelPrice = 0
                        let leanToWall = 0
                        
                        let centerBuildingWall = 0 
                        let leftleanPanelPrice = 0
                        let rightleanPanelPrice = 0
                        let backleanPanelPrice = 0
                        let frontleanPanelPrice = 0
                        let leftleanGabelPrice = 0
                        let rightleanGabelPrice = 0
                        let backleanGabelPrice = 0
                        let frontleanGabelPrice = 0
                        if(Object.keys(const_var.wallsData['center']).length>0){
                            cbPanelPrice = parseFloat(allPricingData.full_length_panel && allPricingData.full_length_panel[0].cost || 0)
                            cbGabelPrice = parseFloat(allPricingData.gable_end && allPricingData.gable_end[0].certified || 0)
                            if(params.p_v_w){
                                cbPanelPrice = parseFloat(allPricingData.full_length_panel && allPricingData.full_length_panel[0].vertical_panel_cost || 0)
                                cbGabelPrice = parseFloat(cbGabelPrice) + parseFloat(allPricingData.gable_end && allPricingData.gable_end[0].vertical_certified || 0) 
                            }
                        }

                        if(Object.keys(const_var.wallsData['frontLean']).length>0 && paramsData.add_front_lean==true){
                            frontleanPanelPrice = (const_var.leanGetDataFront && const_var.leanGetDataFront.full_length_panel[0].cost || 0)
                            frontleanGabelPrice = parseFloat(const_var.leanGetDataFront && const_var.leanGetDataFront.gable_end && const_var.leanGetDataFront.gable_end[0].certified || 0)
                            
                            if(params.p_v_w){
                                frontleanPanelPrice = (const_var.leanGetDataFront && const_var.leanGetDataFront.full_length_panel[0].vertical_panel_cost || 0)
                                frontleanGabelPrice = parseFloat(frontleanGabelPrice) + parseFloat(const_var.leanGetDataFront && const_var.leanGetDataFront.gable_end && const_var.leanGetDataFront.gable_end[0].vertical_certified || 0) 
                            }

                            leanToWall = parseFloat(leanToWall) + (const_var.wallsData['frontLean'].p_b_c_b_f_l == 'Close' ? parseFloat(frontleanPanelPrice) :0) + (const_var.wallsData['frontLean'].p_b_c_b_f_f == 'Close' ? parseFloat(frontleanGabelPrice) :0) + (const_var.wallsData['frontLean'].p_b_c_b_f_b == 'Close' ? parseFloat(frontleanGabelPrice) :0) 

                            if(paramsData.add_storage_check_front == true){
                                let utilityPanelPrice = params.p_v_w ? (const_var.leanGetDataFront && const_var.leanGetDataFront.panel[0].vertical_panel_cost || 0) : (const_var.leanGetDataFront && const_var.leanGetDataFront.panel[0].cost || 0)
                                leanToWall = parseFloat(leanToWall) + parseFloat(frontleanGabelPrice) + parseFloat(const_var.wallsData['frontLean'].p_b_c_b_f_l == 'Close' ? 0 : utilityPanelPrice) + parseFloat(const_var.wallsData['frontLean'].p_b_c_b_f_b == 'Close' ? 0 : frontleanGabelPrice) + (const_var.wallsData['center'].p_f_w == 'Close' ? 0 : utilityPanelPrice)
                            }
                        }
                        if(Object.keys(const_var.wallsData['backLean']).length>0 && paramsData.add_back_lean==true){
                            backleanPanelPrice = (const_var.leanGetDataBack && const_var.leanGetDataBack.full_length_panel[0].cost || 0)
                            backleanGabelPrice = parseFloat(const_var.leanGetDataBack && const_var.leanGetDataBack.gable_end && const_var.leanGetDataBack.gable_end[0].certified || 0)

                            if(params.p_v_w){
                                backleanPanelPrice = (const_var.leanGetDataBack && const_var.leanGetDataBack.full_length_panel[0].vertical_panel_cost || 0)
                                backleanGabelPrice = parseFloat(backleanGabelPrice) + parseFloat(const_var.leanGetDataBack && const_var.leanGetDataBack.gable_end && const_var.leanGetDataBack.gable_end[0].vertical_certified || 0) 
                            }

                            leanToWall = parseFloat(leanToWall) + (const_var.wallsData['backLean'].p_b_c_b_b_l == 'Close' ? parseFloat(backleanGabelPrice) :0) + (const_var.wallsData['backLean'].p_b_c_b_b_f == 'Close' ? parseFloat(backleanGabelPrice) :0) + (const_var.wallsData['backLean'].p_b_c_b_b_b == 'Close' ? parseFloat(backleanPanelPrice) :0) 
                            if(paramsData.add_storage_check_back == true){
                                let utilityPanelPrice = params.p_v_w ? (const_var.leanGetDataBack && const_var.leanGetDataBack.panel[0].vertical_panel_cost || 0) : (const_var.leanGetDataBack && const_var.leanGetDataBack.panel[0].cost || 0)
                                leanToWall = parseFloat(leanToWall) + parseFloat(backleanGabelPrice) + (const_var.wallsData['backLean'].p_b_c_b_b_l == 'Close' ? 0 : utilityPanelPrice) + (const_var.wallsData['backLean'].p_b_c_b_b_b == 'Close' ? 0 : backleanGabelPrice) + (const_var.wallsData['center'].p_b_w == 'Close' ? 0 : utilityPanelPrice)
                            }
                        }
                        if(Object.keys(const_var.wallsData['leftLean']).length>0 && paramsData.add_left_lean==true){
                            leftleanPanelPrice = (const_var.leanGetDataLeft && const_var.leanGetDataLeft.full_length_panel[0].cost || 0)
                            leftleanGabelPrice = parseFloat(const_var.leanGetDataLeft && const_var.leanGetDataLeft.gable_end && const_var.leanGetDataLeft.gable_end[0].certified || 0)

                            if(params.p_v_w){
                                leftleanPanelPrice = parseFloat(const_var.leanGetDataLeft && const_var.leanGetDataLeft.full_length_panel[0].vertical_panel_cost || 0)
                                leftleanGabelPrice =  parseFloat(leftleanGabelPrice) + parseFloat(const_var.leanGetDataLeft && const_var.leanGetDataLeft.gable_end && const_var.leanGetDataLeft.gable_end[0].vertical_certified || 0)
                            }

                            leanToWall = parseFloat(leanToWall) + (const_var.wallsData['leftLean'].p_b_c_b_l_f == 'Close' ? parseFloat(leftleanGabelPrice) :0) + (const_var.wallsData['leftLean'].p_b_c_b_l_b == 'Close' ? parseFloat(leftleanGabelPrice) :0) + (const_var.wallsData['leftLean'].p_b_c_b_l == 'Close' ? parseFloat(leftleanPanelPrice) :0) 
                            if(paramsData.add_storage_check == true){
                                let utilityPanelPrice = params.p_v_w ? (const_var.leanGetDataLeft && const_var.leanGetDataLeft.panel[0].vertical_panel_cost || 0) :  (const_var.leanGetDataLeft && const_var.leanGetDataLeft.panel[0].cost || 0)
                                leanToWall = parseFloat(leanToWall) + parseFloat(leftleanGabelPrice) + (const_var.wallsData['leftLean'].p_b_c_b_l == 'Close' ? 0 : utilityPanelPrice) +  (const_var.wallsData['leftLean'].p_b_c_b_l_b == 'Close' ? 0 : parseFloat(leftleanGabelPrice)) + (const_var.wallsData['center'].p_l_w == 'Close' ? 0 : utilityPanelPrice)
                            }
                        }
                        if(Object.keys(const_var.wallsData['rightLean']).length>0 && paramsData.add_right_lean==true){
                            rightleanPanelPrice = (const_var.leanGetDataRight && const_var.leanGetDataRight.full_length_panel[0].cost || 0)
                            rightleanGabelPrice = parseFloat(const_var.leanGetDataRight && const_var.leanGetDataRight.gable_end && const_var.leanGetDataRight.gable_end[0].certified || 0)

                            if(params.p_v_w){
                                rightleanPanelPrice = parseFloat(const_var.leanGetDataRight && const_var.leanGetDataRight.full_length_panel[0].vertical_panel_cost || 0)
                                rightleanGabelPrice = parseFloat(rightleanGabelPrice) + parseFloat(const_var.leanGetDataRight && const_var.leanGetDataRight.gable_end && const_var.leanGetDataRight.gable_end[0].vertical_certified || 0) 
                            }

                            leanToWall = parseFloat(leanToWall) + (const_var.wallsData['rightLean'].p_b_c_b_r == 'Close' ? parseFloat(rightleanPanelPrice) :0) + (const_var.wallsData['rightLean'].p_b_c_b_r_b == 'Close' ? parseFloat(rightleanGabelPrice) :0) + (const_var.wallsData['rightLean'].p_b_c_b_r_f == 'Close' ? parseFloat(rightleanGabelPrice) :0)
                            if(paramsData.add_storage_check_right == true){
                                let utilityPanelPrice = params.p_v_w ? (const_var.leanGetDataRight && const_var.leanGetDataRight.panel[0].vertical_panel_cost || 0) : (const_var.leanGetDataRight && const_var.leanGetDataRight.panel[0].cost || 0)
                                leanToWall = parseFloat(leanToWall) + parseFloat(rightleanGabelPrice) + (const_var.wallsData['rightLean'].p_b_c_b_r == 'Close' ? 0 : parseFloat(utilityPanelPrice)) + (const_var.wallsData['rightLean'].p_b_c_b_r_b == 'Close' ? 0 : parseFloat(rightleanGabelPrice))  + (const_var.wallsData['center'].p_r_w == 'Close' ? 0 : utilityPanelPrice)
                            }
                        }

                        centerBuildingWall = (const_var.wallsData['center'].p_f_w == 'Close' ? parseFloat(cbGabelPrice) :0) + (const_var.wallsData['center'].p_b_w == 'Close' ? parseFloat(cbGabelPrice) :0) + (const_var.wallsData['center'].p_l_w == 'Close' ? parseFloat(cbPanelPrice) :0) + (const_var.wallsData['center'].p_r_w == 'Close' ? parseFloat(cbPanelPrice) :0)

                        // let leanToWall = (const_var.wallsData['frontLean'].p_b_c_b_f_l == 'Close' ? parseFloat(frontleanPanelPrice) :0) + (const_var.wallsData['frontLean'].p_b_c_b_f_f == 'Close' ? parseFloat(frontleanGabelPrice) :0) + (const_var.wallsData['frontLean'].p_b_c_b_f_b == 'Close' ? parseFloat(frontleanGabelPrice) :0) + 
                        //     (const_var.wallsData['backLean'].p_b_c_b_b_l == 'Close' ? parseFloat(backleanGabelPrice) :0) + (const_var.wallsData['backLean'].p_b_c_b_b_f == 'Close' ? parseFloat(backleanGabelPrice) :0) + (const_var.wallsData['backLean'].p_b_c_b_b_b == 'Close' ? parseFloat(backleanPanelPrice) :0) 
                        //      + (const_var.wallsData['leftLean'].p_b_c_b_l_f == 'Close' ? parseFloat(leftleanGabelPrice) :0) + (const_var.wallsData['leftLean'].p_b_c_b_l_b == 'Close' ? parseFloat(leftleanGabelPrice) :0) + (const_var.wallsData['leftLean'].p_b_c_b_l == 'Close' ? parseFloat(leftleanPanelPrice) :0) 
                        //      + (const_var.wallsData['rightLean'].p_b_c_b_r == 'Close' ? parseFloat(rightleanPanelPrice) :0) + (const_var.wallsData['rightLean'].p_b_c_b_r_b == 'Close' ? parseFloat(rightleanGabelPrice) :0) + (const_var.wallsData['rightLean'].p_b_c_b_r_f == 'Close' ? parseFloat(rightleanGabelPrice) :0)

                        if((paramsData.p_u_c==true || paramsData.cB_addStorage_check_left==true || paramsData.cB_addStorage_check_right==true))
                        {
                            let UtilityPrice = 0
                            let utilityPanelPrice = parseFloat(allPricingData.panel && allPricingData.panel[0].cost || 0)
                            let utilityGablePrice = cbGabelPrice
                             if(params.p_v_w){
                                utilityPanelPrice = parseFloat(allPricingData.panel && allPricingData.panel[0].vertical_panel_cost || 0) 
                            }

                            if(paramsData.p_u_c==true){
                                UtilityPrice = parseFloat(utilityGablePrice) + parseFloat(const_var.wallsData['center'].p_b_w == 'Close' ? 0 : utilityGablePrice) + parseFloat(const_var.wallsData['center'].p_l_w == 'Close' ? 0 : utilityPanelPrice) + parseFloat(const_var.wallsData['center'].p_r_w == 'Close' ? 0 : utilityPanelPrice)
                            }
                            if(paramsData.cB_addStorage_check_left==true){
                                UtilityPrice = parseFloat(utilityPanelPrice) + parseFloat(const_var.wallsData['center'].p_f_w == 'Close' ? 0 : utilityGablePrice) + parseFloat(const_var.wallsData['center'].p_b_w == 'Close' ? 0 : utilityGablePrice) + parseFloat(const_var.wallsData['center'].p_l_w == 'Close' ? 0 : utilityPanelPrice)
                            }
                            if(paramsData.cB_addStorage_check_right==true){
                                UtilityPrice = parseFloat(utilityPanelPrice) + parseFloat(const_var.wallsData['center'].p_f_w == 'Close' ? 0 : utilityGablePrice) + parseFloat(const_var.wallsData['center'].p_b_w == 'Close' ? 0 : utilityGablePrice) + parseFloat(const_var.wallsData['center'].p_r_w == 'Close' ? 0 : utilityPanelPrice)
                            }
                            splval = parseFloat(splval) + parseFloat(UtilityPrice) + parseFloat(centerBuildingWall) + parseFloat(leanToWall);
                        }else
                        {
                            splval = parseFloat(splval) + parseFloat(centerBuildingWall) + parseFloat(leanToWall);
                        }
                        // if (buildingData.utility_front_price != undefined && paramsData.isBreezeway && paramsData.cB_addStorage_check_front ) {
                        //     splval = parseFloat(splval) + parseFloat(buildingData.utility_front_price);
                        // } 
                    }
                    else{
                        if((paramsData.p_u_c==true || paramsData.cB_addStorage_check_left==true || paramsData.cB_addStorage_check_right==true))
                        {
                            splval = parseFloat(splval) + parseFloat(buildingData.utility_price) + parseFloat(buildingData.front_wall_price) + parseFloat(buildingData.left_wall_price) + parseFloat(buildingData.right_wall_price)+ parseFloat(buildingData.back_wall_price) + parseFloat(leantoPriceCalculation.totalWallPrice);
                        }else
                        {        
                            splval = parseFloat(splval) + parseFloat(buildingData.front_wall_price) +parseFloat(buildingData.left_wall_price) + parseFloat(buildingData.right_wall_price) + parseFloat(buildingData.back_wall_price) + parseFloat(leantoPriceCalculation.totalWallPrice);
                        }
                        if (buildingData.utility_front_price != undefined && paramsData.isBreezeway && paramsData.cB_addStorage_check_front ) {
                            splval = parseFloat(splval) + parseFloat(buildingData.utility_front_price);
                        } 
                    }
                }
                if(splitVal.includes("height_price")!=false)
                { 
                    splval = parseFloat(splval) + parseFloat(buildingData.height_price) + parseFloat(leantoPriceCalculation.totalHeightPrice);    
                }
                
            }
            else
            {
                splval = parseFloat(splval) + parseFloat(totalPriceWithoutAdditionalItem);
            }
            finalCost  = (splval * costObj.cost) / 100;    
        }
        else if(costObj.cost_type == 'sqft' || costObj.cost_type == '2'){
            let roofPrice =  0;
            let sidePrice = 0;
            let endPrice = 0;
            let endCount = 0;
            let sideCount = 0;
            let wainscotPrice = 0
    
            if(calcfor == 'trim'){
                let widthCalc = 0
                let heightCalc = 0
                let lengthCalc = 0
                if(Object.keys(const_var.wallsData['center']).length>0){
                    if(const_var.wallsData['center'].p_b_w == 'Open' && const_var.wallsData['center'].p_f_w == 'Open' && const_var.wallsData['center'].p_l_w == 'Open' && const_var.wallsData['center'].p_r_w == 'Open'){
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.p_d) * 2 * (costObj.cost))
                        if(paramsData.p_u_c == true || paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.p_h) * 4 * (costObj.cost))
                        }
                    }
                    else{
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.p_d) * 2 * (costObj.cost))
                        
                        if(const_var.wallsData['center'].p_b_w == 'Close' && const_var.wallsData['center'].p_f_w == 'Close' && const_var.wallsData['center'].p_l_w == 'Close' && const_var.wallsData['center'].p_r_w == 'Close'){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.p_h) * 4 * (costObj.cost))                        
                        }
                        else{
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.p_h) * 4 * (costObj.cost))                        
                            if(paramsData.p_u_c == true && const_var.wallsData['center'].p_f_w == 'Close'){
                                heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.p_h) * 2 * (costObj.cost))
                            }
                            if(paramsData.cB_addStorage_check_left == true && const_var.wallsData['center'].p_r_w == 'Close'){
                                heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.p_h) * 2 * (costObj.cost))
                            }
                            if(paramsData.cB_addStorage_check_right == true && const_var.wallsData['center'].p_l_w == 'Close'){
                                heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.p_h) * 2 * (costObj.cost))
                            }
                        }
                    }
                }
                if(Object.keys(const_var.wallsData['frontLean']).length>0 && paramsData.add_front_lean==true){
                    if(const_var.wallsData['frontLean'].p_b_c_b_f_b == "Open" && const_var.wallsData['frontLean'].p_b_c_b_f_f == "Open" && const_var.wallsData['frontLean'].p_b_c_b_f_l == "Open"){
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.leanF_p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.leanF_p_d) * (costObj.cost))
                        if(paramsData.add_storage_check_front == true){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.leanF_p_h) * 2 * (costObj.cost))
                        }
                    }
                    else{
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.leanF_p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.leanF_p_d) * (costObj.cost))
                        heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.leanF_p_h) * 2 * (costObj.cost))
                        if(paramsData.add_storage_check_front == true && const_var.wallsData['frontLean'].p_b_c_b_f_f == 'Close'){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.leanF_p_h) * (costObj.cost))
                        }
                    }
                }
                if(Object.keys(const_var.wallsData['backLean']).length>0 && paramsData.add_back_lean==true){
                    if(const_var.wallsData['backLean'].p_b_c_b_b_b == "Open" && const_var.wallsData['backLean'].p_b_c_b_b_f == "Open" && const_var.wallsData['backLean'].p_b_c_b_b_l == "Open"){
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.leanB_p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.leanB_p_d) * (costObj.cost))
                        if(paramsData.add_storage_check_back == true){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.leanB_p_h) * 2 * (costObj.cost))
                        }
                    }
                    else{
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.leanB_p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.leanB_p_d) * (costObj.cost))
                        heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.leanB_p_h) * 2 * (costObj.cost))
                        if(paramsData.add_storage_check_back == true && const_var.wallsData['backLean'].p_b_c_b_b_f == 'Close'){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.leanB_p_h) * (costObj.cost))
                        }
                    }
                }
                if(Object.keys(const_var.wallsData['leftLean']).length>0 && paramsData.add_left_lean==true){
                    if(const_var.wallsData['leftLean'].p_b_c_b_l_b == "Open" && const_var.wallsData['leftLean'].p_b_c_b_l_f == "Open" && const_var.wallsData['leftLean'].p_b_c_b_l == "Open"){
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.lean_p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.lean_p_d) * (costObj.cost))
                        if(paramsData.add_storage_check == true){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.lean_p_h) * 2 * (costObj.cost))
                        }
                    }
                    else{
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.lean_p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.lean_p_d) * (costObj.cost))
                        heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.lean_p_h) * 2 * (costObj.cost))
                        if(paramsData.add_storage_check == true && const_var.wallsData['leftLean'].p_b_c_b_l_f == 'Close'){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.lean_p_h) * (costObj.cost))
                        }
                    }
                }
                if(Object.keys(const_var.wallsData['rightLean']).length>0 && paramsData.add_right_lean==true){
                    if(const_var.wallsData['rightLean'].p_b_c_b_r_b == "Open" && const_var.wallsData['rightLean'].p_b_c_b_r_f == "Open" && const_var.wallsData['rightLean'].p_b_c_b_r == "Open"){
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.leanR_p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.leanR_p_d) * (costObj.cost))
                        if(paramsData.add_storage_check_right == true){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.leanR_p_h) * 2 * (costObj.cost))
                        }
                    }
                    else{
                        widthCalc = parseFloat(widthCalc) + (parseFloat(paramsData.leanR_p_w) * 2 * (costObj.cost))
                        lengthCalc = parseFloat(lengthCalc) + (parseFloat(paramsData.leanR_p_d) * (costObj.cost))
                        heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.leanR_p_h) * 2 * (costObj.cost))
                        if(paramsData.add_storage_check_right == true && const_var.wallsData['rightLean'].p_b_c_b_r_f == 'Close'){
                            heightCalc = parseFloat(heightCalc) + (parseFloat(paramsData.leanR_p_h) * (costObj.cost))
                        }
                    }
                }
                let trimfinalCost = parseFloat(widthCalc) + parseFloat(lengthCalc) + parseFloat(heightCalc)
                return convertToTwoDecimalNumber(trimfinalCost)
            }
            else{
                if(Object.keys(const_var.wallsData['center']).length>0)
                {
                    if(calcfor == 'wainscot'){
                        let fullClosedWidthCalc = 0;
                        let fullClosedLengthCalc = 0;
                        if(paramsData.p_u_c == true){                                              
                            fullClosedLengthCalc = parseFloat(const_var.wallsData['center'].p_l_w == 'Close' ? paramsData.p_d : (paramsData.add_storage_check && parseFloat(paramsData.add_storage) > parseFloat(paramsData.p_u_t) ? 0 : paramsData.p_u_t)) + parseFloat(const_var.wallsData['center'].p_r_w == 'Close' ? paramsData.p_d : (paramsData.add_storage_check_right == true && parseFloat(paramsData.add_storage_right) > parseFloat(paramsData.p_u_t) ? 0 : paramsData.p_u_t))
                            fullClosedWidthCalc = parseFloat(const_var.wallsData['center'].p_f_w == 'Close' ? paramsData.p_w : 0) + parseFloat(const_var.wallsData['center'].p_b_w == 'Close' ? paramsData.p_w : 0) + (paramsData.p_w)
                        }
                        else if(paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true) {
                            fullClosedLengthCalc = parseFloat(const_var.wallsData['center'].p_l_w == 'Close' ? paramsData.p_d : 0) + parseFloat(const_var.wallsData['center'].p_r_w == 'Close' ? paramsData.p_d : 0) + parseFloat(paramsData.p_d)

                            // let storageValue = paramsData.cB_addStorage_check_left ? (paramsData.add_storage_check_front == true && parseFloat(paramsData.add_storage_front) > parseFloat(paramsData.cB_addStorage_left) ? 0 : parseFloat(paramsData.cB_addStorage_left)) : (paramsData.add_storage_check_back == true && parseFloat(paramsData.add_storage_back) > parseFloat(paramsData.cB_addStorage_right) ? 0 : parseFloat(paramsData.cB_addStorage_right))
                           
                            // fullClosedWidthCalc = parseFloat(const_var.wallsData['center'].p_f_w == 'Close' ? paramsData.p_w : storageValue) + parseFloat(const_var.wallsData['center'].p_b_w == 'Close' ? paramsData.p_w : storageValue)
                            
                            if(paramsData.cB_addStorage_check_left == true){
                                fullClosedWidthCalc = parseFloat(const_var.wallsData['center'].p_f_w == 'Close' ? paramsData.p_w : (paramsData.add_storage_check_front == true && parseFloat(paramsData.add_storage_front) > parseFloat(paramsData.cB_addStorage_left) ? 0 : parseFloat(paramsData.cB_addStorage_left))) + parseFloat(const_var.wallsData['center'].p_b_w == 'Close' ? paramsData.p_w : (paramsData.add_storage_check_back == true && parseFloat(paramsData.add_storage_back) > parseFloat(paramsData.cB_addStorage_left) ? 0 : parseFloat(paramsData.cB_addStorage_left)))
                            }
                            else{
                                fullClosedWidthCalc = parseFloat(const_var.wallsData['center'].p_f_w == 'Close' ? paramsData.p_w : parseFloat(paramsData.cB_addStorage_right)) + parseFloat(const_var.wallsData['center'].p_b_w == 'Close' ? paramsData.p_w : parseFloat(paramsData.cB_addStorage_right))
                                // fullClosedWidthCalc = parseFloat(const_var.wallsData['center'].p_f_w == 'Close' ? paramsData.p_w : parseFloat(paramsData.cB_addStorage_right)) + parseFloat(const_var.wallsData['center'].p_b_w == 'Close' ? paramsData.p_w : (paramsData.add_storage_check_back == true && parseFloat(paramsData.add_storage_back) > parseFloat(paramsData.cB_addStorage_right) ? 0 : parseFloat(paramsData.cB_addStorage_right)))
                            }
                            
                        }
                        else{                            
                            fullClosedLengthCalc = parseFloat(const_var.wallsData['center'].p_l_w == 'Close' ? paramsData.p_d : 0) + parseFloat(const_var.wallsData['center'].p_r_w == 'Close' ? paramsData.p_d : 0)
                            fullClosedWidthCalc = parseFloat(const_var.wallsData['center'].p_f_w == 'Close' ? paramsData.p_w : 0) + parseFloat(const_var.wallsData['center'].p_b_w == 'Close' ? paramsData.p_w : 0)
                        }
                        wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc,fullClosedLengthCalc,costObj,false)
                        // sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData['center'].closedSideWalls);
                        // endCount = parseFloat(endCount) + parseFloat(const_var.wallsData['center'].closedEndWalls);
                        
                        // sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_d) * 3 * (costObj.cost )* sideCount)); 
                        // endPrice = parseFloat(endPrice) + parseFloat((3 * (paramsData.p_w) *(costObj.cost)* endCount));
                    }
                    else{
                        if(params.p_b_t == 27 || params.p_b_t == 33){
                            let single_slope_height=(const_var.c_m_a[params.p_b_t]!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length>0 ) ? Math.floor(params.p_h-((params.p_w * params.p_r_p) / 12)) : Math.round(params.p_h-((params.p_w * params.p_r_p) / 12));

                            if(paramsData.p_u_c == true){   
                                // ########## if back storage added ########## 
                                sideCount = parseFloat(const_var.wallsData['center'].closedSideWalls)
                                endCount = parseFloat(const_var.wallsData['center'].closedEndWalls);
    
                                // roofPrice =  parseFloat(roofPrice) + parseFloat(((paramsData.p_w+1) * (paramsData.p_d) * (costObj.cost)));
                                // endPrice = parseFloat(endPrice) + parseFloat(((paramsData.p_h+1) * (paramsData.p_w) *(costObj.cost)* endCount));
                                
                                if(const_var.wallsData['center'].p_f_w == 'Open' && const_var.wallsData['center'].p_b_w == 'Open'){
                                    endPrice = parseFloat(endPrice) + parseFloat(((paramsData.p_h) * (paramsData.p_w) *(costObj.cost)* endCount));                                
                                }
                                else{
                                    let storageFrontWall = parseFloat(endPrice) + parseFloat(((paramsData.p_h) * (paramsData.p_w) *(costObj.cost)));
                                    let FWall = calcWallCostUtility('backStorage','end',paramsData,const_var.wallsData['center'].p_f_w,costObj)
                                    let BWall = (calcWallCostUtility('backStorage','end',paramsData,const_var.wallsData['center'].p_b_w,costObj))
                                    
                                    endPrice = parseFloat(endPrice) + FWall + BWall + parseFloat(storageFrontWall)              
                                }
                                if(const_var.wallsData['center'].p_l_w == 'Open' && const_var.wallsData['center'].p_r_w == 'Open'){
                                    // ########## if left & right wall of center building is not open ########## 
                                    // sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_u_t) * (paramsData.p_h) * (costObj.cost )* sideCount)); 
                                    sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_u_t) * parseFloat(single_slope_height) * (costObj.cost )));
                                    
                                    sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_u_t) * (paramsData.p_h) * (costObj.cost ))); 
                                    
                                }
                                else{
                                    sidePrice = parseFloat(sidePrice) + (calcWallCostUtility('backStorage','side',paramsData,const_var.wallsData['center'].p_l_w,costObj,0,0,0,single_slope_height,true)) + (calcWallCostUtility('backStorage','side',paramsData,const_var.wallsData['center'].p_r_w,costObj))
                                }
                            }
                            else if(paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true) {
                                // ########## when left/right storage is added ########## 
                                sideCount = parseFloat(const_var.wallsData['center'].closedSideWalls)
                                endCount = parseFloat(const_var.wallsData['center'].closedEndWalls);
                                // roofPrice =  parseFloat(roofPrice) + parseFloat(((paramsData.p_w+1) * (paramsData.p_d) * (costObj.cost)));
        
                                let exactCalculation = 0; // ########## variable to store higher height/ pitch height ########## 
                                let storageValue = paramsData.cB_addStorage_check_left ? paramsData.cB_addStorage_left : paramsData.cB_addStorage_right
                                if(parseInt(storageValue)> (paramsData.p_w/2))
                                {
                                    // exactCalculation = parseInt(paramsData.p_h)+ parseInt(paramsData.p_r_p);
                                    exactCalculation = parseInt(Math.round(params.p_h-params.p_r_p)+(Math.ceil(((params.p_r_p/(params.p_w))*parseFloat(storageValue)))));
                                }else
                                {
                                    // exactCalculation = parseInt(paramsData.p_h+(Math.ceil(((paramsData.p_r_p/(paramsData.p_w/2))*storageValue))))
                                    exactCalculation = parseInt(Math.round(params.p_h-params.p_r_p)+(Math.ceil(((params.p_r_p/(params.p_w))*parseFloat(storageValue)))))
                                }
                                let smWallCount = parseInt(sideCount) - 1;
                                if(const_var.wallsData['center'].p_f_w == 'Open' && const_var.wallsData['center'].p_b_w == 'Open'){
                                    // ########## front & right wall of center building is open ########## 
                                    
                                    endPrice = parseFloat(endPrice) + parseFloat(((paramsData.cB_addStorage_check_right == true ? paramsData.p_h : exactCalculation) * (storageValue) *(costObj.cost)* endCount));
                                    // ########## for smaller side ########## 
                                    sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_d) * (paramsData.cB_addStorage_check_right == true ? paramsData.p_h : single_slope_height) * (costObj.cost ))); 

                                    // fro left/right wall
                                    let wallsidePrice = paramsData.cB_addStorage_check_right == true ? calcWallCostUtility('sideStorage','side',paramsData,const_var.wallsData['center'].p_l_w,costObj,storageValue,0,0,single_slope_height) : calcWallCostUtility('sideStorage','side',paramsData,const_var.wallsData['center'].p_r_w,costObj,storageValue)
                                    

                                    sidePrice = parseFloat(sidePrice) + parseFloat(wallsidePrice)
                                    // ########## for higher side ##########                         
                                    sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_d) * (exactCalculation) * (costObj.cost ))); 

                                }
                                else{
                                    let LeftWall = calcWallCostUtility('sideStorage','side',paramsData,const_var.wallsData['center'].p_l_w,costObj,storageValue,0,0,single_slope_height)
                                    let RightWall = calcWallCostUtility('sideStorage','side',paramsData,const_var.wallsData['center'].p_r_w,costObj,storageValue)
        
        
                                    let FrontWall = calcWallCostUtility('sideStorage','end',paramsData,const_var.wallsData['center'].p_f_w,costObj,storageValue)
                                    let BackWall = calcWallCostUtility('sideStorage','end',paramsData,const_var.wallsData['center'].p_b_w,costObj,storageValue)
                                    
                                    let pitchHeightCalc = parseFloat(((paramsData.p_d) * (exactCalculation) * (costObj.cost ))); 
        
                                    sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall) +  parseFloat(RightWall) + parseFloat(pitchHeightCalc)
                                    endPrice = parseFloat(endPrice) + parseFloat(FrontWall) +  parseFloat(BackWall)
                                }
                            }
                            else{

                                let endWallCost = (const_var.wallsData['center'].p_f_w != "Open" ? calcWallCost(paramsData,'end',const_var.wallsData['center'].p_f_w,costObj,'') : 0) + (const_var.wallsData['center'].p_b_w != "Open" ? calcWallCost(paramsData,'end',const_var.wallsData['center'].p_b_w,costObj) : 0);
        
                                
                                let sideWallCost = (const_var.wallsData['center'].p_l_w != "Open" ? calcWallCost(paramsData,'side',const_var.wallsData['center'].p_l_w,costObj,'','',single_slope_height) : 0) + (const_var.wallsData['center'].p_r_w != "Open" ? calcWallCost(paramsData,'side',const_var.wallsData['center'].p_r_w,costObj) : 0);
                                // ########## when no storage is added ########## 
                                sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData['center'].closedSideWalls);
                                endCount = parseFloat(endCount) + parseFloat(const_var.wallsData['center'].closedEndWalls);
                                // roofPrice =  parseFloat(roofPrice) + parseFloat(((paramsData.p_w+1) * (paramsData.p_d) * (costObj.cost)));
                                sidePrice = parseFloat(sidePrice) + sideWallCost; 
                                endPrice = parseFloat(endPrice) + endWallCost;  
                            }
                        }
                        else{
                            if(paramsData.p_u_c == true){
                                // ########## if back storage added ########## 
                                sideCount = parseFloat(const_var.wallsData['center'].closedSideWalls)
                                endCount = parseFloat(const_var.wallsData['center'].closedEndWalls);
    
                                // roofPrice =  parseFloat(roofPrice) + parseFloat(((paramsData.p_w+1) * (paramsData.p_d) * (costObj.cost)));
                                // endPrice = parseFloat(endPrice) + parseFloat(((paramsData.p_h+1) * (paramsData.p_w) *(costObj.cost)* endCount));
                                
                                if(const_var.wallsData['center'].p_f_w == 'Open' && const_var.wallsData['center'].p_b_w == 'Open'){
                                    if((params.m_s_n == 93)){
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.p_h+(1.5)) * (paramsData.p_w) *(costObj.cost)* endCount));
                                    }
                                    else{
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.p_h+1) * (paramsData.p_w) *(costObj.cost)* endCount));                                
                                    }
                                }
                                else{
                                    let storageFrontWall = parseFloat(endPrice) +  ((params.m_s_n == 93) ? (parseFloat(((paramsData.p_h+(1.5)) * (paramsData.p_w) *(costObj.cost)))) : (parseFloat(((paramsData.p_h+1) * (paramsData.p_w) *(costObj.cost)))));
                                    let FWall = calcWallCostUtility('backStorage','end',paramsData,const_var.wallsData['center'].p_f_w,costObj,0 , 0, 0, 0, true, 'frontwall')
                                    let BWall = (calcWallCostUtility('backStorage','end',paramsData,const_var.wallsData['center'].p_b_w,costObj,0 , 0, 0, 0, true, 'backwall'))
                                    endPrice = parseFloat(endPrice) + FWall + BWall + parseFloat(storageFrontWall)              
                                }
                                if(const_var.wallsData['center'].p_l_w == 'Open' && const_var.wallsData['center'].p_r_w == 'Open'){
                                    // ########## if left & right wall of center building is not open ########## 
                                    sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_u_t) * (paramsData.p_h) * (costObj.cost )* sideCount)); 
                                }
                                else{
                                    sidePrice = parseFloat(sidePrice) + (calcWallCostUtility('backStorage','side',paramsData,const_var.wallsData['center'].p_l_w,costObj,0 , 0, 0, 0, true, 'leftwall')) + (calcWallCostUtility('backStorage','side',paramsData,const_var.wallsData['center'].p_r_w,costObj,0 , 0, 0, 0,true,'rightwall'))
                                }
                            }
                            else if(paramsData.cB_addStorage_check_left == true || paramsData.cB_addStorage_check_right == true) {
                                // ########## when left/right storage is added ########## 
                                sideCount = parseFloat(const_var.wallsData['center'].closedSideWalls)
                                endCount = parseFloat(const_var.wallsData['center'].closedEndWalls);
                                // roofPrice =  parseFloat(roofPrice) + parseFloat(((paramsData.p_w+1) * (paramsData.p_d) * (costObj.cost)));
        
                                let exactCalculation = 0; // ########## variable to store higher height/ pitch height ########## 
                                let storageValue = paramsData.cB_addStorage_check_left ? paramsData.cB_addStorage_left : paramsData.cB_addStorage_right
                                if(parseInt(storageValue)> (paramsData.p_w/2))
                                {
                                    exactCalculation = parseInt(paramsData.p_h)+ parseInt(paramsData.p_r_p);
                                    // exactCalculation = parseInt(Math.round(params.p_h-params.p_r_p)+(Math.ceil(((params.p_r_p/(params.p_w))*parseFloat(storageValue)))));
                                }else
                                {
                                    exactCalculation = parseInt(paramsData.p_h+(Math.ceil(((paramsData.p_r_p/(paramsData.p_w/2))*storageValue))))
                                    // exactCalculation = parseInt(Math.round(params.p_h-params.p_r_p)+(Math.ceil(((params.p_r_p/(params.p_w))*parseFloat(storageValue)))))
                                }
                                let smWallCount = parseInt(sideCount) - 1;
        
                                if(const_var.wallsData['center'].p_f_w == 'Open' && const_var.wallsData['center'].p_b_w == 'Open'){
                                    // ########## front & right wall of center building is open ########## 
                                    if(params.m_s_n == 93){
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.p_h+(1.5)) * (storageValue) *(costObj.cost)* endCount));
                                    }
                                    else{
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.p_h+1) * (storageValue) *(costObj.cost)* endCount));
                                    }
                                    // ########## for smaller side ########## 
                                    sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_d) * (paramsData.p_h) * (costObj.cost ))); 
                                    // sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_d) * (paramsData.p_h) * (costObj.cost ) * (smWallCount))); 
                                    // ########## for higher side ##########                         
                                    // sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_d) * (exactCalculation) * (costObj.cost ))); 

 
 
 
 
 
 
                                     // // ########## for smaller side ########## 
                                     // sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_d) * (paramsData.cB_addStorage_check_right == true ? paramsData.p_h : single_slope_height) * (costObj.cost ))); 
 
                                     // fro left/right wall
                                     let wallsidePrice = paramsData.cB_addStorage_check_right == true ? calcWallCostUtility('sideStorage','side',paramsData,const_var.wallsData['center'].p_l_w,costObj,storageValue) : calcWallCostUtility('sideStorage','side',paramsData,const_var.wallsData['center'].p_r_w,costObj,storageValue)
                                     
                                     sidePrice = parseFloat(sidePrice) + parseFloat(wallsidePrice)
                                     // ########## for higher side ##########                         
                                     sidePrice = parseFloat(sidePrice) + parseFloat(((paramsData.p_d) * (exactCalculation) * (costObj.cost ))); 
                                }
                                else{
                                    let LeftWall = calcWallCostUtility('sideStorage','side',paramsData,const_var.wallsData['center'].p_l_w,costObj,storageValue)
                                    let RightWall = calcWallCostUtility('sideStorage','side',paramsData,const_var.wallsData['center'].p_r_w,costObj,storageValue)
        
        
                                    let FrontWall = calcWallCostUtility('sideStorage','end',paramsData,const_var.wallsData['center'].p_f_w,costObj,storageValue)
                                    let BackWall = calcWallCostUtility('sideStorage','end',paramsData,const_var.wallsData['center'].p_b_w,costObj,storageValue)
                                    
                                    let pitchHeightCalc = parseFloat(((paramsData.p_d) * (exactCalculation) * (costObj.cost ))); 
        
                                    sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall) +  parseFloat(RightWall) + parseFloat(pitchHeightCalc)
                                    endPrice = parseFloat(endPrice) + parseFloat(FrontWall) +  parseFloat(BackWall)
                                }
                            }
                            else{
                                let endWallCost = parseFloat(const_var.wallsData['center'].p_f_w != "Open" ? calcWallCost(paramsData,'end',const_var.wallsData['center'].p_f_w,costObj,'',0,0,true,'frontwall') : 0) + parseFloat(const_var.wallsData['center'].p_b_w != "Open" ? calcWallCost(paramsData,'end',const_var.wallsData['center'].p_b_w,costObj,'',0,0,true,'backwall') : 0);
        
                                let sideWallCost = (const_var.wallsData['center'].p_l_w != "Open" ? calcWallCost(paramsData,'side',const_var.wallsData['center'].p_l_w,costObj,'',0,0,true, 'leftwall') : 0) + (const_var.wallsData['center'].p_r_w != "Open" ? calcWallCost(paramsData,'side',const_var.wallsData['center'].p_r_w,costObj,'',0,0,true,'rightwall') : 0);


                                
                                
                                // ########## when no storage is added ########## 
                                sideCount = parseFloat(sideCount) + parseFloat(const_var.wallsData['center'].closedSideWalls);
                                endCount = parseFloat(endCount) + parseFloat(const_var.wallsData['center'].closedEndWalls);
                                // roofPrice =  parseFloat(roofPrice) + parseFloat(((paramsData.p_w+1) * (paramsData.p_d) * (costObj.cost)));
                                sidePrice = parseFloat(sidePrice) + sideWallCost; 
                                endPrice = parseFloat(endPrice) + endWallCost;  
                            }
                        }
                    }
                    roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.p_w,paramsData.p_d,costObj,paramsData)
                   
                }if(Object.keys(const_var.wallsData['frontLean']).length>0 && paramsData.add_front_lean==true)
                {
                    let leanToLength = parseInt(paramsData.leanF_p_d)
                    let wrapIncludedCount = 0
                    if(paramsData.add_right_front_lean_porch==true){
                        wrapIncludedCount = 1
                    }
                    if(paramsData.add_left_front_lean_porch==true){
                        wrapIncludedCount = parseInt(wrapIncludedCount) + 1
                    }
                    
                    if(paramsData.add_right_front_lean_porch==true){
                        // ########## right front wrap is included then will add that wrap length too ##########
                        leanToLength = parseInt(leanToLength) + parseInt(paramsData.leanR_p_w);
                    }
                    if(paramsData.add_left_front_lean_porch==true){
                        // ########## left front wrap is included then will add that wrap length too ##########
                        leanToLength = parseInt(leanToLength) + parseInt(paramsData.lean_p_w);
                    }
                    let sideLeanCount = parseFloat(const_var.wallsData['frontLean'].closedSideWalls);
                    if(calcfor == 'wainscot'){
                        let fullClosedWidthCalc = 0;
                        let fullClosedLengthCalc = 0;
                        if(paramsData.add_storage_check_front == true){   
                            fullClosedLengthCalc = (const_var.wallsData['frontLean'].p_b_c_b_f_l == 'Close' ? parseFloat(leanToLength) : parseFloat(paramsData.add_storage_front))  + (const_var.wallsData['center'].p_f_w == 'Close' ? 0 : (paramsData.cB_addStorage_check_left == true && parseFloat(paramsData.cB_addStorage_left) >= parseFloat(paramsData.add_storage_front) ? 0 : parseFloat(paramsData.add_storage_front)));
                            fullClosedWidthCalc = parseFloat(const_var.wallsData['frontLean'].p_b_c_b_f_f == 'Close' ? paramsData.leanF_p_w : 0) + parseFloat(const_var.wallsData['frontLean'].p_b_c_b_f_b == 'Close' ? paramsData.leanF_p_w : 0) + (parseFloat(paramsData.leanF_p_w))
                        }
                        else{                            
                            fullClosedLengthCalc = parseFloat(const_var.wallsData['frontLean'].p_b_c_b_f_l == 'Close' ? leanToLength : 0) 
                            fullClosedWidthCalc = parseFloat(const_var.wallsData['frontLean'].p_b_c_b_f_f == 'Close' ? paramsData.leanF_p_w : 0) + parseFloat(const_var.wallsData['frontLean'].p_b_c_b_f_b == 'Close' ? paramsData.leanF_p_w : 0)
                        }
                        wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc,fullClosedLengthCalc,costObj,true)
                    }
                    else{
                        if(const_var.wallsData['frontLean'].closedSideWalls!=0)
                        {
                            // if(calcfor == 'wainscot'){
                            //     sidePrice = parseFloat(sidePrice) + parseFloat(((leanToLength) * 3 * (costObj.cost )* sideLeanCount)); 
                            // }
                            // else{                    
                                if(paramsData.add_storage_check_front == true){
                                    // if(const_var.wallsData['center'].p_f_w != "Open" && const_var.wallsData['center'].p_f_w != '1'){
                                    if(const_var.wallsData['center'].p_f_w != "Open"){
                                        sideLeanCount = sideLeanCount - 1
                                    }
                                    let LeftWall = calcWallCostUtility('frontLeanStorage','side',paramsData,const_var.wallsData['frontLean'].p_b_c_b_f_l,costObj,paramsData.add_storage_front,leanToLength,sideLeanCount)
                                    
                                    sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall);
                                }
                                else{
                                    sidePrice = parseFloat(sidePrice) + (const_var.wallsData['frontLean'].p_b_c_b_f_l != "Open" ? calcWallCost(paramsData,'side',const_var.wallsData['frontLean'].p_b_c_b_f_l,costObj,'front',leanToLength) : 0)
                                }
                            // }
                        }
                        if(const_var.wallsData['frontLean'].closedEndWalls!=0)
                        {
                            // let endLeanCount = parseFloat(const_var.wallsData['frontLean'].closedEndWalls);
                            // if(calcfor == 'wainscot'){
                            //     endPrice = parseFloat(endPrice) + parseFloat((3 * (paramsData.leanF_p_w) *(costObj.cost)* endLeanCount));
                            // }
                            // else{
                                if(paramsData.add_storage_check_front == true){
                                    // for storage 1 end wall calc
                                    if(params.m_s_n == 93){
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.leanF_p_h+(1.5)) * (paramsData.leanF_p_w) *(costObj.cost)));
                                    }
                                    else{
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.leanF_p_h+1) * (paramsData.leanF_p_w) *(costObj.cost)));
                                    }
                                }
                                endPrice = parseFloat(endPrice) + (const_var.wallsData['frontLean'].p_b_c_b_f_f != 'Open' ? calcWallCost(paramsData,'end',const_var.wallsData['frontLean'].p_b_c_b_f_f,costObj,'front') : 0) + (const_var.wallsData['frontLean'].p_b_c_b_f_b != 'Open' ? calcWallCost(paramsData,'end',const_var.wallsData['frontLean'].p_b_c_b_f_b,costObj,'front') : 0)
                            // }
                        }
                    }
                    // roofPrice = parseFloat(roofPrice) + parseFloat(((paramsData.leanF_p_w+1) * (leanToLength) * (costObj.cost)));
                    roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.leanF_p_w,parseInt(leanToLength),costObj,paramsData, true,wrapIncludedCount)
                    // roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.leanF_p_w,(parseInt(leanToLength) + (paramsData.add_right_front_lean_porch==true ? parseInt(paramsData.leanR_p_w) : 0) + (paramsData.add_left_front_lean_porch==true ? parseInt(paramsData.lean_p_w) : 0)),costObj,paramsData, true,wrapIncludedCount)
                    
                }if(Object.keys(const_var.wallsData['backLean']).length>0 && paramsData.add_back_lean==true)
                {
                    let leanToLength = parseInt(paramsData.leanB_p_d)
                    let wrapIncludedCount = 0
                    if(paramsData.add_right_back_lean_porch==true){
                        wrapIncludedCount = 1
                    }
                    if(paramsData.add_left_back_lean_porch==true){
                        wrapIncludedCount = parseInt(wrapIncludedCount) + 1
                    }
                    
                    if(paramsData.add_right_back_lean_porch==true){
                        // ########## right back wrap is included then will add that wrap length too ##########
                        leanToLength = parseInt(leanToLength) + parseInt(paramsData.leanR_p_w)
                    }
                    if(paramsData.add_left_back_lean_porch==true){
                        // ########## left back wrap is included then will add that wrap length too ##########
                        leanToLength = parseInt(leanToLength) + parseInt(paramsData.lean_p_w)
                    }
                    let sideLeanCount = parseFloat(const_var.wallsData['backLean'].closedSideWalls);

                    if(calcfor == 'wainscot'){
                        let fullClosedWidthCalc = 0;
                        let fullClosedLengthCalc = 0;
                        if(paramsData.add_storage_check_back == true){   
                            fullClosedLengthCalc = (const_var.wallsData['backLean'].p_b_c_b_b_l == 'Close' ? parseFloat(leanToLength) : parseFloat(paramsData.add_storage_back))  + (const_var.wallsData['center'].p_b_w == 'Close' ? 0 :  (paramsData.cB_addStorage_check_left == true && parseFloat(paramsData.cB_addStorage_left) >= parseFloat(paramsData.add_storage_back) ? 0 : parseFloat(paramsData.add_storage_back)));
                            fullClosedWidthCalc = parseFloat(const_var.wallsData['backLean'].p_b_c_b_b_f == 'Close' ? paramsData.leanB_p_w : 0) + parseFloat(const_var.wallsData['backLean'].p_b_c_b_b_b == 'Close' ? paramsData.leanB_p_w : 0) + (parseFloat(paramsData.leanB_p_w))
                        }
                        else{                            
                            fullClosedLengthCalc = parseFloat(const_var.wallsData['backLean'].p_b_c_b_b_l == 'Close' ? leanToLength : 0) 
                            fullClosedWidthCalc = parseFloat(const_var.wallsData['backLean'].p_b_c_b_b_f == 'Close' ? paramsData.leanB_p_w : 0) + parseFloat(const_var.wallsData['backLean'].p_b_c_b_b_b == 'Close' ? paramsData.leanB_p_w : 0)
                        }
                        wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc,fullClosedLengthCalc,costObj,true)
                    }
                    else{
                        if(const_var.wallsData['backLean'].closedSideWalls!=0)
                        {
                            // if(calcfor == 'wainscot'){
                            //     sidePrice = parseFloat(sidePrice) + parseFloat(((leanToLength) * 3 * (costObj.cost )* sideLeanCount)); 
                            // }
                            // else{       
                                // if((const_var.wallsData['center'].p_b_w != "Open" && const_var.wallsData['center'].p_b_w != '1') || paramsData.p_u_c == true){
                                if((const_var.wallsData['center'].p_b_w != "Open") || paramsData.p_u_c == true){
                                    sideLeanCount = sideLeanCount - 1
                                }         
                                if(paramsData.add_storage_check_back == true){
                                    let LeftWall = calcWallCostUtility('backLeanStorage','side',paramsData,const_var.wallsData['backLean'].p_b_c_b_b_l,costObj,paramsData.add_storage_back,leanToLength,sideLeanCount)
        
                                    sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall);
                                }
                                else{ 
                                    sidePrice = parseFloat(sidePrice) + (const_var.wallsData['backLean'].p_b_c_b_b_l != 'Open' ? calcWallCost(paramsData,'side',const_var.wallsData['backLean'].p_b_c_b_b_l,costObj,'back',leanToLength) : 0) ; 
                                }
                            // }
                        }
                        if(const_var.wallsData['backLean'].closedEndWalls!=0)
                        {
                            // let endLeanCount = parseFloat(const_var.wallsData['backLean'].closedEndWalls);
                            // if(calcfor == 'wainscot'){
                            //     endPrice = parseFloat(endPrice) + parseFloat((3 * (paramsData.leanB_p_w) *(costObj.cost)* endLeanCount));
                            // }
                            // else{
                                if(paramsData.add_storage_check_back == true){
                                    // for storage 1 end wall calc
                                    if(params.m_s_n == 93){
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.leanB_p_h+(1.5)) * (paramsData.leanB_p_w) *(costObj.cost)));
                                    }
                                    else{
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.leanB_p_h+1) * (paramsData.leanB_p_w) *(costObj.cost)));
                                    }
                                }
                                endPrice = parseFloat(endPrice) + (const_var.wallsData['backLean'].p_b_c_b_b_f != 'Open' ? calcWallCost(paramsData,'end',const_var.wallsData['backLean'].p_b_c_b_b_f,costObj,'back') : 0) + (const_var.wallsData['backLean'].p_b_c_b_b_b != 'Open' ? calcWallCost(paramsData,'end',const_var.wallsData['backLean'].p_b_c_b_b_b,costObj,'back') : 0);
                            // }
                        }
                    }
                    // roofPrice = parseFloat(roofPrice) + parseFloat(((paramsData.leanB_p_w+1) * (leanToLength) * (costObj.cost)));
                    roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.leanB_p_w,parseInt(leanToLength),costObj,paramsData, true,wrapIncludedCount)
                    // roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.leanB_p_w,(parseInt(leanToLength) + (paramsData.add_right_back_lean_porch==true ? parseInt(paramsData.leanR_p_w) : 0) + (paramsData.add_left_back_lean_porch==true ? parseInt(paramsData.lean_p_w) : 0)),costObj,paramsData, true,wrapIncludedCount)
                }if(Object.keys(const_var.wallsData['leftLean']).length>0 && paramsData.add_left_lean==true)
                {
                    let leanToLength = paramsData.lean_p_d
                    let wrapIncludedCount = 0
                    if(paramsData.add_left_front_lean_porch==true){
                        wrapIncludedCount = 1
                    }
                    if(paramsData.add_left_back_lean_porch==true){
                        wrapIncludedCount = parseInt(wrapIncludedCount) + 1
                    }
                    if(paramsData.add_left_front_lean_porch==true){
                        // ########## left front wrap is included then will add that wrap length too ##########
                        leanToLength = leanToLength + parseInt(paramsData.leanF_p_w);
                    }
                    if(paramsData.add_left_back_lean_porch==true){
                        // ########## left back wrap is included then will add that wrap length too ##########
                        leanToLength = leanToLength + parseInt(paramsData.leanB_p_w);
                    }
                    let sideLeanCount = parseFloat(const_var.wallsData['leftLean'].closedSideWalls);

                    if(calcfor == 'wainscot'){
                        let fullClosedWidthCalc = 0;
                        let fullClosedLengthCalc = 0;
                        if(paramsData.add_storage_check == true){   
                            fullClosedLengthCalc = (const_var.wallsData['leftLean'].p_b_c_b_l == 'Close' ? parseFloat(leanToLength) : parseFloat(paramsData.add_storage))  + (const_var.wallsData['center'].p_l_w == 'Close' ? 0 : (paramsData.p_u_c == true && parseInt(paramsData.p_u_t) >= parseInt(paramsData.add_storage) ? 0 : (paramsData.cB_addStorage_check_left ? parseFloat(paramsData.cB_addStorage_left) : parseFloat(paramsData.add_storage))))
                            fullClosedWidthCalc = (const_var.wallsData['leftLean'].p_b_c_b_l_f == 'Close' ? paramsData.lean_p_w : 0) + (const_var.wallsData['leftLean'].p_b_c_b_l_b == 'Close' ? paramsData.lean_p_w : 0) + (parseFloat(paramsData.lean_p_w))
                        }
                        else{                            
                            fullClosedLengthCalc = (const_var.wallsData['leftLean'].p_b_c_b_l == 'Close' ? leanToLength : 0) 
                            fullClosedWidthCalc = (const_var.wallsData['leftLean'].p_b_c_b_l_f == 'Close' ? paramsData.lean_p_w : 0) + (const_var.wallsData['leftLean'].p_b_c_b_l_b == 'Close' ? paramsData.lean_p_w : 0)
                        }
                        wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc,fullClosedLengthCalc,costObj,true)
                    }
                    else{
                        if(const_var.wallsData['leftLean'].closedSideWalls!=0)
                        {
                            // if(calcfor == 'wainscot'){
                            //     sidePrice = parseFloat(sidePrice) + parseFloat(((leanToLength) * 3 * (costObj.cost )* sideLeanCount)); 
                            // }
                            // else{
                                // if((const_var.wallsData['center'].p_l_w != "Open" && const_var.wallsData['center'].p_l_w != '1') || paramsData.p_u_c == true || paramsData.cB_addStorage_check_left == true){
                                if((const_var.wallsData['center'].p_l_w != "Open") || paramsData.p_u_c == true || paramsData.cB_addStorage_check_left == true){
                                    sideLeanCount = sideLeanCount - 1
                                }         
                                if(paramsData.add_storage_check == true){
                                    let LeftWall = calcWallCostUtility('leftLeanStorage','side',paramsData,const_var.wallsData['leftLean'].p_b_c_b_l,costObj,paramsData.add_storage,leanToLength,sideLeanCount) 
                                    sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall);
                                }
                                else{
                                    sidePrice = parseFloat(sidePrice) + (const_var.wallsData['leftLean'].p_b_c_b_l != 'Open' ? calcWallCost(paramsData,'side',const_var.wallsData['leftLean'].p_b_c_b_l,costObj,'left',leanToLength) : 0) ; 
                                }
                            // }
                        }
                        if(const_var.wallsData['leftLean'].closedEndWalls!=0)
                        {
                            // let endLeanCount = parseFloat(const_var.wallsData['leftLean'].closedEndWalls);
                            // if(calcfor == 'wainscot'){
                            //     endPrice = parseFloat(endPrice) + parseFloat((3 * (paramsData.lean_p_w) *(costObj.cost)* endLeanCount));
                            // }
                            // else{
                                if(paramsData.add_storage_check == true){
                                    // for storage 1 end wall calc
                                    if(params.m_s_n == 93){
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.lean_p_h+(1.5)) * (paramsData.lean_p_w) *(costObj.cost)));
                                    }
                                    else{
                                        endPrice = parseFloat(endPrice) + parseFloat(((paramsData.lean_p_h+1) * (paramsData.lean_p_w) *(costObj.cost)));
                                    }
                                }
        
                                endPrice = parseFloat(endPrice) + (const_var.wallsData['leftLean'].p_b_c_b_l_f != 'Open' ? calcWallCost(paramsData,'end',const_var.wallsData['leftLean'].p_b_c_b_l_f,costObj,'left') : 0) + (const_var.wallsData['leftLean'].p_b_c_b_l_b != 'Open' ? calcWallCost(paramsData,'end',const_var.wallsData['leftLean'].p_b_c_b_l_b,costObj,'left') : 0);
                            // }
                        }
                    }
                    // roofPrice = parseFloat(roofPrice) + parseFloat(((paramsData.lean_p_w+1) * (leanToLength) * (costObj.cost)));
                    roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.lean_p_w,parseInt(leanToLength),costObj,paramsData, true, wrapIncludedCount)
                    // roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.lean_p_w,(parseInt(leanToLength) + (paramsData.add_left_front_lean_porch==true ? parseInt(paramsData.leanF_p_w) : 0) + (paramsData.add_left_back_lean_porch==true ? parseInt(paramsData.leanB_p_w) : 0)),costObj,paramsData, true, wrapIncludedCount)
                    
                }if(Object.keys(const_var.wallsData['rightLean']).length>0 && paramsData.add_right_lean==true)
                {
                    let leanToLength = parseInt(paramsData.leanR_p_d)
                    let wrapIncludedCount = 0
                    if(paramsData.add_right_front_lean_porch==true){
                        wrapIncludedCount = 1
                    }
                    if(paramsData.add_right_back_lean_porch==true){
                        wrapIncludedCount = parseInt(wrapIncludedCount) + 1
                    }
                    if(paramsData.add_right_front_lean_porch==true){
                        // ########## right front wrap is included then will add that wrap length too ##########
                        leanToLength = leanToLength + parseInt(paramsData.leanF_p_w)
                    }
                    if(paramsData.add_right_back_lean_porch==true){
                        // ########## right back wrap is included then will add that wrap length too ##########
                        leanToLength = leanToLength + parseInt(paramsData.leanB_p_w)
                    }
                    let sideLeanCount = parseFloat(const_var.wallsData['rightLean'].closedSideWalls);
                    
                    if(calcfor == 'wainscot'){
                        let fullClosedWidthCalc = 0;
                        let fullClosedLengthCalc = 0;
                        if(paramsData.add_storage_check_right == true){   
                            fullClosedLengthCalc = (const_var.wallsData['rightLean'].p_b_c_b_r == 'Close' ? parseFloat(leanToLength) : parseFloat(paramsData.add_storage_right))  + parseFloat(const_var.wallsData['center'].p_r_w == 'Close' ? 0 : (paramsData.p_u_c == true && parseFloat(paramsData.p_u_t) >= parseFloat(paramsData.add_storage_right) ? 0 : (paramsData.cB_addStorage_check_right == true ? parseFloat(paramsData.cB_addStorage_right) : parseFloat(paramsData.add_storage_right))));
                            fullClosedWidthCalc = parseFloat(const_var.wallsData['rightLean'].p_b_c_b_r_f == 'Close' ? paramsData.leanR_p_w : 0) + parseFloat(const_var.wallsData['rightLean'].p_b_c_b_r_b == 'Close' ? paramsData.leanR_p_w : 0) + (parseFloat(paramsData.leanR_p_w))
                        }
                        else{                            
                            fullClosedLengthCalc = parseFloat(const_var.wallsData['rightLean'].p_b_c_b_r == 'Close' ? leanToLength : 0) 
                            fullClosedWidthCalc = parseFloat(const_var.wallsData['rightLean'].p_b_c_b_r_f == 'Close' ? paramsData.leanR_p_w : 0) + parseFloat(const_var.wallsData['rightLean'].p_b_c_b_r_b == 'Close' ? paramsData.leanR_p_w : 0)
                        }
                        wainscotPrice = parseFloat(wainscotPrice) + calcWainscotPrice(fullClosedWidthCalc,fullClosedLengthCalc,costObj,true)
                    }
                    else{
                        if(const_var.wallsData['rightLean'].closedSideWalls!=0)
                        {
                            // if(calcfor == 'wainscot'){
                            //     sidePrice = parseFloat(sidePrice) + parseFloat(((leanToLength) * 3 * (costObj.cost )* sideLeanCount)); 
                            // }
                            // else{                       
                                // if((const_var.wallsData['center'].p_r_w != "Open" && const_var.wallsData['center'].p_r_w != '1') || (paramsData.p_u_c == true || paramsData.cB_addStorage_check_right == true)){
                                if((const_var.wallsData['center'].p_r_w != "Open") || (paramsData.p_u_c == true || paramsData.cB_addStorage_check_right == true)){
                                    sideLeanCount = sideLeanCount - 1
                                }   
                                if(paramsData.add_storage_check_right == true){
                                    
                                    let LeftWall = calcWallCostUtility('rightLeanStorage','side',paramsData,const_var.wallsData['rightLean'].p_b_c_b_r,costObj,paramsData.add_storage_right,leanToLength,sideLeanCount)
        
                                    sidePrice = parseFloat(sidePrice) + parseFloat(LeftWall);
                                }
                                else{ 
                                    sidePrice = parseFloat(sidePrice) + (const_var.wallsData['rightLean'].p_b_c_b_r != 'Open' ? calcWallCost(paramsData,'side',const_var.wallsData['rightLean'].p_b_c_b_r,costObj,'right',leanToLength) : 0) ; 
                                }
                            // }
                        }
                        if(const_var.wallsData['rightLean'].closedEndWalls!=0)
                        {
                            // let endLeanCount = parseFloat(const_var.wallsData['rightLean'].closedEndWalls);
                            // if(calcfor == 'wainscot'){
                            //     endPrice = parseFloat(endPrice) + parseFloat((3 * (paramsData.leanR_p_w) *(costObj.cost)* endLeanCount));
                            // }
                            // else{
                                if(paramsData.add_storage_check_right == true){
                                    // for storage 1 end wall calc
                                    if(params.m_s_n == 93){
                                        endPrice =  parseFloat(endPrice) + parseFloat(((paramsData.leanR_p_h+(1.5)) * (paramsData.leanR_p_w) *(costObj.cost)));
                                    }
                                    else{
                                        endPrice =  parseFloat(endPrice) + parseFloat(((paramsData.leanR_p_h+1) * (paramsData.leanR_p_w) *(costObj.cost)));
                                    }
                                }
                                endPrice = parseFloat(endPrice) + (const_var.wallsData['rightLean'].p_b_c_b_r_f != 'Open' ? calcWallCost(paramsData,'end',const_var.wallsData['rightLean'].p_b_c_b_r_f,costObj,'right') : 0) + (const_var.wallsData['rightLean'].p_b_c_b_r_b != 'Open' ? calcWallCost(paramsData,'end',const_var.wallsData['rightLean'].p_b_c_b_r_b,costObj,'right') : 0);
                            // }
                        }
                    }
                    // roofPrice = parseFloat(roofPrice) + parseFloat(((paramsData.leanR_p_w+1) * (leanToLength) * (costObj.cost)));
                    roofPrice = parseFloat(roofPrice) + calcRoofColorPrice(paramsData.leanR_p_w,parseInt(leanToLength),costObj,paramsData, true, wrapIncludedCount)
                }
            }
    
            if(calcfor == 'roof'){
                // ########## Calculate for roof color ########## 
                finalCost=parseFloat(roofPrice) 
            }
            else if(calcfor == 'wall'){
                // ########## Calculate for wall color ########## 
                finalCost=parseFloat(sidePrice) + parseFloat(endPrice);
            }
            else if(calcfor == 'wainscot'){
                // ########## Calculate for wainscot color ########## 
                finalCost=parseFloat(wainscotPrice);
            }
            else{
                finalCost=parseFloat(roofPrice) + parseFloat(sidePrice) + parseFloat(endPrice);
            }
        }
        else{
            finalCost = costObj.cost
        }
    }    
    return convertToTwoDecimalNumber(finalCost)
}

// ########## funtcion to calculate individual wall price ########## 
// panel is their in sides only gable/extended gable is not their
// panel is not their in ends only gable/extended gable can be their
// no extended gable is their for lean to 
function calcWallCost(paramsData,calcfor,wall,costObj, isLean='',leanToLength, lowerHeight = 0,isCenterBuidling= false, wallname= ''){
    let Price = 0
    // center building side wall calculation
    if(calcfor == 'side' && isLean == ''){
        let exactHeight = lowerHeight != 0 ? lowerHeight : paramsData.p_h
        let exactLength = paramsData.p_d
        // when left lean to storage is their
        if(isCenterBuidling == true && wall != 'Close' && wallname == 'leftwall' && paramsData.add_storage_check == true){
            Price = parseFloat((paramsData.add_storage) * (exactHeight) * (costObj.cost ))
            exactLength = parseFloat(paramsData.p_d) - parseFloat(paramsData.add_storage)
        }
        // when right lean to storage is their
        if(isCenterBuidling == true && wall != 'Close' && wallname == 'rightwall' && paramsData.add_storage_check_right == true){
            Price = parseFloat((paramsData.add_storage_right) * (exactHeight) * (costObj.cost ))
            exactLength = parseFloat(paramsData.p_d) - parseFloat(paramsData.add_storage_right)
        }
        if(wall=="One_Fourth_Close"){
            Price = parseFloat(Price) + parseFloat(((exactLength) * (1/4*parseInt(exactHeight)) * (costObj.cost ))); 
        }
        else if(wall=="Half_Close"){
            Price = parseFloat(Price) + parseFloat(((exactLength) * (1/2*parseInt(exactHeight)) * (costObj.cost ))); 
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat(Price) + parseFloat(((exactLength) * (3/4*parseInt(exactHeight)) * (costObj.cost ))); 
        }
        else if(wall != "Close"){
            Price = parseFloat(Price) + parseFloat(((exactLength) * (parseInt(wall) * 3) * (costObj.cost ))); 
        }
        else{
            Price = parseFloat(Price) + parseFloat(((exactLength) * (exactHeight) * (costObj.cost ))); 
            
        }
    }
    // center building end wall calculation
    if(calcfor == 'end' && isLean == ''){
        let actualWidth = paramsData.p_w
        // when front lean to storage is their
        if(isCenterBuidling == true && wall != 'Close' && wallname == 'frontwall' && paramsData.add_storage_check_front == true){
            // Price = parseFloat((paramsData.add_storage_front) * (exactHeight) * (costObj.cost ))
            if(params.m_s_n == 93){
                Price = parseFloat(((parseInt(paramsData.p_h)+(1.5)) * (paramsData.add_storage_front) *(costObj.cost))); 
            }
            else{
                Price = parseFloat(((parseInt(paramsData.p_h)+1) * (paramsData.add_storage_front) *(costObj.cost))); 
            }
            actualWidth = paramsData.p_w -  paramsData.add_storage_front
        }
        // when back lean to storage is their
        if(isCenterBuidling == true && wall != 'Close' && wallname == 'backwall' && paramsData.add_storage_check_back == true){
            if(params.m_s_n == 93){
                Price = parseFloat(((parseInt(paramsData.p_h)+(1.5)) * (paramsData.add_storage_back) *(costObj.cost))); 
            }
            else{
                Price = parseFloat(((parseInt(paramsData.p_h)+1) * (paramsData.add_storage_back) *(costObj.cost))); 
            }
            actualWidth = paramsData.p_w -  paramsData.add_storage_back
        }        
        if(wall=="Extended Gable" ){
            Price = parseFloat(Price) + parseFloat(((6) * (actualWidth) *(costObj.cost)));   
        }
        else if(wall=="Gable"){
            Price = parseFloat(Price) + parseFloat(((3) * (actualWidth) *(costObj.cost))); 
        }
        else if(wall=="One_Fourth_Close"){
            Price = parseFloat(Price) + parseFloat(((1/4*parseInt(paramsData.p_h)) * (actualWidth) *(costObj.cost)));   
        }
        else if(wall=="Half_Close"){
            Price = parseFloat(Price) + parseFloat(((1/2*parseInt(paramsData.p_h)) * (actualWidth) *(costObj.cost)));   
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat(Price) + parseFloat(((3/4*parseInt(paramsData.p_h)) * (actualWidth) *(costObj.cost)));  
        }
        else{
            if(params.p_b_t == 27 || params.p_b_t == 33){
                Price = parseFloat(((parseInt(paramsData.p_h)) * (paramsData.p_w) *(costObj.cost)));  
            }
            else{
                if(params.m_s_n == 93){
                    Price = parseFloat(Price) + parseFloat(((parseInt(paramsData.p_h)+(1.5)) * (actualWidth) *(costObj.cost)));  
                }
                else{
                    Price = parseFloat(Price) + parseFloat(((parseInt(paramsData.p_h)+1) * (actualWidth) *(costObj.cost)));  
                }
            }
        }   
    }
    // front lean-to side wall calculation
    if(calcfor == 'side' && isLean == 'front'){
        if(wall=="One_Fourth_Close"){
            Price = parseFloat(((leanToLength) * (1/4 * parseInt(paramsData.leanF_p_h)) * (costObj.cost )))
        }
        else if(wall=="Half_Close"){
            Price = parseFloat(((leanToLength) * (1/2 * parseInt(paramsData.leanF_p_h)) * (costObj.cost ))) 
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat(((leanToLength) * (3/4 * parseInt(paramsData.leanF_p_h)) * (costObj.cost )))
        }
        else if(wall != "Close"){
            Price = parseFloat(((leanToLength) * (parseInt(wall) * 3) * (costObj.cost )))
        }
        else{
            Price = parseFloat(((leanToLength) * (paramsData.leanF_p_h) * (costObj.cost )))
        }   
    }
    // front lean-to end wall calculation
    if(calcfor == 'end' && isLean == 'front'){
        if(wall=="Extended Gable" ){
            Price = parseFloat(((6) * (paramsData.leanF_p_w) *(costObj.cost)));
        }
        else if(wall=="Gable"){
            Price = parseFloat(((3) * (paramsData.leanF_p_w) *(costObj.cost)));
        }
        else if(wall=="One_Fourth_Close"){
            Price = parseFloat((1/4*parseInt(paramsData.leanF_p_h) * (paramsData.leanF_p_w) *(costObj.cost)));
        }
        else if(wall=="Half_Close"){
            Price = parseFloat((1/2 * parseInt(paramsData.leanF_p_h) * (paramsData.leanF_p_w) *(costObj.cost)));
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat((3/4 * parseInt(paramsData.leanF_p_h) * (paramsData.leanF_p_w) *(costObj.cost)));
        }
        else{
            if(params.p_b_t == 27 || params.p_b_t == 33){
                Price = parseFloat(((paramsData.leanF_p_h) * (paramsData.leanF_p_w) *(costObj.cost)));
            }
            else{
                if(params.m_s_n == 93){
                    Price = parseFloat(((paramsData.leanF_p_h+(1.5)) * (paramsData.leanF_p_w) *(costObj.cost)));
                }
                else{
                    Price = parseFloat(((paramsData.leanF_p_h+1) * (paramsData.leanF_p_w) *(costObj.cost)));
                }
            }
        }   
    }
    // back lean-to side wall calculation
    if(calcfor == 'side' && isLean == 'back'){
        if(wall=="One_Fourth_Close"){
            Price = parseFloat(((leanToLength) * (1/4 * parseInt(paramsData.leanB_p_h)) * (costObj.cost )))
        }
        else if(wall=="Half_Close"){
            Price = parseFloat(((leanToLength) * (1/2 * parseInt(paramsData.leanB_p_h)) * (costObj.cost ))) 
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat(((leanToLength) * (3/4 * parseInt(paramsData.leanB_p_h)) * (costObj.cost )))
        }
        else if(wall != "Close"){
            Price = parseFloat(((leanToLength) * (parseInt(wall) * 3) * (costObj.cost )));
        }
        else{
            Price = parseFloat(((leanToLength) * (paramsData.leanB_p_h) * (costObj.cost )));
        }   
    }
    // back lean-to end wall calculation
    if(calcfor == 'end' && isLean == 'back'){       
        if(wall=="Gable"){
            Price = parseFloat(((3) * (paramsData.leanB_p_w) *(costObj.cost)));
        }
        else if(wall=="One_Fourth_Close"){
            Price = parseFloat(((1/4*parseInt(paramsData.leanB_p_h)) * (paramsData.leanB_p_w) *(costObj.cost)));
        }
        else if(wall=="Half_Close"){
            Price = parseFloat(((1/2*parseInt(paramsData.leanB_p_h)) * (paramsData.leanB_p_w) *(costObj.cost)));
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat(((3/4*parseInt(paramsData.leanB_p_h)) * (paramsData.leanB_p_w) *(costObj.cost)));
        }
        else{
            if(params.p_b_t == 27 || params.p_b_t == 33){
                Price =  parseFloat(((paramsData.leanB_p_h) * (paramsData.leanB_p_w) *(costObj.cost)));
            }
            else{
                if(params.m_s_n == 93){
                    Price =  parseFloat(((paramsData.leanB_p_h+(1.5)) * (paramsData.leanB_p_w) *(costObj.cost)));
                }
                else{
                    Price =  parseFloat(((paramsData.leanB_p_h+1) * (paramsData.leanB_p_w) *(costObj.cost)));
                }
            }
        }   
    }
    // left lean-to side wall calculation
    if(calcfor == 'side' && isLean == 'left'){
        if(wall=="One_Fourth_Close"){
            Price = parseFloat(((leanToLength) * (1/4 * parseInt(paramsData.lean_p_h)) * (costObj.cost )));
        }
        else if(wall=="Half_Close"){
            Price = parseFloat(((leanToLength) * (1/2 * parseInt(paramsData.lean_p_h)) * (costObj.cost )));
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat(((leanToLength) * (3/4 * parseInt(paramsData.lean_p_h)) * (costObj.cost )));
        }
        else if(wall != "Close"){
            Price = parseFloat(((leanToLength) * (parseInt(wall) * 3) * (costObj.cost )));
        }
        else{
            Price = parseFloat(((leanToLength) * (paramsData.lean_p_h) * (costObj.cost )));
        }   
    }
    // left lean-to end wall calculation
    if(calcfor == 'end' && isLean == 'left'){
        if(wall=="Gable"){
            Price = parseFloat(((3) * (paramsData.lean_p_w) *(costObj.cost)));
        }
        else if(wall=="One_Fourth_Close"){
            Price = parseFloat(((1/4*parseInt(paramsData.lean_p_h)) * (paramsData.lean_p_w) *(costObj.cost)));
        }
        else if(wall=="Half_Close"){
            Price = parseFloat(((1/2 * parseInt(paramsData.lean_p_h)) * (paramsData.lean_p_w) *(costObj.cost)));
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat(((3/4 * parseInt(paramsData.lean_p_h)) * (paramsData.lean_p_w) *(costObj.cost)));
        }
        else{
            if(params.p_b_t == 27 || params.p_b_t == 33){
                Price = parseFloat(((paramsData.lean_p_h) * (paramsData.lean_p_w) *(costObj.cost)));
            }
            else{
                if(params.m_s_n == 93){
                    Price = parseFloat(((paramsData.lean_p_h+(1.5)) * (paramsData.lean_p_w) *(costObj.cost)));
                }
                else{
                    Price = parseFloat(((paramsData.lean_p_h+1) * (paramsData.lean_p_w) *(costObj.cost)));
                }
            }
        }   
    }
    // right lean-to side wall calculation
    if(calcfor == 'side' && isLean == 'right'){
        if(wall=="One_Fourth_Close"){
            Price = parseFloat(((leanToLength) * (1/4 * parseInt(paramsData.leanR_p_h)) * (costObj.cost )))
        }
        else if(wall=="Half_Close"){
            Price = parseFloat(((leanToLength) * (1/2 * parseInt(paramsData.leanR_p_h)) * (costObj.cost ))) 
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat(((leanToLength) * (3/4 * parseInt(paramsData.leanR_p_h)) * (costObj.cost )))
        }
        else if(wall != "Close"){
            Price = parseFloat(((leanToLength) * (parseInt(wall) * 3) * (costObj.cost )))
        }
        else{
            Price = parseFloat(((leanToLength) * (paramsData.leanR_p_h) * (costObj.cost ))); 
        }   
    }
    // right lean-to end wall calculation
    if(calcfor == 'end' && isLean == 'right'){
        if(wall=="Gable"){
            Price = parseFloat(((3) * (paramsData.leanR_p_w) *(costObj.cost)));
        }
        else if(wall=="One_Fourth_Close"){
            Price = parseFloat(((1/4 * parseInt(paramsData.leanR_p_h)) * (paramsData.leanR_p_w) *(costObj.cost)));
        }
        else if(wall=="Half_Close"){
            Price = parseFloat(((1/2 * parseInt(paramsData.leanR_p_h)) * (paramsData.leanR_p_w) *(costObj.cost)));
        }
        else if(wall=="Three_Fourth_Close"){
            Price = parseFloat(((3/4 * parseInt(paramsData.leanR_p_h)) * (paramsData.leanR_p_w) *(costObj.cost)));
        }
        else{
            if(params.p_b_t == 27 || params.p_b_t == 33){
                Price = parseFloat(((paramsData.leanR_p_h) * (paramsData.leanR_p_w) *(costObj.cost)));
            }
            else{
                if(params.m_s_n == 93){
                    Price = parseFloat(((paramsData.leanR_p_h+(1.5)) * (paramsData.leanR_p_w) *(costObj.cost)));
                }
                else{
                    Price = parseFloat(((paramsData.leanR_p_h+1) * (paramsData.leanR_p_w) *(costObj.cost)));
                }
            }
        }   
    }
    return Price
}

function calcWallCostUtility(storageType,calcfor,paramsData,wall,costObj,storageValue,leanToLength,leanCount,lowerHeight=0,isCenterBuidling= false, wallname= ''){
    let Price = 0
    // center buidling back storage
    if(storageType == 'backStorage'){
        let length = parseFloat(paramsData.p_d)
        
        let exactHeight = lowerHeight != 0 ? lowerHeight : paramsData.p_h

        if(isCenterBuidling == true && wall != 'Close' && wallname == 'rightwall' && paramsData.add_storage_check_right == true && (parseFloat(paramsData.add_storage_right) > parseInt(paramsData.p_u_t))){
            length = parseFloat(paramsData.p_d) - parseFloat(paramsData.add_storage_right)
            Price = parseFloat(Price) + parseFloat(((paramsData.add_storage_right) * (exactHeight) * (costObj.cost ))); 
        }
        else if(isCenterBuidling == true && wall != 'Close' && wallname == 'leftwall' && paramsData.add_storage_check == true && (parseFloat(paramsData.add_storage) > parseInt(paramsData.p_u_t))){
            length = parseFloat(paramsData.p_d) - parseFloat(paramsData.add_storage)
            Price = parseFloat(Price) + parseFloat(((paramsData.add_storage) * (exactHeight) * (costObj.cost ))); 
        }
        else{
            length = wall != 'Close' ? (parseInt(paramsData.p_d) - parseInt(paramsData.p_u_t)) : parseFloat(paramsData.p_d); //remaining wall length
            if(calcfor == 'side' && wall != 'Close'){
                Price = parseFloat(Price) + parseFloat(((paramsData.p_u_t) * (exactHeight) * (costObj.cost ))); 
            }
        }
        // if(calcfor == 'side' && wall != 'Close'){
        //     Price = parseFloat(Price) + parseFloat(((paramsData.p_u_t) * (exactHeight) * (costObj.cost ))); 
        // }
        // side wall calculation
        if(calcfor == 'side' && wall != 'Open'){
            if(wall=="One_Fourth_Close"){
                Price = parseFloat(Price) + parseFloat(((length) * (1/4*parseInt(exactHeight)) * (costObj.cost ))); 
            }
            else if(wall=="Half_Close"){
                Price = parseFloat(Price) + parseFloat(((length) * (1/2*parseInt(exactHeight)) * (costObj.cost ))); 
            }
            else if(wall=="Three_Fourth_Close"){
                Price = parseFloat(Price) + parseFloat(((length) * (3/4*parseInt(exactHeight)) * (costObj.cost ))); 
            }
            else if(wall != "Close"){ 
                Price = parseFloat(Price) + parseFloat(((length) * (parseInt(wall) * 3) * (costObj.cost ))); 
            }
            else{
                Price = parseFloat(Price) + parseFloat(((length) * (exactHeight) * (costObj.cost ))); 
            }
        }
        if(calcfor == 'end' && wall != 'Open'){
            // let width = wall == 'Open' ? storageValue : (wall != 'Close' ? (parseInt(paramsData.p_w) - parseInt(storageValue)) : paramsData.p_w )
            // parseFloat(endPrice) + parseFloat(((paramsData.p_h+1) * (paramsData.p_w) *(costObj.cost)* endCount));
            // if(wall != 'Open'){    
                if(wall=="Extended Gable" ){
                    Price = parseFloat(Price) + parseFloat(((6) * (paramsData.p_w) *(costObj.cost)));   
                }
                else if(wall=="Gable"){
                    Price = parseFloat(Price) + parseFloat(((3) * (paramsData.p_w) *(costObj.cost))); 
                }
                else if(wall=="One_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((1/4*parseInt(paramsData.p_h)) * (paramsData.p_w) *(costObj.cost)));   
                }
                else if(wall=="Half_Close"){
                    Price = parseFloat(Price) + parseFloat(((1/2*parseInt(paramsData.p_h)) * (paramsData.p_w) *(costObj.cost)));   
                }
                else if(wall=="Three_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((3/4*parseInt(paramsData.p_h)) * (paramsData.p_w) *(costObj.cost)));  
                }
                else{
                    if(params.p_b_t == 27 || params.p_b_t == 33){
                        Price = parseFloat(Price) + parseFloat(((parseInt(paramsData.p_h)) * (paramsData.p_w) *(costObj.cost)));  
                    }
                    else{
                        if(params.m_s_n == 93){
                            Price = parseFloat(Price) + parseFloat(((parseInt(paramsData.p_h)+(1.5)) * (paramsData.p_w) *(costObj.cost)));  
                        }
                        else{
                            Price = parseFloat(Price) + parseFloat(((parseInt(paramsData.p_h)+1) * (paramsData.p_w) *(costObj.cost)));  
                        }
                    }
                }   
            // }
            // if( wall == 'Open'){
            //     Price = parseFloat(Price) + parseFloat(((paramsData.p_h+1) * (storageValue) *(costObj.cost)));
            // }
        }
    }
    if(storageType == 'sideStorage'){
        if(calcfor == 'end'){
            let width = wall == 'Open' ? storageValue : (wall != 'Close' ? (parseInt(paramsData.p_w) - parseInt(storageValue)) : paramsData.p_w )
           
            if(wall != 'Open'){    
                
                if(wall != 'Close'){
                    if(params.p_b_t == 27 || params.p_b_t == 33){
                        Price = parseFloat(Price) + parseFloat(((paramsData.p_h) * (storageValue) *(costObj.cost))); 
                    }
                    else{
                        if(params.m_s_n == 93){
                            Price = parseFloat(Price) + parseFloat(((paramsData.p_h+(1.5)) * (storageValue) *(costObj.cost))); 
                        }
                        else{
                            Price = parseFloat(Price) + parseFloat(((paramsData.p_h+1) * (storageValue) *(costObj.cost))); 
                        }
                    }
                }
                if(wall=="Extended Gable" ){
                    Price = parseFloat(Price) + parseFloat(((6) * (width) *(costObj.cost)));   
                }
                else if(wall=="Gable"){
                    Price = parseFloat(Price) + parseFloat(((3) * (width) *(costObj.cost))); 
                }
                else if(wall=="One_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((1/4*parseInt(paramsData.p_h)) * (width) *(costObj.cost)));   
                }
                else if(wall=="Half_Close"){
                    Price = parseFloat(Price) + parseFloat(((1/2*parseInt(paramsData.p_h)) * (width) *(costObj.cost)));   
                }
                else if(wall=="Three_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((3/4*parseInt(paramsData.p_h)) * (width) *(costObj.cost)));  
                }
                else{
                    if(params.p_b_t == 27 || params.p_b_t == 33){
                        Price = parseFloat(Price) + parseFloat(((parseInt(paramsData.p_h)) * (width) *(costObj.cost)));  
                    }
                    else{
                        if(params.m_s_n == 93){
                            Price = parseFloat(Price) + parseFloat(((parseInt(paramsData.p_h)+(1.5)) * (width) *(costObj.cost)));  
                        }
                        else{
                            Price = parseFloat(Price) + parseFloat(((parseInt(paramsData.p_h)+1) * (width) *(costObj.cost)));  
                        }
                    }
                }   
            }
            if( wall == 'Open'){
                if(params.p_b_t == 27 || params.p_b_t == 33){
                    Price = parseFloat(Price) + parseFloat(((paramsData.p_h) * (storageValue) *(costObj.cost)));
                }
                else{
                    if(params.m_s_n == 93){
                        Price = parseFloat(Price) + parseFloat(((paramsData.p_h+(1.5)) * (storageValue) *(costObj.cost)));
                    }
                    else{
                        Price = parseFloat(Price) + parseFloat(((paramsData.p_h+1) * (storageValue) *(costObj.cost)));
                    }
                }
            }
        }
        if(calcfor == 'side' && wall != 'Open'){          
            let exactHeight = lowerHeight != 0 ? lowerHeight : paramsData.p_h      
            if(wall=="One_Fourth_Close"){
                Price = parseFloat(Price) + parseFloat(((paramsData.p_d) * (1/4*parseInt(exactHeight)) * (costObj.cost ))); 
            }
            else if(wall=="Half_Close"){
                Price = parseFloat(Price) + parseFloat(((paramsData.p_d) * (1/2*parseInt(exactHeight)) * (costObj.cost ))); 
            }
            else if(wall=="Three_Fourth_Close"){
                Price = parseFloat(Price) + parseFloat(((paramsData.p_d) * (3/4*parseInt(exactHeight)) * (costObj.cost ))); 
            }
            else if(wall != "Close"){
                Price = parseFloat(Price) + parseFloat(((paramsData.p_d) * (parseInt(wall) * 3) * (costObj.cost ))); 
            }
            else{
                Price = parseFloat(Price) + parseFloat(((paramsData.p_d) * (exactHeight) * (costObj.cost ))); 
            }
        }
    }
    if(storageType == 'frontLeanStorage'){
        if(calcfor == 'side'){
            if(wall == 'Open'){
                Price =  parseFloat(Price) + parseFloat(((paramsData.add_storage_front) * (paramsData.leanF_p_h) * (costObj.cost )* leanCount)); 
            }
            else{
                let actualLength = leanToLength
                // if(const_var.wallsData['center'].p_f_w == "Open" || const_var.wallsData['center'].p_f_w == '1'){
                if(const_var.wallsData['center'].p_f_w == "Open"){
                    Price = parseFloat(Price) + parseFloat(((paramsData.add_storage_front) * (paramsData.leanF_p_h) * (costObj.cost))); 
                }
                if(paramsData.add_storage_check_front == true && wall != 'Close' && wall != 'Open'){
                    Price =  parseFloat(Price) + parseFloat(((paramsData.add_storage_front) * (paramsData.leanF_p_h) * (costObj.cost ))); 
                    actualLength = parseFloat(leanToLength) - parseFloat(paramsData.add_storage_front)
                } 
                if(wall=="One_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (1/4 * parseInt(paramsData.leanF_p_h)) * (costObj.cost )))
                }
                else if(wall=="Half_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (1/2 * parseInt(paramsData.leanF_p_h)) * (costObj.cost ))) 
                }
                else if(wall=="Three_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (3/4 * parseInt(paramsData.leanF_p_h)) * (costObj.cost )))
                }
                else if(wall != "Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (parseInt(wall) * 3) * (costObj.cost )))
                }
                else{
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (paramsData.leanF_p_h) * (costObj.cost )))
                }   
            }
        }
    }
    if(storageType == 'backLeanStorage'){
        if(calcfor == 'side'){
            if(wall == 'Open'){
                Price =  parseFloat(Price) + parseFloat(((paramsData.add_storage_back) * (paramsData.leanB_p_h) * (costObj.cost )* leanCount)); 
            }
            else{
                let actualLength = leanToLength
                // if((const_var.wallsData['center'].p_b_w == "Open" || const_var.wallsData['center'].p_b_w == '1') && paramsData.p_u_c != true){
                if((const_var.wallsData['center'].p_b_w == "Open") && paramsData.p_u_c != true){
                    Price = parseFloat(Price) + parseFloat(((paramsData.add_storage_back) * (paramsData.leanB_p_h) * (costObj.cost))); 
                }
                if(paramsData.add_storage_check_back == true && wall != 'Close' && wall != 'Open'){
                    Price =  parseFloat(Price) + parseFloat(((paramsData.add_storage_back) * (paramsData.leanB_p_h) * (costObj.cost ))); 
                    actualLength = parseFloat(leanToLength) - parseFloat(paramsData.add_storage_back)
                } 
                if(wall=="One_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (1/4 * parseInt(paramsData.leanB_p_h)) * (costObj.cost )))
                }
                else if(wall=="Half_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (1/2 * parseInt(paramsData.leanB_p_h)) * (costObj.cost ))) 
                }
                else if(wall=="Three_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (3/4 * parseInt(paramsData.leanB_p_h)) * (costObj.cost )))
                }
                else if(wall != "Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (parseInt(wall) * 3) * (costObj.cost )))
                }
                else{
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (paramsData.leanB_p_h) * (costObj.cost )))
                }   
            }
        }
    }
    if(storageType == 'leftLeanStorage'){
        if(calcfor == 'side'){
            if(wall == 'Open'){
                Price =  parseFloat(Price) + parseFloat(((paramsData.add_storage) * (paramsData.lean_p_h) * (costObj.cost ) * parseInt(leanCount))); 
            }
            else{
                let actualLength = leanToLength
                // if((const_var.wallsData['center'].p_l_w == "Open" || const_var.wallsData['center'].p_l_w == '1') && paramsData.cB_addStorage_check_left != true){
                if((const_var.wallsData['center'].p_l_w == "Open") && paramsData.cB_addStorage_check_left != true){
                    Price = parseFloat(Price) + parseFloat(((paramsData.add_storage) * (paramsData.lean_p_h) * (costObj.cost))); 
                }
                if(paramsData.add_storage_check == true && wall != 'Close' && wall != 'Open'){
                    Price =  parseFloat(Price) + parseFloat(((paramsData.add_storage) * (paramsData.lean_p_h) * (costObj.cost ))); 
                    actualLength = parseFloat(leanToLength) - parseFloat(paramsData.add_storage)
                } 
                if(wall=="One_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (1/4 * parseInt(paramsData.lean_p_h)) * (costObj.cost )))
                }
                else if(wall=="Half_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (1/2 * parseInt(paramsData.lean_p_h)) * (costObj.cost ))) 
                }
                else if(wall=="Three_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (3/4 * parseInt(paramsData.lean_p_h)) * (costObj.cost )))
                }
                else if(wall != "Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (parseInt(wall) * 3) * (costObj.cost )))
                }
                else{
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (paramsData.lean_p_h) * (costObj.cost )))
                }   
            }
        }
    }
    if(storageType == 'rightLeanStorage'){
        if(calcfor == 'side'){            
            if(wall == 'Open'){
                Price =  parseFloat(Price) + parseFloat(((paramsData.add_storage_right) * (paramsData.leanR_p_h) * (costObj.cost )* leanCount)); 
            }
            else{
                let actualLength = leanToLength
                // if((const_var.wallsData['center'].p_r_w == "Open" || const_var.wallsData['center'].p_r_w == "1") && paramsData.cB_addStorage_check_right != true){
                if((const_var.wallsData['center'].p_r_w == "Open") && paramsData.cB_addStorage_check_right != true){
                    Price = parseFloat(Price) + parseFloat(((paramsData.add_storage_right) * (paramsData.leanR_p_h) * (costObj.cost))); 
                }
                if(paramsData.add_storage_check_right == true && wall != 'Close' && wall != 'Open'){
                    Price =  parseFloat(Price) + parseFloat(((paramsData.add_storage_right) * (paramsData.lean_p_h) * (costObj.cost ))); 
                    actualLength = parseFloat(leanToLength) - parseFloat(paramsData.add_storage_right)
                } 
                if(wall=="One_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (1/4 * parseInt(paramsData.leanR_p_h)) * (costObj.cost )))
                }
                else if(wall=="Half_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (1/2 * parseInt(paramsData.leanR_p_h)) * (costObj.cost ))) 
                }
                else if(wall=="Three_Fourth_Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (3/4 * parseInt(paramsData.leanR_p_h)) * (costObj.cost )))
                }
                else if(wall != "Close"){
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (parseInt(wall) * 3) * (costObj.cost )))
                }
                else{
                    Price = parseFloat(Price) + parseFloat(((actualLength) * (paramsData.leanR_p_h) * (costObj.cost )))
                }   
            }
        }
    }
    return Price
}

function calcRoofColorPrice(width,length,costObj,paramsData, islean,wrapIncludedCount){
    let Price = 0
    let roofWidth = (params.m_s_n == 93) ? (parseInt(width) + 2) : (parseInt(width) + 1)
    let rooflength = (params.m_s_n == 93) ? (parseInt(length) + 1) : parseInt(length)

    let overhangSideWidth = 0
    let overhangEndWidth = 0

    if(paramsData.o_v_h_n_g == true){ // true if side overhang is checked
        overhangSideWidth = const_var.isOverhang['side']['size']
    }
    if(paramsData.o_v_h_n_g_e == true){ // true if end overhang is checked
        overhangEndWidth = const_var.isOverhang['end']['size']
    }

    if(islean == true) {
        roofWidth = parseFloat(roofWidth) + parseFloat(overhangSideWidth)
    }
    else{
        roofWidth = parseFloat(roofWidth) + (parseFloat(overhangSideWidth) * 2)
    }

    if(islean == true && wrapIncludedCount != undefined && wrapIncludedCount == 1){
        rooflength = parseFloat(rooflength) + (parseFloat(overhangEndWidth))
    }
    else{
        if(wrapIncludedCount != 2){
            rooflength = parseFloat(rooflength) + (parseFloat(overhangEndWidth) * 2)
        }
    }
    
    Price = (parseFloat(roofWidth) * parseFloat(rooflength) * parseFloat(costObj.cost));
    return Price

}

function calcWainscotPrice(fullClosedWidthCalc,fullClosedLengthCalc,costObj){
    let Price = 0
    Price = (parseFloat(fullClosedWidthCalc) + parseFloat(fullClosedLengthCalc)) * 3 * (costObj.cost )
    return parseFloat(Price)
}

//Edit old quotes case
// export const editOldQuotes = (response) => {
//     let editBuildingData = response.data.data.request_data.building
//     let buildingData = response.data.data.building_data.building
//     let buildingIndex = null
//     let filterBuilding = buildingData.filter((building, index) => {
//         if(building.building_type.building_id === editBuildingData.building_type){
//             buildingIndex = index
//             return building
//         }
//     })
//     if(const_var.oldFreeStandingData === undefined && (filterBuilding[0].fixed_new_leg_width === undefined || filterBuilding[0].fixed_new_leg_width.length === 0 )){
//         const_var.oldFreeStandingData = JSON.parse(JSON.stringify(response))
//         if(filterBuilding.length > 0){
//             let filterRoofStyle = filterBuilding[0].roof_style.filter((roof) => {
//                 if(roof.roof_id === editBuildingData.roof_style){
//                     return roof
//                 }
//             })
//             let defaultBuildingDataFilter = response.data.data.building_data.default_building.filter((item) => {
//                 if((item.building_id === editBuildingData.building_type)){
//                  return item   
//                 }
//             })
//             defaultBuildingDataFilter.forEach((item) => {
//                 item.size = `${editBuildingData.width}x${editBuildingData.length}x${editBuildingData.height}`
//             })
//             filterRoofStyle[0].min_height = editBuildingData.height
//             filterRoofStyle[0].max_height = editBuildingData.height
//             filterRoofStyle[0].start_height = editBuildingData.height
    
//             filterRoofStyle[0].min_start_width = editBuildingData.width
//             filterRoofStyle[0].min_width = editBuildingData.width
//             filterRoofStyle[0].max_width =  editBuildingData.width
    
//             filterRoofStyle[0].start_length = editBuildingData.length
//             filterRoofStyle[0].min_start_length = editBuildingData.length
//             filterRoofStyle[0].end_length = editBuildingData.length
//             filterRoofStyle[0].building_max_length = editBuildingData.length
//             filterBuilding[0].roof_style = filterRoofStyle
            
//         }
//         let filterRoofpitch = response.data.data.pricing_data.roof_pitch.filter((roof) => {
//             if(roof.roof_pitch == editBuildingData.roof_pitch){
//                 return roof
//             }
//         })
//         response.data.data.pricing_data.roof_pitch = filterRoofpitch
    
//         let filterGauge = response.data.data.pricing_data.base.filter((base) => {
//             if(base.gauge === editBuildingData.gauge){
//                 return(base)
//             }
//         })
        
//         response.data.data.pricing_data.base = filterGauge
//         response.data.data.pricing_data.building_structure[0] = filterBuilding[0].roof_style[0];
//         response.data.data.building_data.building[buildingIndex] = filterBuilding[0]    
//         const_var.infoMessage = true
//     }else{
//         if(const_var.oldFreeStandingData !== undefined && filterBuilding.length > 0 && filterBuilding[0].fixed_new_leg_width?.length === 0){
//             const_var.AllBuildingData.data = const_var.oldFreeStandingData.data.data.building_data;
//             const_var.editAPIDataByResponse.data.building_data = const_var.oldFreeStandingData.data.data.building_data;
//             let oldVarData  = const_var.AllBuildingData?.data?.building?.filter((building) => {
//                 if(building.building_type.building_id === params.p_b_t){
//                     return building
//                 }
//             })
//             if(oldVarData.length > 0){
//                 const_var.c_m_a[params.p_b_t].roof_style = oldVarData[0].roof_style
//             }
//             const_var.infoMessage = false
//         }
//     }
//     return response
// } 

export const isLight = (color) => {
    // Convert color to RGB
    let r, g, b;
    color = color.replace("0x", "#");
    if (color.charAt(0) === '#') {
        color = color.substr(1);
    }
    if (color.length === 3) {
        r = parseInt(color.charAt(0) + color.charAt(0), 16);
        g = parseInt(color.charAt(1) + color.charAt(1), 16);
        b = parseInt(color.charAt(2) + color.charAt(2), 16);
    } else if (color.length === 6) {
        r = parseInt(color.substring(0, 2), 16);
        g = parseInt(color.substring(2, 4), 16);
        b = parseInt(color.substring(4, 6), 16);
    } else {
        return null; // Invalid color
    }

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Check if luminance is greater than 0.5 (considered light)
    return luminance > 0.5;
}
export const isJsonString=(str)=> {
    try {
        return (JSON.parse(str))
    } catch (e) {
        return str;
    }
}

export const copyToClickboard = (from) => {
    var copyText = document.getElementById("my-text-area");
    let copyTextValue = ""
    if(from == "innerHTML"){
        copyTextValue = copyText.innerText
    }else{
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        copyTextValue = copyText.value
    } 
    navigator.clipboard.writeText(copyTextValue);
}

export const initiallyLoadTextures = async() => {
    const gltfLoader = new GLTFLoader();
    const baseUrl = process.env.REACT_APP_BASE_URL;

    try {
        const [
            metalTexture,
            verticalTexture,
            Trim_Texture,
            textureGrass,
            textureGray,
            skyIMG,
            groundIMG,
            lapSiding,
            boardBatten,
            envTexture
        ] = await Promise.all([
            new THREE.TextureLoader().loadAsync(`${baseUrl}${MetalStripeImg}`),
            new THREE.TextureLoader().loadAsync(`${baseUrl}${NormalStripeImg}`),
            new THREE.TextureLoader().loadAsync(`${baseUrl}${TrimTexture}`),
            new THREE.TextureLoader().loadAsync(`${baseUrl}${GrassBackground}`),
            new THREE.TextureLoader().loadAsync(`${baseUrl}${GrayBackground}`),
            new THREE.TextureLoader().loadAsync(`${baseUrl}${SKY_IMG}`),
            new THREE.TextureLoader().loadAsync(`${baseUrl}${GROUND_IMG}`),
            new THREE.TextureLoader().loadAsync(`${baseUrl}${LapSiding}`),
            new THREE.TextureLoader().loadAsync(`${baseUrl}${BoardBatten}`),
            new THREE.CubeTextureLoader().loadAsync([
                `${baseUrl}${ReflectLegTexturePX}`,
                `${baseUrl}${ReflectLegTextureNX}`,
                `${baseUrl}${ReflectLegTexturePY}`,
                `${baseUrl}${ReflectLegTextureNY}`,
                `${baseUrl}${ReflectLegTexturePZ}`,
                `${baseUrl}${ReflectLegTextureNZ}`
            ])

        ]);
        
        const_var.metalTexture = metalTexture;
        const_var.wallTextureObj = {"vertical":verticalTexture, "lap":lapSiding, "board_batten":boardBatten, "none":verticalTexture};
        const_var.TrimTexture = Trim_Texture;
        const_var.textureGrass = textureGrass;
        const_var.textureGray = textureGray;
        const_var.skyIMG = skyIMG;
        const_var.groundIMG = groundIMG;
        const_var.envIMG = envTexture;

    } catch (error) {
        console.error('Error loading textures:', error);
    }
    try {
        const [gltf, gltf1] = await Promise.all([
            gltfLoader.loadAsync(`${baseUrl}/assets/glbModels/handle_sphere.glb`), 
            gltfLoader.loadAsync(`${baseUrl}/assets/glbModels/handle_rect_group.glb`), 
        ]);
        const_var.loadGltObj = gltf.scene?.children[0]?.children[0];
        if ( gltf1.scene) {
            const_var.loadGltObj1 = {
                white_section: gltf1.scene.getObjectByName('white_section'),
                handle: gltf1.scene.getObjectByName('handle'),
                black_section: gltf1.scene.getObjectByName('black_section')
            }
        }
        console.log("Loaded GLTF Object:", const_var.loadGltObj);
    } catch (error) {
        console.error('Error loading GLTF model:', error);
    }
  
}
export const makeTranslucent = (isCheckActiveTab,wallName,is_translusant,scene) => {

    // get the group dynamically we want to make visible
    if(scene=='')
    {
      return;
    }
    let section = cuComponent.wallnameBySec[wallName];
    
    let visibleGroup = scene.getObjectByName(section)
    let legGroup = scene.getObjectByName("legGroup")
    let centerMeaurement = scene.getObjectByName("Measurements-main")
    let leftMeaurement = scene.getObjectByName("Measurements-leftLeanto")
    let rightMeaurement = scene.getObjectByName("Measurements-rightLeanto")
    let frontMeaurement = scene.getObjectByName("Measurements-frontLeanto")
    let backMeaurement = scene.getObjectByName("Measurements-backLeanto")
    let doorMeaurement = scene.getObjectByName("Measurements-door")
    let windowMeaurement = scene.getObjectByName("Measurements-window")

    // console.log(centerMeaurement,"centerMeaurement");
    
    if(legGroup!=undefined) legGroup.visible = false
    // if(centerMeaurement!=undefined) centerMeaurement.visible = false
    // if(rightMeaurement!=undefined) rightMeaurement.visible = false
    // if(leftMeaurement!=undefined) leftMeaurement.visible = false
    // if(backMeaurement!=undefined) backMeaurement.visible = false
    // if(frontMeaurement!=undefined) frontMeaurement.visible = false
    // if(doorMeaurement!=undefined) doorMeaurement.visible = false
    // if(windowMeaurement!=undefined) windowMeaurement.visible = false

    if(!visibleGroup) return;

    if(is_translusant == false && isCheckActiveTab == "doorwindow") visibleGroup.visible = false;

    // if(const_var.wallSectionTab === "close") visibleGroup.visible = true;

    if(isCheckActiveTab != "doorwindow") findActiveWall("canvas",const_var.controls,const_var.wallSelection.centerBuildingWall,controls.isCheckActiveTab);

    // treverse the scene to make the meshes transperent except visibleGroup
    if(scene != undefined && scene != ""){
        scene.traverseVisible((mesh)=>{
            if(mesh.isMesh && !mesh.name.includes("Ground-Surface") && !mesh.name.includes("background") && mesh.name != "manufacturerLogoFront" && mesh.name != "manufacturerLogoBack" && mesh.name != "manufacturerLogoCenter"){
                mesh.material.opacity = 0.02

                if((isCheckActiveTab == "doorwindow" && const_var.wallSectionTab != "close") || (is_translusant == true &&  !mesh.parent.name.includes("legs") && !mesh.parent.name.includes("DoorWindows") && !mesh.name.includes("glass") && !mesh.name.includes("shape") &&!mesh.name.includes("pattern"))){
                    mesh.material.transparent = true
                    if(mesh.parent.name.includes("DoorWindows")) mesh.parent.isTransparent = true
                }else{
                    mesh.material.transparent = false
                    mesh.material.depthWrite = true
                    if(mesh.parent.name.includes("DoorWindows")) mesh.parent.isTransparent = false
                }

                mesh.material.needsUpdate = true
            }
        })
    }

    // make visibleGroup transparent false after dynamically change the group
    if(visibleGroup.visible == false){
        visibleGroup.traverse((mesh)=>{
            if(mesh.isMesh && mesh.name != "manufacturerLogoFront" && mesh.name != "manufacturerLogoBack" && mesh.name != "manufacturerLogoCenter"){
                if(
                    (wallName=="c_b_r_s_l_w" && (mesh.name.includes("left_leg") || mesh.name.includes("c_b_l_w") || mesh.parent.name.includes("c_b_l_w")))  ||
                    (wallName=="c_b_l_s_r_w" && (mesh.name.includes("right_leg") || mesh.name.includes("c_b_r_w") || mesh.parent.name.includes("c_b_r_w"))) ||
                    (wallName=="c_b_f_s_w" && (mesh.name.includes("front_leg") || mesh.name.includes("c_b_f_w") || mesh.parent.name.includes("c_b_f_w")))   ||
                    (wallName=="L_L_F_S_W" && (mesh.name.includes("lean_front_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("L_L_F_W"))) ||
                    (wallName=="R_L_F_S_W" && (mesh.name.includes("lean_front_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("R_L_F_W"))) ||
                    (wallName=="F_L_R_S_W" && (mesh.name.includes("lean_front_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("F_L_R_W"))) ||
                    (wallName=="B_L_L_S_W" && (mesh.name.includes("lean_front_leg") || mesh.name.includes("lean_leg") || mesh.name.includes("B_L_F_W")))
                ){            
                    mesh.material.opacity = 0.02
                    mesh.material.transparent = true
                    if(mesh.parent.name.includes("Measurements")) mesh.parent.isTransparent = true
                    if(mesh.parent.name.includes("DoorWindows")) mesh.parent.isTransparent = true
                }else{                
                    mesh.material.transparent = false
                    mesh.material.depthWrite = true
                    if(mesh.parent.name.includes("Measurements")) mesh.parent.isTransparent = false
                    if(mesh.parent.name.includes("DoorWindows")) mesh.parent.isTransparent = false
                }
                mesh.material.needsUpdate = true
            }
        })
    }

    // make visibleGroup visible
    visibleGroup.visible = true
    // if(centerMeaurement!=undefined) centerMeaurement.visible = true
    // if(rightMeaurement!=undefined) rightMeaurement.visible = true
    // if(leftMeaurement!=undefined) leftMeaurement.visible = true
    // if(backMeaurement!=undefined) backMeaurement.visible = true
    // if(frontMeaurement!=undefined) frontMeaurement.visible = true
    // if(doorMeaurement!=undefined) doorMeaurement.visible = true
    // if(windowMeaurement!=undefined) windowMeaurement.visible = true
    if(legGroup!=undefined) legGroup.visible = true
    visibleGroup.needsUpdate = true
    if(legGroup!=undefined) legGroup.needsUpdate = true
    // console.log(isCheckActiveTab,wallName,is_translusant,visibleGroup,"vvvvvvvvvvv");
    
}

export const findActiveWall = (elementName,constVarControls,section,tab) => {
  let rotAngle = (constVarControls!=undefined && constVarControls != '') ? constVarControls.getAzimuthalAngle() : 0 ;

  if(((section != "select" || tab != "doorwindow") && elementName =="canvas" && rotAngle != 0 && rotAngle != Math.PI/2 && rotAngle != -Math.PI/2) || (tab != "doorwindow")){
    let previousWall = params.activeWall

    if (-Math.PI/4 < rotAngle && rotAngle < Math.PI/4) {

        if(params.p_u_c == true && params.p_f_w !="Close"){
            params.activeWall = "c_b_f_s_w";
        } else {
            params.activeWall = "c_b_f_w";
        }
    } else if ( Math.PI/4 < rotAngle && rotAngle < 3 * Math.PI/4 ) {

         if(params.p_u_c == true && params.p_r_w !="Close"){
            params.activeWall = "c_b_r_s_w";
        } else {
            params.activeWall = 'c_b_r_w';
        }
    } else if (3 * Math.PI/4 < rotAngle || rotAngle < - 3 * Math.PI/4) {

        if(params.p_u_c == true && params.p_b_w !="Close"){
            params.activeWall = "c_b_b_s_w";
        } else {
            params.activeWall = "c_b_b_w";
        }
    } else if ( -Math.PI/4 > rotAngle && rotAngle > - 3 * Math.PI/4) {

        if (params.p_l_w!="Close" && params.p_u_c==true) {
            params.activeWall = "c_b_l_s_w";
        } else {
            params.activeWall = "c_b_l_w";
        }
    }
    const_var.wallSelection.centerBuildingWall = params.activeWall
    const_var.wallSelection.leanToWall = "select";
    const_var.focusedSection = cuComponent.wallnameBySec[params.activeWall];
    if((previousWall == "c_b_f_s_w" && params.activeWall != "c_b_f_s_w") || (previousWall == "c_b_l_s_r_w" && params.activeWall != "c_b_l_s_r_w") || (previousWall == "c_b_r_s_l_w" && params.activeWall != "c_b_r_s_l_w")) makeTranslucent(controls.isCheckActiveTab,params.activeWall,params.is_translusant,const_var.scene);  }
    return params.activeWall
}
//function to find the number of side/end walls
// paramss-- isfor : side/end 
// cond == 1 , not closed not open
export const calcNumOfWalls = (isfor,cond) => {
   let sideWallCount = 0;
   let endWallCount = 0;

    if(isfor == 'side'){
        if(cond == '1'){
            if(const_var.wallsData['center'].p_l_w != 'Open' && const_var.wallsData['center'].p_l_w != 'Close'){
                sideWallCount +=1
            }
            if(const_var.wallsData['center'].p_r_w != 'Open' && const_var.wallsData['center'].p_r_w != 'Close'){
                sideWallCount +=1
            }
            if(const_var.wallsData['leftLean'].p_b_c_b_l != 'Open' && const_var.wallsData['leftLean'].p_b_c_b_l != 'Close'){
                sideWallCount +=1
            }
            if(const_var.wallsData['rightLean'].p_b_c_b_r != 'Open' && const_var.wallsData['rightLean'].p_b_c_b_r != 'Close'){
                sideWallCount +=1
            }
            if(const_var.wallsData['frontLean'].p_b_c_b_f_l != 'Open' && const_var.wallsData['frontLean'].p_b_c_b_f_l != 'Close'){
                sideWallCount +=1
            }
            if(const_var.wallsData['backLean'].p_b_c_b_b_l != 'Open' && const_var.wallsData['backLean'].p_b_c_b_b_l != 'Close'){
                sideWallCount +=1
            }
        }
        return sideWallCount
    }
    if(isfor == 'end'){
        if(const_var.wallsData['center'].p_b_w != 'Open' && const_var.wallsData['center'].p_b_w != 'Close'){
            endWallCount += 1
        }
        if(const_var.wallsData['center'].p_f_w != 'Open' && const_var.wallsData['center'].p_f_w != 'Close'){
            endWallCount += 1
        }
        if(const_var.wallsData['leftLean'].p_b_c_b_l_b != 'Open' && const_var.wallsData['leftLean'].p_b_c_b_l_b != 'Close'){
            endWallCount +=1
        }
        if(const_var.wallsData['leftLean'].p_b_c_b_l_f != 'Open' && const_var.wallsData['leftLean'].p_b_c_b_l_f != 'Close'){
            endWallCount +=1
        }
        if(const_var.wallsData['rightLean'].p_b_c_b_r_b != 'Open' && const_var.wallsData['rightLean'].p_b_c_b_r_b != 'Close'){
            endWallCount +=1
        }
        if(const_var.wallsData['rightLean'].p_b_c_b_r_f != 'Open' && const_var.wallsData['rightLean'].p_b_c_b_r_f != 'Close'){
            endWallCount +=1
        }
        if(const_var.wallsData['frontLean'].p_b_c_b_f_b != 'Open' && const_var.wallsData['frontLean'].p_b_c_b_f_b != 'Close'){
            endWallCount +=1
        }
        if(const_var.wallsData['frontLean'].p_b_c_b_f_f != 'Open' && const_var.wallsData['frontLean'].p_b_c_b_f_l != 'Close'){
            endWallCount +=1
        }
        if(const_var.wallsData['backLean'].p_b_c_b_b_b != 'Open' && const_var.wallsData['backLean'].p_b_c_b_b_b != 'Close'){
            endWallCount +=1
        }
        if(const_var.wallsData['backLean'].p_b_c_b_b_f != 'Open' && const_var.wallsData['backLean'].p_b_c_b_b_f != 'Close'){
            endWallCount +=1
        }
        return endWallCount
    }
}

// ##################################
// ####################### function to calculate insulation price for according to new logic starts from here #######################
// ##################################

export const calcInsulationPrice=()=>{
    let chkPitch = (params.p_r_p==2)?2:params.p_r_p;
    let insulationPriceObj = (const_var.a_p_d_a.insulation.filter(data=>data.insulation_id==params.p_i_o));//const_var.a_p_d_a.insulation_obj[params.p_i_o][params.p_r_p+'_12']
    insulationPriceObj = insulationPriceObj[0]
    
    // ########################################### Conditions For Heritage Manufacturer ######################################
    // ############################################################################################################
    let editCheckForHeritage = editCaseHeritage();

    let heritageNoInsulationCaseCenterBuilding = false;
    let heritageNoInsulationCaseLeftLean = false;
    let heritageNoInsulationCaseRightLean = false;
    let heritageNoInsulationCaseFrontLean = false;
    let heritageNoInsulationCaseBackLean =false

    // ################################# Heritage Manufacture check for Center Building ################################
    heritageNoInsulationCaseCenterBuilding = heritageNoInsulation(params, editCheckForHeritage, false, "center")

    // ################################# Heritage Manufacture check for Front Lean ################################
    if (params.add_front_lean) {
        heritageNoInsulationCaseFrontLean = heritageNoInsulation(params, editCheckForHeritage, false, "frontLean");
    }

    // ################################# Heritage Manufacture check for Back Lean ################################
    if (params.add_back_lean) {
        heritageNoInsulationCaseBackLean = heritageNoInsulation(params, editCheckForHeritage, false, "backLean");
    }

    // ################################# Heritage Manufacture check for Left Lean ################################
    if(params.add_left_lean) {
        heritageNoInsulationCaseLeftLean = heritageNoInsulation(params, editCheckForHeritage,false, "leftLean");
    }

    // ################################# Heritage Manufacture check for Right Lean ################################
    if(params.add_right_lean) {  
        heritageNoInsulationCaseRightLean = heritageNoInsulation(params, editCheckForHeritage,false, "rightLean");
    }

    // ########################################### Conditions For Heritage Manufacturer Ends ######################################
    // ############################################################################################################


    if(params.p_c_i == true){
        const_var.CBInsulationPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : calcInsulationPriceForWall(insulationPriceObj,'centerBuilding')
        // const_var.post_data['building'].insulation_price = calcInsulationPriceForWall(insulationPriceObj,'centerBuilding')
        
        //########################### center building calculation ends here ###################
        //##############################################################################
        //########################### Front lean to's calculation starts from here ###################
        
        if(params.add_front_lean && const_var.leanGetDataFront!=undefined && params.insulation.frontLean.insulationId != 0 && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront[params.insulation.frontLean.insulationId] != undefined){
            let insulationPriceLeanObj = (const_var.leanGetDataFront.insulation!=undefined && const_var.leanGetDataFront.insulation.filter(data=>data.insulation_id==params.insulation.frontLean.insulationId )); //const_var.leanGetDataFront.insulation_obj[params.insulation.frontLean.insulationId][params.b_l_t_r_pF + '_12']
            insulationPriceLeanObj = insulationPriceLeanObj[0]
          
            const_var.FLInsulationPrice = heritageNoInsulationCaseFrontLean == true ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj,'frontLean')
        }
        
        //########################### Front lean to's calculation ends here ###################
        //##############################################################################
        //########################### Back lean to's calculation starts from here ###################

        if(params.add_back_lean && const_var.leanGetDataBack!=undefined && params.insulation.backLean.insulationId != 0 && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack[params.insulation.backLean.insulationId] != undefined){
            let insulationPriceLeanObj = (const_var.leanGetDataBack.insulation!=undefined && const_var.leanGetDataBack.insulation.filter(data=>data.insulation_id==params.insulation.backLean.insulationId )); //const_var.leanGetDataBack.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            const_var.BLInsulationPrice = heritageNoInsulationCaseBackLean == true ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj,'backLean')
        }
        
        //########################### Back lean to's calculation ends here ###################
        //##############################################################################
        //########################### Left lean to's calculation starts from here ###################

        if(params.add_left_lean && const_var.leanGetDataLeft!=undefined && const_var.insulationArrayForLeantoLeft && params.insulation.leftLean.insulationId != 0 && const_var.insulationArrayForLeantoLeft[params.insulation.leftLean.insulationId] != undefined ){
            let insulationPriceLeanObj = (const_var.leanGetDataLeft.insulation!=undefined && const_var.leanGetDataLeft.insulation.filter(data=>data.insulation_id==params.insulation.leftLean.insulationId ));//const_var.leanGetDataLeft.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
            
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            const_var.LLInsulationPrice = heritageNoInsulationCaseLeftLean ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj,'leftLean')
        }
        
        //########################### Left lean to's calculation ends here ###################
        //##############################################################################
        //########################### Right lean to's calculation starts from here ###################

        if(params.add_right_lean && const_var.leanGetDataRight!=undefined && params.insulation.rightLean.insulationId != 0 && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight[params.insulation.rightLean.insulationId] != undefined){
            let insulationPriceLeanObj = (const_var.leanGetDataRight.insulation!=undefined && const_var.leanGetDataRight.insulation.filter(data=>data.insulation_id==params.insulation.rightLean.insulationId ));//const_var.leanGetDataRight.insulation_obj[params.insulation.rightLean.insulationId][params.b_l_t_r_pR + '_12']
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            const_var.RLInsulationPrice = heritageNoInsulationCaseRightLean ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj,'rightLean')
        }

        //########################### Right lean to's calculation ends here ###################
        //##############################################################################

    }
    if(params.p_c_i != true && params.p_f_i){
        let finalPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : insulationPriceObj.full_building_insulation_cost
        if(params.add_front_lean && !heritageNoInsulationCaseFrontLean && params.insulation.frontLean.insulationId != 0 && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront[params.insulation.frontLean.insulationId] != undefined){
            let insulationPriceLeanObj = (const_var.leanGetDataFront.insulation.filter(data=>data.insulation_id==params.insulation.frontLean.insulationId ));//const_var.leanGetDataFront.insulation_obj[params.insulation.frontLean.insulationId][params.b_l_t_r_pF + '_12']
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost)
        }
        if(params.add_back_lean && !heritageNoInsulationCaseBackLean && params.insulation.backLean.insulationId != 0 && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack[params.insulation.backLean.insulationId] != undefined){
            let insulationPriceLeanObj = (const_var.leanGetDataBack.insulation.filter(data=>data.insulation_id==params.insulation.backLean.insulationId ));//const_var.leanGetDataBack.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost)
        }
        if(params.add_left_lean && !heritageNoInsulationCaseLeftLean && const_var.insulationArrayForLeantoLeft && params.insulation.leftLean.insulationId != 0 && const_var.insulationArrayForLeantoLeft[params.insulation.leftLean.insulationId] != undefined ){
            let insulationPriceLeanObj = (const_var.leanGetDataLeft.insulation.filter(data=>data.insulation_id==params.insulation.leftLean.insulationId ));//const_var.leanGetDataLeft.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost)
        }
        if(params.add_right_lean && !heritageNoInsulationCaseRightLean && params.insulation.rightLean.insulationId != 0 && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight[params.insulation.rightLean.insulationId] != undefined){
            let insulationPriceLeanObj = (const_var.leanGetDataRight.insulation.filter(data=>data.insulation_id==params.insulation.rightLean.insulationId ));//const_var.leanGetDataRight.insulation_obj[params.insulation.rightLean.insulationId][params.b_l_t_r_pR + '_12']
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost)
        }
        const_var.CBInsulationPrice = finalPrice
    }
    if((params.p_c_i != true && params.p_r_o)){
        let finalPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : insulationPriceObj.roof_insulation_cost
        if(params.add_front_lean && !heritageNoInsulationCaseFrontLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront[params.p_i_o] != undefined){
            let insulationPriceLeanObj = (const_var.leanGetDataFront.insulation.filter(data=>data.insulation_id==params.p_i_o ));
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
        }
        if(params.add_back_lean && !heritageNoInsulationCaseBackLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack[params.p_i_o] != undefined){
            let insulationPriceLeanObj = (const_var.leanGetDataBack.insulation.filter(data=>data.insulation_id==params.p_i_o ));
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
        }
        if(params.add_left_lean && !heritageNoInsulationCaseLeftLean && const_var.insulationArrayForLeantoLeft && params.p_i_o != 0 && const_var.insulationArrayForLeantoLeft[params.p_i_o] != undefined ){
            let insulationPriceLeanObj = (const_var.leanGetDataLeft.insulation.filter(data=>data.insulation_id==params.p_i_o ));
            insulationPriceLeanObj = insulationPriceLeanObj[0]
            finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
        }
        if(params.add_right_lean && !heritageNoInsulationCaseRightLean && params.p_i_o != 0 && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight[params.p_i_o] != undefined){
            let insulationPriceLeanObj = (const_var.leanGetDataRight.insulation.filter(data=>data.insulation_id==params.p_i_o ));
            insulationPriceLeanObj = insulationPriceLeanObj[0];
            finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
        }
        // if(params.add_front_lean && !heritageNoInsulationCaseFrontLean && params.insulation.frontLean.insulationId != 0 && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront[params.insulation.frontLean.insulationId] != undefined){
        //     let insulationPriceLeanObj = (const_var.leanGetDataFront.insulation.filter(data=>data.insulation_id==params.insulation.frontLean.insulationId ));//const_var.leanGetDataFront.insulation_obj[params.insulation.frontLean.insulationId][params.b_l_t_r_pF + '_12']
        //     insulationPriceLeanObj = insulationPriceLeanObj[0]
        //     finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
        // }
        // if(params.add_back_lean && !heritageNoInsulationCaseBackLean && params.insulation.backLean.insulationId != 0 && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack[params.insulation.backLean.insulationId] != undefined){
        //     let insulationPriceLeanObj = (const_var.leanGetDataBack.insulation.filter(data=>data.insulation_id==params.insulation.backLean.insulationId ));//const_var.leanGetDataBack.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
        //     insulationPriceLeanObj = insulationPriceLeanObj[0]
        //     finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
        // }
        // if(params.add_left_lean && !heritageNoInsulationCaseLeftLean && const_var.insulationArrayForLeantoLeft && params.insulation.leftLean.insulationId != 0 && const_var.insulationArrayForLeantoLeft[params.insulation.leftLean.insulationId] != undefined ){
        //     let insulationPriceLeanObj = (const_var.leanGetDataLeft.insulation.filter(data=>data.insulation_id==params.insulation.leftLean.insulationId ));//const_var.leanGetDataLeft.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
        //     insulationPriceLeanObj = insulationPriceLeanObj[0]
        //     finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
        // }
        // if(params.add_right_lean && !heritageNoInsulationCaseRightLean && params.insulation.rightLean.insulationId != 0 && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight[params.insulation.rightLean.insulationId] != undefined){
        //     let insulationPriceLeanObj = (const_var.leanGetDataRight.insulation.filter(data=>data.insulation_id==params.insulation.rightLean.insulationId ));//const_var.leanGetDataRight.insulation_obj[params.insulation.rightLean.insulationId][params.b_l_t_r_pR + '_12']
        //     insulationPriceLeanObj = insulationPriceLeanObj[0];
        //     console.log(finalPrice,"finalPrice",insulationPriceObj.roof_insulation_cost,insulationPriceLeanObj.roof_insulation_cost,const_var.leanGetDataRight.insulation,params.insulation.rightLean.insulationId)
        //     finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
        //     console.log(finalPrice,"finalPrice",insulationPriceObj.roof_insulation_cost,insulationPriceLeanObj.roof_insulation_cost)
        // }
        const_var.CBInsulationPrice = finalPrice
    }
}

// ##################################
// ####################### function to calculate insulation price for according to new logic ends here #######################
// ##################################


//########################### Insulation calculation according to indiviadual wall when custom option is selected starts from here ###################
//##############################################################################
export const calcInsulationPriceForWall=(insulationPriceObj, isFor)=>{
    let finalInsCost = 0

    let isFreeStandingBuilding = false 
    if(params.p_b_t!=undefined)
    {
        let selBuildingObj = Object.entries(const_var.defaultBuildingArr).find(([key,obj]) => obj.building_id == params.p_b_t)
        
        selBuildingObj = selBuildingObj && selBuildingObj.length > 0 ? selBuildingObj[1] : 0
        isFreeStandingBuilding = (selBuildingObj!=0)?selBuildingObj?.image_name.includes('Free_Standing') ? true : false:false
        const_var.isFreeStandingBuilding = isFreeStandingBuilding 
    }
    // console.log('const_var.insulationPriceJson.insulation_wall',const_var.insulationPriceJson.insulation_wall);
    if(isFor == 'centerBuilding' && const_var.insulationPriceJson.insulation_wall && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0){
        Object.entries(const_var.insulationPriceJson.insulation_wall).map(([key,val])=>{
            if((key == 'p_b_w' && val == true && params.p_b_w === 'Close') || (key == 'p_f_w' && val == true && params.p_f_w === 'Close')){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if((key == 'p_l_w' && !isFreeStandingBuilding && val == true && params.p_l_w === 'Close') || (key == 'p_r_w' && val == true && params.p_r_w === 'Close')){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'p_l_w' && val == true && isFreeStandingBuilding && params.p_l_w === 'Close'){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.slope_side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }

            if(params.p_u_c){
                if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
                }
                if((key == 'storage_right' && val == true) || (key == 'storage_left' && val == true && !isFreeStandingBuilding)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
                }
                if(key == 'storage_left' && val == true && isFreeStandingBuilding){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_slope_side_cost || 0)
                }
            }
            if(params.cB_addStorage_check_left){
                if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_end || 0)
                }
                if((key == 'storage_right' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.pitch_side || 0)
                }
                if(key == 'storage_left' && val == true){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
                }
            }
            if(params.cB_addStorage_check_right){
                if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_end || 0)
                }
                if(key == 'storage_left' && val == true){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.pitch_side || 0)
                }
                if((key == 'storage_right' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
                }
            }

            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    if(isFor == 'frontLean' && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront.insulation_wall && Object.keys(const_var.insulationArrayForLeantoFront.insulation_wall).length > 0){
        Object.entries(const_var.insulationArrayForLeantoFront.insulation_wall).map(([key,val])=>{
            if((key == 'p_b_c_b_f_b' && val == true && params.p_b_c_b_f_b === 'Close') || (key == 'p_b_c_b_f_f' && val == true && params.p_b_c_b_f_f === 'Close')){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'p_b_c_b_f_l' && val == true && params.p_b_c_b_f_l === 'Close'){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }
            if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'storage_left' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
            }
            if(key == 'storage_right' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_opposite_side_cost || 0)
            }
            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    if(isFor == 'backLean' && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack.insulation_wall && Object.keys(const_var.insulationArrayForLeantoBack.insulation_wall).length > 0){
        Object.entries(const_var.insulationArrayForLeantoBack.insulation_wall).map(([key,val])=>{
            if((key == 'p_b_c_b_b_f' && val == true && params.p_b_c_b_b_f === 'Close') || (key == 'p_b_c_b_b_b' && val == true && params.p_b_c_b_b_b === 'Close')){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'p_b_c_b_b_l' && val == true && params.p_b_c_b_b_l === 'Close'){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }
            if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'storage_right' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
            }
            if(key == 'storage_left' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_opposite_side_cost || 0)
            }
            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    if(isFor == 'leftLean' && const_var.insulationArrayForLeantoLeft && const_var.insulationArrayForLeantoLeft.insulation_wall && Object.keys(const_var.insulationArrayForLeantoLeft.insulation_wall).length > 0){
        Object.entries(const_var.insulationArrayForLeantoLeft.insulation_wall).map(([key,val])=>{
            if((key == 'p_b_c_b_l_f' && val == true && params.p_b_c_b_l_f === 'Close') || (key == 'p_b_c_b_l_b' && val == true && params.p_b_c_b_l_b === 'Close')){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'p_b_c_b_l' && val == true && params.p_b_c_b_l === 'Close'){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }
            if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'storage_left' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
            }
            if(key == 'storage_right' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_opposite_side_cost || 0)
            }
            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    if(isFor == 'rightLean' && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight.insulation_wall && Object.keys(const_var.insulationArrayForLeantoRight.insulation_wall).length > 0){
        Object.entries(const_var.insulationArrayForLeantoRight.insulation_wall).map(([key,val])=>{
            if((key == 'p_b_c_b_r_b' && val == true && params.p_b_c_b_r_b === 'Close') || (key == 'p_b_c_b_r_f' && val == true && params.p_b_c_b_r_f === 'Close')){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'p_b_c_b_r' && val == true && params.p_b_c_b_r === 'Close'){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }
            if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'storage_left' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_opposite_side_cost || 0)
            }
            if(key == 'storage_right' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
            }
            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    return convertToTwoDecimalNumber(finalInsCost)
}

//########################### Insulation calculation according to indiviadual wall when custom option is selected ends here ###################
//##############################################################################


// ##################################
// ####################### function to calculate insulation price for compare according to new logic starts from here #######################
// ##################################

export const calcInsulationPriceForCompare=(data,newParam,leanToData = undefined)=>{
    // console.log('newParam.p_r_p',newParam.p_r_p);
    // console.log('newParam.p_r_p',newParam.p_r_p.includes('12'));
    // console.log('newParam.p_r_p',newParam.p_r_p.includes('_12'));
    // let CRP = newParam.p_r_p.replace('12','')
    // console.log('data.pricing_data.insulation',data.pricing_data.insulation,CRP ,newParam.p_r_p,newParam.p_i_o);
    let selInsulationId = data.pricing_data.insulation.filter(obj => obj.insulation_id == newParam.p_i_o)
    // let selInsulationId = data.pricing_data.insulation.filter(obj => obj.insulation_id == newParam.p_i_o && obj.pitch_type.includes(CRP))
    // console.log('selInsulationId',selInsulationId);
    
    selInsulationId = selInsulationId && selInsulationId.length > 0 ? selInsulationId[0] : data.pricing_data.insulation[0]
    // console.log('selInsulationId',selInsulationId);
    // selInsulationId = selInsulationId.insulation_id

    const_var.compareInsId = selInsulationId.insulation_id

    let insulationPriceObj = selInsulationId
    
    // let insulationPriceObj = data.pricing_data.insulation_obj[selInsulationId][newParam.p_r_p+'_12']
    // insulationPriceObj = insulationPriceObj[0]

    // ########################################### Conditions For Heritage Manufacturer ######################################
    // ############################################################################################################
    // let editCheckForHeritage = editCaseHeritage();

    let heritageNoInsulationCaseCenterBuilding = false;
    let heritageNoInsulationCaseLeftLean = false;
    let heritageNoInsulationCaseRightLean = false;
    let heritageNoInsulationCaseFrontLean = false;
    let heritageNoInsulationCaseBackLean =false

    // ################################# Heritage Manufacture check for Center Building ################################

    heritageNoInsulationCaseCenterBuilding = heritageNoInsulation(newParam, false, true, "center",data);

    if(newParam.m_s_n == 153 && (newParam.p_r_s == 1 || newParam.p_r_s == 2) && newParam.p_h > 10) {
        heritageNoInsulationCaseCenterBuilding = true
    } else {
        heritageNoInsulationCaseCenterBuilding = false
    }

// console.log('heritageNoInsulationCaseCenterBuilding',heritageNoInsulationCaseCenterBuilding);
    // ################################# Heritage Manufacture check for Front Lean ################################
    if (params.add_front_lean) {
        heritageNoInsulationCaseFrontLean = heritageNoInsulation(newParam, false, true, "frontLean",data);
    }

    // console.log('heritageNoInsulationCaseCenterBuilding',heritageNoInsulationCaseCenterBuilding);
    // ################################# Heritage Manufacture check for Back Lean ################################
    if (params.add_back_lean) {
        heritageNoInsulationCaseBackLean = heritageNoInsulation(newParam, false, true, "backLean",data);
    }

    // console.log('heritageNoInsulationCaseCenterBuilding',heritageNoInsulationCaseCenterBuilding);
    // ################################# Heritage Manufacture check for Left Lean ################################
    if(params.add_left_lean) {
        heritageNoInsulationCaseLeftLean = heritageNoInsulation(newParam, false,true, "leftLean",data);
    }

    // ################################# Heritage Manufacture check for Right Lean ################################
    if(params.add_right_lean) {  
        heritageNoInsulationCaseRightLean = heritageNoInsulation(newParam, false,true, "rightLean",data);
    }
    // console.log('heritageNoInsulationCaseCenterBuilding',heritageNoInsulationCaseCenterBuilding);

    // ########################################### Conditions For Heritage Manufacturer Ends ######################################
    // ############################################################################################################

    if(params.p_c_i){
        if(const_var.a_p_d_a && const_var.a_p_d_a.insulation && const_var.insulationPriceJson && const_var.insulationPriceJson.insulation_wall){
            let selWallObj = {}
            selWallObj = const_var.insulationPriceJson.insulation_wall
            const_var.CompareCBInsulationPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : calcCompareInsulationPriceForWall(insulationPriceObj,'centerBuilding', selWallObj,newParam)
        }

        if((newParam.add_front_lean || newParam.add_back_lean || newParam.add_left_lean || newParam.add_right_lean) && leanToData != undefined && leanToData.length > 0){ 
           
            for(let i = 0;i<leanToData.length;i++){
                if(newParam.add_front_lean && !heritageNoInsulationCaseFrontLean &&  leanToData[i].leanto_type == 3 && newParam.insulation.frontLean.insulationId != 0 && leanToData[i].pricing_data.insulation && const_var.insulationArrayForLeantoFront && const_var.insulationArrayForLeantoFront.insulation_wall && Object.keys(const_var.insulationArrayForLeantoFront.insulation_wall).length > 0){

                    let RP = newParam.b_l_t_r_pF.replace('12','')
                    // let insulationPriceLeanObj = leanToData[i].pricing_data.insulation_obj[newParam.insulation.frontLean.insulationId][RP]
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation!=undefined && leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.frontLean.insulationId )); //const_var.leanGetDataFront.insulation_obj[params.insulation.frontLean.insulationId][params.b_l_t_r_pF + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                   let selLeanWallObj = const_var.insulationArrayForLeantoFront.insulation_wall
                
                    const_var.CompareFLInsulationPrice = calcCompareInsulationPriceForWall(insulationPriceLeanObj,'frontLean', selLeanWallObj,newParam)



                    // let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation!=undefined && leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.frontLean.insulationId && data.pitch_type.includes(newParam.b_l_t_r_pF))); //const_var.leanGetDataFront.insulation_obj[params.insulation.frontLean.insulationId][params.b_l_t_r_pF + '_12']
                    // console.log('insulationPriceLeanObj',insulationPriceLeanObj);
                    // insulationPriceLeanObj = insulationPriceLeanObj[0]
                    // console.log('insulationPriceLeanObj',insulationPriceLeanObj);
                    // const_var.FLInsulationPrice = heritageNoInsulationCaseFrontLean == true ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj,'frontLean')


                }
                if(newParam.add_back_lean && !heritageNoInsulationCaseBackLean && leanToData[i].leanto_type == 4 && newParam.insulation.backLean.insulationId != 0 && leanToData[i].pricing_data.insulation && const_var.insulationArrayForLeantoBack && const_var.insulationArrayForLeantoBack.insulation_wall && Object.keys(const_var.insulationArrayForLeantoBack.insulation_wall).length > 0){
                    let RP = newParam.b_l_t_r_pB.replace('12','')
                   
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation!=undefined && leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.backLean.insulationId )); //const_var.leanGetDataBack.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    let selLeanWallObj = const_var.insulationArrayForLeantoBack.insulation_wall
                    const_var.CompareBLInsulationPrice = calcCompareInsulationPriceForWall(insulationPriceLeanObj,'backLean', selLeanWallObj,newParam)


                    // let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation!=undefined && leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.backLean.insulationId && data.pitch_type.includes(RP))); //const_var.leanGetDataBack.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
                    // insulationPriceLeanObj = insulationPriceLeanObj[0]
                    // const_var.BLInsulationPrice = heritageNoInsulationCaseBackLean == true ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj,'backLean')

                }
                if(newParam.add_left_lean && !heritageNoInsulationCaseLeftLean && leanToData[i].leanto_type == 1 && newParam.insulation.leftLean.insulationId != 0 && leanToData[i].pricing_data && leanToData[i].pricing_data.insulation && const_var.insulationArrayForLeantoLeft && const_var.insulationArrayForLeantoLeft.insulation_wall && Object.keys(const_var.insulationArrayForLeantoLeft.insulation_wall).length > 0){
                    let RP = newParam.b_l_t_r_p.replace('12','')
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation!=undefined && leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.leftLean.insulationId ));//const_var.leanGetDataLeft.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    let selLeanWallObj = const_var.insulationArrayForLeantoLeft.insulation_wall
                    const_var.CompareLLInsulationPrice = calcCompareInsulationPriceForWall(insulationPriceLeanObj,'leftLean', selLeanWallObj,newParam)

                    // let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation!=undefined && leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==params.insulation.leftLean.insulationId && data.pitch_type.includes(RP)));//const_var.leanGetDataLeft.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
                    // console.log('insulationPriceLeanObj',insulationPriceLeanObj,params.b_l_t_r_p );
                    // insulationPriceLeanObj = insulationPriceLeanObj[0]
                    // console.log('insulationPriceLeanObj',insulationPriceLeanObj);
                    // const_var.LLInsulationPrice = heritageNoInsulationCaseLeftLean ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj,'leftLean')

                }
                if(newParam.add_right_lean && !heritageNoInsulationCaseRightLean && leanToData[i].leanto_type == 2 && newParam.insulation.rightLean.insulationId != 0 && leanToData[i].pricing_data && leanToData[i].pricing_data.insulation && const_var.insulationArrayForLeantoRight && const_var.insulationArrayForLeantoRight.insulation_wall && Object.keys(const_var.insulationArrayForLeantoRight.insulation_wall).length > 0){
                    let RP = newParam.b_l_t_r_pR.replace('12','')
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation!=undefined && leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.rightLean.insulationId ));
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    let selLeanWallObj = const_var.insulationArrayForLeantoRight.insulation_wall
                    const_var.CompareRLInsulationPrice = calcCompareInsulationPriceForWall(insulationPriceLeanObj,'rightLean', selLeanWallObj,newParam)

                    // let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation!=undefined && leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.rightLean.insulationId && data.pitch_type.includes(RP)));//const_var.leanGetDataRight.insulation_obj[params.insulation.rightLean.insulationId][params.b_l_t_r_pR + '_12']
                    // insulationPriceLeanObj = insulationPriceLeanObj[0]
                    // const_var.RLInsulationPrice = heritageNoInsulationCaseRightLean ? 0 : calcInsulationPriceForWall(insulationPriceLeanObj,'rightLean')
                }
            }
        }
    }

    if(newParam.p_f_i){
        let finalPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 : insulationPriceObj.full_building_insulation_cost
        if((newParam.add_front_lean || newParam.add_back_lean || newParam.add_left_lean || newParam.add_right_lean) && leanToData != undefined && leanToData.length > 0){ 
            for(let i = 0;i<leanToData.length;i++){
                if(newParam.add_front_lean && !heritageNoInsulationCaseFrontLean && leanToData[i].leanto_type == 3 && leanToData[i].pricing_data.insulation && newParam.insulation.frontLean.insulationId != 0){
                    let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0]
    
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.frontLean.insulationId ));

                    // let insulationPriceLeanObj = leanToData[i].pricing_data.insulation[selInsulationId][leanRoofPitch + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost)
                }
                if(newParam.add_back_lean && !heritageNoInsulationCaseBackLean && leanToData[i].leanto_type == 4 && leanToData[i].pricing_data.insulation && newParam.insulation.backLean.insulationId != 0){
                    let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0]
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.backLean.insulationId ));//leanToData[i].pricing_data.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
                    // let insulationPriceLeanObj = leanToData[i].pricing_data.insulation_obj[selInsulationId][leanRoofPitch + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost)
                }       
                if(newParam.add_left_lean && !heritageNoInsulationCaseLeftLean && leanToData[i].leanto_type == 1 && leanToData[i].pricing_data.insulation && newParam.insulation.leftLean.insulationId != 0){
                    let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0]
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.leftLean.insulationId ));//leanToData[i].pricing_data.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
                    // let insulationPriceLeanObj = leanToData[i].pricing_data.insulation_obj[selInsulationId][leanRoofPitch + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost)
                }        
                if(newParam.add_right_lean && !heritageNoInsulationCaseRightLean && leanToData[i].leanto_type == 2 && leanToData[i].pricing_data.insulation && newParam.insulation.rightLean.insulationId != 0){
                    let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0]
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.rightLean.insulationId ));//leanToData[i].pricing_data.insulation.insulation_obj[params.insulation.rightLean.insulationId][params.b_l_t_r_pR + '_12']
                    // let insulationPriceLeanObj = leanToData[i].pricing_data.insulation_obj[selInsulationId][leanRoofPitch + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.full_building_insulation_cost)
                }
            }
        }
        const_var.CompareCBInsulationPrice = convertToTwoDecimalNumber(finalPrice)
    }
    
    if(newParam.p_r_o){   
        // console.log('heritageNoInsulationCaseCenterBuilding',heritageNoInsulationCaseCenterBuilding);
        let finalPrice = heritageNoInsulationCaseCenterBuilding == true ? 0 :  insulationPriceObj.roof_insulation_cost
        // console.log('aaa finalPrice',finalPrice);
        if((newParam.add_front_lean || newParam.add_back_lean || newParam.add_left_lean || newParam.add_right_lean) && leanToData != undefined){       
            for(let i = 0;i<leanToData.length;i++){
                if(newParam.add_front_lean && !heritageNoInsulationCaseFrontLean &&  leanToData[i].leanto_type == 3 && leanToData[i].pricing_data.insulation && newParam.insulation.frontLean.insulationId != 0){
                    let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0]
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.frontLean.insulationId ));
                    // let insulationPriceLeanObj = leanToData[i].pricing_data.insulation_obj[selInsulationId][leanRoofPitch + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
                }
                if(newParam.add_back_lean && !heritageNoInsulationCaseBackLean && leanToData[i].leanto_type == 4 && leanToData[i].pricing_data.insulation && newParam.insulation.backLean.insulationId != 0){
                    let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0] 
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.backLean.insulationId ));//leanToData[i].pricing_data.insulation_obj[params.insulation.backLean.insulationId][params.b_l_t_r_pB + '_12']
                    // let insulationPriceLeanObj = leanToData[i].pricing_data.insulation_obj[selInsulationId][leanRoofPitch + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
                }
                if(newParam.add_left_lean && !heritageNoInsulationCaseLeftLean && leanToData[i].leanto_type == 1 && leanToData[i].pricing_data.insulation && newParam.insulation.leftLean.insulationId != 0){
                    let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0]
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.leftLean.insulationId ));//leanToData[i].pricing_data.insulation_obj[params.insulation.leftLean.insulationId][params.b_l_t_r_p + '_12']
                    // let insulationPriceLeanObj = leanToData[i].pricing_data.insulation_obj[selInsulationId][leanRoofPitch + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
                }
                if(newParam.add_right_lean && !heritageNoInsulationCaseRightLean && leanToData[i].leanto_type == 2 && leanToData[i].pricing_data.insulation && newParam.insulation.rightLean.insulationId != 0){
                    let leanRoofPitch = leanToData[i].roof_pitch.split("/")[0]
                    let insulationPriceLeanObj = (leanToData[i].pricing_data.insulation.filter(data=>data.insulation_id==newParam.insulation.rightLean.insulationId ));
                    // let insulationPriceLeanObj = leanToData[i].pricing_data.insulation_obj[selInsulationId][leanRoofPitch + '_12']
                    insulationPriceLeanObj = insulationPriceLeanObj[0]
                    finalPrice = parseFloat(finalPrice) + parseFloat(insulationPriceLeanObj.roof_insulation_cost)
                }
            }
            // console.log('aaa finalPrice',finalPrice);
        }
        const_var.CompareCBInsulationPrice = finalPrice
    }
        
}



//########################### Insulation calculation according to indiviadual wall when custom option is selected while compare starts from here ###################
//##############################################################################
export const calcCompareInsulationPriceForWall=(insulationPriceObj, isFor, wallData,newParam)=>{
    let finalInsCost = 0
    // let insulationPriceObj = const_var.a_p_d_a.insulation_obj[params.p_i_o][params.p_r_p+'_12']
    // insulationPriceObj = insulationPriceObj[0]

//    console.log('const_var.insulationArrayForLeantoFront.insulation_wall',const_var.insulationArrayForLeantoFront.insulation_wall);
//    console.log('const_var.insulationArrayForLeantoBack.insulation_wall',const_var.insulationArrayForLeantoBack.insulation_wall);
//    console.log('const_var.insulationArrayForLeantoLeft.insulation_wall',const_var.insulationArrayForLeantoLeft.insulation_wall);
//    console.log('const_var.insulationArrayForLeantoRight.insulation_wall',const_var.insulationArrayForLeantoRight.insulation_wall);

    let isFreeStandingBuilding = const_var.isFreeStandingBuilding 
    
    if(isFor == 'centerBuilding' && wallData && Object.keys(wallData).length > 0 && insulationPriceObj!=undefined){
        Object.entries(wallData).map(([key,val])=>{
            if((key == 'p_b_w' && val == true) || (key == 'p_f_w' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if((key == 'p_l_w' && !isFreeStandingBuilding && val == true) || (key == 'p_r_w' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'p_l_w' && val == true && isFreeStandingBuilding){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.slope_side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }

            if(newParam.p_u_c){
                if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
                }
                if((key == 'storage_right' && val == true) || (key == 'storage_left' && val == true && !isFreeStandingBuilding)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
                }
                if(key == 'storage_left' && val == true && isFreeStandingBuilding){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_slope_side_cost || 0)
                }
            }
            if(newParam.cB_addStorage_check_left){
                if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_end || 0)
                }
                if((key == 'storage_right' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.pitch_side || 0)
                }
                if(key == 'storage_left' && val == true){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
                }
            }
            if(newParam.cB_addStorage_check_right){
                if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_end || 0)
                }
                if(key == 'storage_left' && val == true){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.pitch_side || 0)
                }
                if((key == 'storage_right' && val == true)){
                    finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
                }
            }
            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    if(isFor == 'frontLean' && wallData && Object.keys(wallData).length > 0 && insulationPriceObj!=undefined){
        Object.entries(wallData).map(([key,val])=>{
            if((key == 'p_b_c_b_f_b' && val == true) || (key == 'p_b_c_b_f_f' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'p_b_c_b_f_l' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }
            if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'storage_left' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
            }
            if(key == 'storage_right' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_opposite_side_cost || 0)
            }
            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    if(isFor == 'backLean' && wallData && Object.keys(wallData).length > 0 && insulationPriceObj!=undefined){
        Object.entries(wallData).map(([key,val])=>{
            if((key == 'p_b_c_b_b_f' && val == true) || (key == 'p_b_c_b_b_b' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'p_b_c_b_b_l' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }
            if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'storage_right' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
            }
            if(key == 'storage_left' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_opposite_side_cost || 0)
            }
            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    if(isFor == 'leftLean' && wallData && Object.keys(wallData).length > 0 && insulationPriceObj!=undefined){
        Object.entries(wallData).map(([key,val])=>{
            if((key == 'p_b_c_b_l_f' && val == true) || (key == 'p_b_c_b_l_b' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'p_b_c_b_l' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }
            if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'storage_left' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
            }
            if(key == 'storage_right' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_opposite_side_cost || 0)
            }
            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    if(isFor == 'rightLean' && wallData && Object.keys(wallData).length > 0 && insulationPriceObj!=undefined){
        Object.entries(wallData).map(([key,val])=>{
            if((key == 'p_b_c_b_r_b' && val == true) || (key == 'p_b_c_b_r_f' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'p_b_c_b_r' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.side_cost || 0)
            }
            if(key == 'full_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.roof_insulation_cost || 0)
            }
            if(key == 'open_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.open_roof_cost || 0)
            }
            if((key == 'storage_front' && val == true) || (key == 'storage_back' && val == true)){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.end_cost || 0)
            }
            if(key == 'storage_left' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_opposite_side_cost || 0)
            }
            if(key == 'storage_right' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_side || 0)
            }
            if(key == 'storage_roof' && val == true){
                finalInsCost = parseFloat(finalInsCost) + parseFloat(insulationPriceObj.utility_roof_cost || 0)
            }
        })
    }
    return convertToTwoDecimalNumber(finalInsCost)
}

//########################### Insulation calculation according to indiviadual wall when custom option is selected ends here ###################
//##############################################################################

//########################### Insulation calculation according to indiviadual wall when custom option is selected ends here ###################
//##############################################################################

export const updateWallSelection=(isFor, fullEmpty = false)=>{
    // console.log('state.params.p_b_w',params.p_b_w,const_var.wallsData, const_var.insulationArrayForLeantoLeft);
    // if(isFor == 'center' && const_var.insulationPriceJson){
    //     const_var.insulationPriceJson.forEach((obj) => {
    //         if(obj && obj.insulation_wall){
    //             delete obj.insulation_wall
    //         }
    //     })
    // }
    // else if(isFor == 'frontLean' && const_var.insulationArrayForLeantoFront){
    //     const_var.insulationArrayForLeantoFront.forEach((obj) => {
    //         if(obj && obj.insulation_wall){
    //             delete obj.insulation_wall
    //         }
    //     })
    // }
    // else if(isFor == 'backLean' && const_var.insulationArrayForLeantoBack){
    //     const_var.insulationArrayForLeantoBack.forEach((obj) => {
    //         if(obj && obj.insulation_wall){
    //             delete obj.insulation_wall
    //         }
    //     })
    // }
    // else if(isFor == 'leftLean' && const_var.insulationArrayForLeantoLeft){
    //     const_var.insulationArrayForLeantoLeft.forEach((obj) => {
    //         if(obj && obj.insulation_wall){
    //             delete obj.insulation_wall
    //         }
    //     })
    // }
    // else if(isFor == 'rightLean' && const_var.insulationArrayForLeantoRight){
    //     const_var.insulationArrayForLeantoRight.forEach((obj) => {
    //         if(obj && obj.insulation_wall){
    //             delete obj.insulation_wall
    //         }
    //     })
    // }
    // else{
        if(const_var.insulationPriceJson){
            const_var.insulationPriceJson.forEach((obj) => {
                if(obj && obj.insulation_wall){
                    let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));
                    // console.log('obj.insulation_wall ---??',obj.insulation_wall);
                    // console.log('obj.params.cB_addStorage_check_left',params.cB_addStorage_check_right);
                    // console.log('obj.params.cB_addStorage_check_left',params.cB_addStorage_check_left);
                    // console.log('obj.params.cB_addStorage_check_left',params.cB_addStorage_check_front);

                    // params.cB_addStorage_check_right = false;
                    // params.cB_addStorage_check_left = false;

                    Object.entries(tmpObj).forEach(([key,val])=>{
                        // console.log('params[key] ---??',params[key],key)
                        if(key == 'storage_front' || key =='open_roof' || key == 'storage_roof' || key == 'storage_right' || key == 'storage_left' || key == 'storage_back'){
                            if(params.cB_addStorage_check_left || params.p_u_c || params.cB_addStorage_check_right){
                                obj.insulation_wall[key] = val
                                if(key == 'storage_left' && tmpObj['storage_left'] == 'included' && params.p_l_w != 'Close' && params.p_u_c){
                                    obj.insulation_wall[key] = true
                                }
                                if(key == 'storage_right' && tmpObj['storage_right'] == 'included' && params.p_r_w != 'Close' && params.p_u_c){
                                    obj.insulation_wall[key] = true
                                }
                                if(key == 'storage_front' && tmpObj['storage_front'] == 'included' && params.p_u_c){
                                    obj.insulation_wall[key] = true
                                }
                                if(key == 'storage_front' && tmpObj['storage_front'] == 'included' && params.p_f_w != 'Close' && obj.insulation_wall['p_f_w'] != true && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                    obj.insulation_wall[key] = true
                                }
                                if(key == 'storage_back' && tmpObj['storage_back'] == 'included' && params.p_b_w != 'Close' && obj.insulation_wall['p_b_w'] != true && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                    obj.insulation_wall[key] = true
                                }
                                if(key == 'storage_right' && (tmpObj['storage_right'] == 'included') && params.cB_addStorage_check_left){
                                    obj.insulation_wall[key] = false
                                }
                                if(key == 'storage_left' && (tmpObj['storage_left'] == 'included') && params.cB_addStorage_check_right){
                                    obj.insulation_wall[key] = false
                                }
                                
                                // if(key == 'storage_left' && (obj.insulation_wall['storage_left'] == true || obj.insulation_wall['storage_left'] == false) && params.p_l_w == 'Close' && params.p_u_c){
                                //     obj.insulation_wall[key] = 'included'
                                //     obj.insulation_wall['p_l_w'] = true
                                // }
                                // if(key == 'storage_right' && (obj.insulation_wall['storage_right'] == true || obj.insulation_wall['storage_right'] == false) && params.p_r_w == 'Close' && params.p_u_c){
                                //     obj.insulation_wall[key] = 'included'
                                //     obj.insulation_wall['p_r_w'] = true
                                // }
                                // if(key == 'storage_front' && (obj.insulation_wall['storage_front'] == true || obj.insulation_wall['storage_front'] == false) && params.p_f_w == 'Close' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                //     obj.insulation_wall[key] = 'included'
                                //     obj.insulation_wall['p_f_w'] = true
                                // }
                                // if(key == 'storage_back' && (obj.insulation_wall['storage_back'] == true || obj.insulation_wall['storage_back'] == false) && params.p_b_w == 'Close' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                //     obj.insulation_wall[key] = 'included'
                                //     obj.insulation_wall['p_b_w'] = true
                                // }
                                // if(key == 'storage_front' && (obj.insulation_wall['storage_front'] == true || obj.insulation_wall['storage_front'] == false) && params.p_f_w == 'Close' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                if(key == 'storage_front' && (obj.insulation_wall['storage_front'] == false) && obj.insulation_wall['p_f_w'] == true && params.p_f_w == 'Close' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                    obj.insulation_wall[key] = 'included'
                                    obj.insulation_wall['p_f_w'] = true
                                }
                                // if(key == 'storage_back' && (obj.insulation_wall['storage_back'] == true || obj.insulation_wall['storage_back'] == false) && params.p_b_w == 'Close' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                if(key == 'storage_back' && (tmpObj['storage_back'] == false) && tmpObj['p_b_w'] == true && params.p_b_w == 'Close' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                    obj.insulation_wall[key] = 'included'
                                    obj.insulation_wall['p_b_w'] = true
                                }

                                
                                if((key == 'open_roof' || key == 'storage_roof') && tmpObj['full_roof'] == true && (params.cB_addStorage_check_left || params.cB_addStorage_check_right ||params.p_u_c)){
                                    obj.insulation_wall['open_roof'] = 'included'
                                    obj.insulation_wall['storage_roof'] = 'included'
                                }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                if( key == "p_l_w" && tmpObj['storage_left'] == 'included' && params.p_u_c){
                                    obj.insulation_wall['storage_left'] = false
                                }
                                if(key == "p_r_w" && tmpObj['storage_right'] == 'included' && params.p_u_c){
                                    obj.insulation_wall['storage_right'] = false
                                }
                                if(key == "p_f_w" && tmpObj['storage_front'] == 'included' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                    obj.insulation_wall['storage_front'] = false
                                }
                                if(key == "p_b_w" && tmpObj['storage_back'] == 'included' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                    obj.insulation_wall['storage_back'] = false
                                }
                            }

                        }
                        else if(key != 'full_roof'){
                            if(params[key] == 'Close'){
                                obj.insulation_wall[key] = val
                                if(key == "p_l_w" && val==true && params.p_u_c && (obj.insulation_wall['storage_left'] == undefined || obj.insulation_wall['storage_left'] == false)){
                                    obj.insulation_wall['storage_left'] = 'included'
                                }
                                if(key == "p_r_w" && val==true && params.p_u_c && (obj.insulation_wall['storage_right'] == undefined || obj.insulation_wall['storage_right'] == false)){
                                    obj.insulation_wall['storage_right'] = 'included'
                                }
                                if(key == "p_f_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right) && (obj.insulation_wall['storage_front'] == undefined || obj.insulation_wall['storage_front'] == false)){
                                    obj.insulation_wall['storage_front'] = 'included'
                                }
                                if(key == "p_b_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right) && (obj.insulation_wall['storage_back'] == undefined || obj.insulation_wall['storage_back'] == false)){
                                    obj.insulation_wall['storage_back'] = 'included'
                                }

                                if(key == "p_l_w" && params.p_u_c && obj.insulation_wall['storage_left'] == true){
                                    obj.insulation_wall[key] = true
                                    obj.insulation_wall['storage_left'] = 'included'
                                }
                                if(key == "p_r_w" && params.p_u_c && obj.insulation_wall['storage_right'] == true){
                                    obj.insulation_wall[key] = true
                                    obj.insulation_wall['storage_right'] = 'included'
                                }
                                // if(key == "p_f_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right) && obj.insulation_wall['storage_front'] == true){
                                //     obj.insulation_wall[key] = true
                                //     obj.insulation_wall['storage_front'] = 'included'
                                // }
                                // if(key == "p_b_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right) && obj.insulation_wall['storage_back'] == true){
                                //     obj.insulation_wall[key] = true
                                //     obj.insulation_wall['storage_back'] = 'included'
                                // }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                if(key == "p_l_w" && params.p_u_c){
                                    obj.insulation_wall['storage_left'] = false
                                }
                                if(key == "p_r_w" && params.p_u_c){
                                    obj.insulation_wall['storage_right'] = false
                                }
                                if(key == "p_f_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                    obj.insulation_wall['storage_front'] = false
                                }
                                if(key == "p_b_w" && (params.cB_addStorage_check_left || params.cB_addStorage_check_right)){
                                    obj.insulation_wall['storage_back'] = false
                                }
                            }
                        }
                        else if(key == 'full_roof' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right || params.p_u_c)){
                            if(obj.insulation_wall['full_roof'] == true){
                                obj.insulation_wall['open_roof'] = 'included'
                                obj.insulation_wall['storage_roof'] = 'included'
                            }
                            if(obj.insulation_wall['full_roof'] == false){
                                obj.insulation_wall['open_roof'] = obj.insulation_wall['open_roof'] || false
                                obj.insulation_wall['storage_roof'] = obj.insulation_wall['storage_roof'] || false
                            }
                            // console.log('obj.insulation_wall',obj.insulation_wall,obj.insulation_wall['full_roof'],obj.insulation_wall['storage_roof']);
                            // console.log('obj.insulation_wall',const_var.insulationPriceJson.insulation_wall);
                        }
                        // console.log('obj.insulation_wall ---??',obj.insulation_wall);
                    })
                }
                // console.log('obj.insulation_wall ---??',obj.insulation_wall);
            })
            //const_var.UpdatedPriceData.insulation_price_changed = true
        }
        if(const_var.insulationArrayForLeantoFront){
            const_var.insulationArrayForLeantoFront.forEach((obj) => {
                if(obj && obj.insulation_wall){
                    let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));
                    // console.log('obj.insulation_wall ---??',obj.insulation_wall);
                    // console.log('obj.insulation_wall',obj.insulation_wall);
                    Object.entries(tmpObj).forEach(([key,val])=>{
                        // console.log('params[key]',params[key])
                        if(key == 'storage_front' || key == 'storage_roof' || key == 'storage_right' || key == 'storage_left' || key == 'open_roof'){
                            if(params.add_storage_check_front){
                                obj.insulation_wall[key] = val
                                if(key == 'storage_left' && obj.insulation_wall['storage_left'] == 'included' && params.p_b_c_b_f_l != 'Close'){
                                    obj.insulation_wall[key] = true
                                }
                                
                                if(key == 'storage_left' && (tmpObj['storage_left'] == true || tmpObj['storage_left'] == false) && tmpObj['p_b_c_b_f_l'] == true && params.p_b_c_b_f_l == 'Close'){
                                    obj.insulation_wall[key] = 'included'
                                    obj.insulation_wall['p_b_c_b_f_l'] = true
                                }
                                if((key == 'open_roof' || key == 'storage_roof') && tmpObj['full_roof'] == true && params.add_storage_check_front){
                                    obj.insulation_wall['open_roof'] = 'included'
                                    obj.insulation_wall['storage_roof'] = 'included'
                                }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                if(key == "p_b_c_b_f_l" && tmpObj['storage_left'] == 'included' && params.add_storage_check_front){
                                    obj.insulation_wall['storage_left'] = false
                                }
                            }
                        }
                        else if(key != 'full_roof'){
                            if(params[key] == 'Close'){
                                obj.insulation_wall[key] = val
                                if(key == "p_b_c_b_f_l" && params.add_storage_check_front && (tmpObj['storage_left'] == undefined || tmpObj['storage_left'] == false)){
                                    obj.insulation_wall['storage_left'] = 'included'
                                }
                                if(key == "p_b_c_b_f_l" && params.add_storage_check_front && tmpObj['storage_left'] == true){
                                    obj.insulation_wall[key] = true
                                    obj.insulation_wall['storage_left'] = 'included'
                                }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                if(key == "p_b_c_b_f_l" && params.add_storage_check_front){
                                    obj.insulation_wall['storage_left'] = false
                                }
                            }
                        }
                        else if(key == 'full_roof' && params.add_storage_check_front){
                            if(tmpObj['full_roof'] == true){
                                obj.insulation_wall['open_roof'] = 'included'
                                obj.insulation_wall['storage_roof'] = 'included'
                            }
                            if(tmpObj['full_roof'] == false){
                                obj.insulation_wall['open_roof'] = obj.insulation_wall['open_roof'] || false
                                obj.insulation_wall['storage_roof'] = obj.insulation_wall['storage_roof'] || false
                            }
                        }
                    })
                }
            })
            // const_var.UpdatedPriceData.front_lean_insulation_price_changed = true
        }
        if(const_var.insulationArrayForLeantoBack){
            const_var.insulationArrayForLeantoBack.forEach((obj) => {
                if(obj && obj.insulation_wall){
                    let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));
                    // console.log('obj.insulation_wall ---??',obj.insulation_wall);
                    // console.log('obj.insulation_wall',obj.insulation_wall);
                    Object.entries(tmpObj).forEach(([key,val])=>{
                        // console.log('params[key]',params[key])
                        if(key == 'storage_front' || key == 'storage_roof' || key == 'storage_right' || key == 'storage_left' || key == 'open_roof'){
                            if(params.add_storage_check_back){
                                obj.insulation_wall[key] = val
                                if(key == 'storage_right' && tmpObj['storage_right'] == 'included' && params.p_b_c_b_b_l != 'Close'){
                                    obj.insulation_wall[key] = true
                                }
                                
                                if(key == 'storage_right' && (tmpObj['storage_right'] == true || tmpObj['storage_right'] == false) && tmpObj['p_b_c_b_b_l'] == true && params.p_b_c_b_b_l == 'Close'){
                                    obj.insulation_wall[key] = 'included'
                                    obj.insulation_wall['p_b_c_b_b_l'] = true
                                }
                                if((key == 'open_roof' || key == 'storage_roof') && tmpObj['full_roof'] == true && params.add_storage_check_back){
                                    obj.insulation_wall['open_roof'] = 'included'
                                    obj.insulation_wall['storage_roof'] = 'included'
                                }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                if(key == "p_b_c_b_b_l" && tmpObj['storage_right'] == 'included' && params.add_storage_check_back){
                                    obj.insulation_wall['storage_right'] = false
                                }
                            }
                        }
                        else if(key != 'full_roof'){
                            if(params[key] == 'Close'){
                                obj.insulation_wall[key] = val
                                if(key == "p_b_c_b_b_l" && params.add_storage_check_back && (tmpObj['storage_right'] == undefined || tmpObj['storage_right'] == false)){
                                    obj.insulation_wall['storage_right'] = 'included'
                                }
                                if(key == "p_b_c_b_b_l" && params.add_storage_check_back && tmpObj['storage_right'] == true){
                                    obj.insulation_wall[key] = true
                                    obj.insulation_wall['storage_right'] = 'included'
                                }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                if(key == "p_b_c_b_b_l" && params.add_storage_check_back){
                                    obj.insulation_wall['storage_right'] = false
                                }
                            }
                        }
                        else if(key == 'full_roof' && params.add_storage_check_back){
                            if(tmpObj['full_roof'] == true){
                                obj.insulation_wall['open_roof'] = 'included'
                                obj.insulation_wall['storage_roof'] = 'included'
                            }
                            if(tmpObj['full_roof'] == false){
                                obj.insulation_wall['open_roof'] = obj.insulation_wall['open_roof'] || false
                                obj.insulation_wall['storage_roof'] = obj.insulation_wall['storage_roof'] || false
                            }
                        }
                    })
                }
            })
            //const_var.UpdatedPriceData.back_lean_insulation_price_changed = true
        }
        if(const_var.insulationArrayForLeantoLeft){
            // let updatedData = {}
            const_var.insulationArrayForLeantoLeft.forEach((obj) => {
                if(obj && obj.insulation_wall){
                    let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));
                    // console.log('obj.insulation_wall ---??',obj.insulation_wall);
                    // console.log('obj.insulation_wall',obj.insulation_wall);
                    Object.entries(tmpObj).forEach(([key,val])=>{
                        // console.log('params[key]',params[key],key)
                        if(key == 'storage_front' || key == 'storage_roof' || key == 'storage_right' || key == 'storage_left' || key == 'open_roof'){
                            // console.log('inner',obj.insulation_wall[key]);
                            if(params.add_storage_check){
                                obj.insulation_wall[key] = val
                                if(key == 'storage_left' && tmpObj['storage_left'] == 'included' && params.p_b_c_b_l != 'Close'){
                                    obj.insulation_wall[key] = true
                                }
                                if(key == 'storage_left' && (tmpObj['storage_left'] == true || tmpObj['storage_left'] == false) && tmpObj['p_b_c_b_l'] == true && params.p_b_c_b_l == 'Close'){
                                    obj.insulation_wall[key] = 'included'
                                    obj.insulation_wall['p_b_c_b_l'] = true
                                }
                                if((key == 'open_roof' || key == 'storage_roof') && tmpObj['full_roof'] == true && params.add_storage_check){
                                    obj.insulation_wall['open_roof'] = 'included'
                                    obj.insulation_wall['storage_roof'] = 'included'
                                }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                if(key == "p_b_c_b_l" && tmpObj['storage_left'] == 'included' && params.add_storage_check){
                                    obj.insulation_wall['storage_left'] = false
                                }
                            }
                        }
                        else if(key != 'full_roof'){
                            if(params[key] == 'Close'){
                                obj.insulation_wall[key] = val
                                // console.log('object===',obj.insulation_wall['storage_left']);
                                if(key == "p_b_c_b_l" && params.add_storage_check && (tmpObj['storage_left'] == undefined || tmpObj['storage_left'] == false)){
                                    obj.insulation_wall['storage_left'] = 'included'
                                }
                                if(key == "p_b_c_b_l" && params.add_storage_check && tmpObj['storage_left'] == true){
                                    obj.insulation_wall[key] = true
                                    obj.insulation_wall['storage_left'] = 'included'
                                }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                // console.log('key',key, params.add_storage_check, key == "p_b_c_b_l" && params.add_storage_check);
                                if(key == "p_b_c_b_l" && params.add_storage_check){
                                    obj.insulation_wall['storage_left'] = false
                                }
                            }
                        }
                        else if(key == 'full_roof' && params.add_storage_check){
                            if(tmpObj['full_roof'] == true){
                                obj.insulation_wall['open_roof'] = 'included'
                                obj.insulation_wall['storage_roof'] = 'included'
                            }
                            if(tmpObj['full_roof'] == false){
                                obj.insulation_wall['open_roof'] = obj.insulation_wall['open_roof'] || false
                                obj.insulation_wall['storage_roof'] = obj.insulation_wall['storage_roof'] || false
                            }
                        }
                        // else if(key == 'full_roof')
                        // console.log('object',obj.insulation_wall['storage_left']);
                        // console.log('object',obj.insulation_wall);
                    })
                    // updatedData = obj.insulation_wall
                }
                // const_var.insulationArrayForLeantoLeft.insulation_wall = updatedData
                // console.log('const_var.insulationPriceJson',const_var.insulationArrayForLeantoLeft);
            })
            //const_var.UpdatedPriceData.left_lean_insulation_price_changed = true
        }
        if(const_var.insulationArrayForLeantoRight){
            const_var.insulationArrayForLeantoRight.forEach((obj) => {
                if(obj && obj.insulation_wall){
                    let tmpObj = JSON.parse(JSON.stringify(obj.insulation_wall));
                    // console.log('obj.insulation_wall ---??',obj.insulation_wall);
                    // console.log('obj.insulation_wall',obj.insulation_wall);
                    Object.entries(tmpObj).forEach(([key,val])=>{
                        // console.log('params[key]',params[key])
                        if(key == 'storage_front' || key == 'storage_roof' || key == 'storage_right' || key == 'storage_left' || key == 'open_roof'){
                            if(params.add_storage_check_right){
                                obj.insulation_wall[key] = val
                                if(key == 'storage_right' && tmpObj['storage_right'] == 'included' && params.p_b_c_b_r != 'Close'){
                                    obj.insulation_wall[key] = true
                                }
                                if(key == 'storage_right' && (tmpObj['storage_right'] == true || tmpObj['storage_right'] == false) && tmpObj['p_b_c_b_r'] == true && params.p_b_c_b_r == 'Close'){
                                    obj.insulation_wall[key] = 'included'
                                    obj.insulation_wall['p_b_c_b_r'] = true
                                }
                                if((key == 'open_roof' || key == 'storage_roof') && tmpObj['full_roof'] == true && params.add_storage_check_right){
                                    obj.insulation_wall['open_roof'] = 'included'
                                    obj.insulation_wall['storage_roof'] = 'included'
                                }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                if(key == "p_b_c_b_r" && tmpObj['storage_right'] == 'included' && params.add_storage_check_right){
                                    obj.insulation_wall['storage_right'] = false
                                }
                            }
                        }
                        else if(key != 'full_roof'){
                            if(params[key] == 'Close'){
                                obj.insulation_wall[key] = val
                                if(key == "p_b_c_b_r" && params.add_storage_check_right && (tmpObj['storage_right'] == undefined || tmpObj['storage_right'] == false)){
                                    obj.insulation_wall['storage_right'] = 'included'
                                }
                                if(key == "p_b_c_b_r" && params.add_storage_check_right && tmpObj['storage_right'] == true){
                                    obj.insulation_wall[key] = true
                                    obj.insulation_wall['storage_right'] = 'included'
                                }
                            }
                            else{
                                obj.insulation_wall[key] = false
                                
                                if(key == "p_b_c_b_r" && params.add_storage_check_right){
                                    obj.insulation_wall['storage_right'] = false
                                }
                            }
                        }
                        else if(key == 'full_roof' && params.add_storage_check_right){
                            if(tmpObj['full_roof'] == true){
                                obj.insulation_wall['open_roof'] = 'included'
                                obj.insulation_wall['storage_roof'] = 'included'
                            }
                            if(tmpObj['full_roof'] == false){
                                obj.insulation_wall['open_roof'] = obj.insulation_wall['open_roof'] || false
                                obj.insulation_wall['storage_roof'] = obj.insulation_wall['storage_roof'] || false
                            }
                        }
                    })
                }
            })
            //const_var.UpdatedPriceData.right_lean_insulation_price_changed = true
        }
        // console.log('const_var.insulationPriceJson',const_var.insulationArrayForLeantoLeft);
        // console.log('const_var.insulationPriceJson',const_var.insulationArrayForLeantoFront);
        // console.log('const_var.insulationPriceJson',const_var.insulationArrayForLeantoRight);
    // }
}

//########################### Insulation calculation according to indiviadual wall when custom option is selected ends here ###################
//##############################################################################


// ##################################### Heritage Manufacture Case for no insulation #########################################
// ############################################################################

export const heritageNoInsulation = (newParams, editCase, isFromCompare, type, compareMnfData = undefined) => {
    let frontLeanData = undefined;
    let backLeanData = undefined;
    let leftLeanData = undefined;
    let rightLeanData = undefined;
    let heritageNoInsulationCase = false

    let height = 0;
    let roofStyle = 0;
    let leanToData= [];
    let manufacturer = 153;


    if(isFromCompare === true) {
        height = newParams.height ? newParams.height: newParams.p_h;
        roofStyle = newParams.roof_style ? newParams.roof_style : newParams.p_r_s
        // if(newParams != undefined && newParams.leanto != undefined && newParams.leanto.length > 0){

// console.log('compareData aaa',compareMnfData);
        if(compareMnfData !== undefined && compareMnfData.post_data && compareMnfData.post_data.building && compareMnfData.post_data.building.leanto && compareMnfData.post_data.building.leanto.length > 0){
            leanToData = compareMnfData.post_data.building.leanto
        }
        manufacturer = newParams.manufacturer ? newParams.manufacturer : newParams.m_s_n
    } else {
        height = newParams.p_h;
        roofStyle = newParams.p_r_s
        if (const_var.post_data.building !== undefined && const_var.post_data.building.leanto.length > 0) {
            leanToData = const_var.post_data.building.leanto;
        }
        manufacturer = newParams.m_s_n;
    }
    // ######################## For common cases ###################################
    if (leanToData !== undefined && leanToData.length > 0) {
        for (var i = 0; i <= leanToData.length - 1; i++) {
            if (leanToData[i].leanto_type === 2) {
                rightLeanData = leanToData[i];
            } else if (leanToData[i].leanto_type === 1) {
                leftLeanData = leanToData[i];
            } else if (leanToData[i].leanto_type === 3) {
                frontLeanData = leanToData[i];
            } else if (leanToData[i].leanto_type === 4) {
                backLeanData = leanToData[i];
            }
        }
    }

         if(newParams.singleSlope != true &&
            (
               (const_var.crmSetting.is_Edit != true && newParams.m_s_n == 153 && 
                  (
                     (newParams.p_r_s  == 1 || newParams.p_r_s == 2) && newParams.p_h > 10
                  )
               ) 
               || 
               (editCase == true && newParams.p_h > 10)
            )
         ) {

            if(type == "all" ) {
                if(
                   (
                      (newParams.add_left_lean == true && leftLeanData != undefined &&  leftLeanData.height <= 10) ||
                      (newParams.add_right_lean == true && rightLeanData != undefined &&  rightLeanData.height <= 10) ||
                      (newParams.add_front_lean == true && frontLeanData != undefined &&  frontLeanData.height <= 10) ||
                      (newParams.add_back_lean == true && backLeanData != undefined &&  backLeanData.height <= 10 )
                   )
                ){
                   heritageNoInsulationCase = false
                } else {
                    heritageNoInsulationCase = true;
                    //params.p_f_i = false;params.p_r_o = false; params.p_c_i= false;
                }
            }
            

            // ##################### Center Building ########################
            if(type === "center") {
                // console.log('roofStyle aaaa',roofStyle, height);
                if((roofStyle  == 1 || roofStyle == 2) && height > 10) {
                
                    // console.log('aaa ???');
                    heritageNoInsulationCase = true;
                    // params.p_f_i = false;params.p_r_o = false; params.p_c_i= false;
                    // const_var.insulationPriceJson.insulation_wall = {}
                } else {
                    // console.log('aaa ??? 2223');
                
                    heritageNoInsulationCase = false
                }
                return heritageNoInsulationCase;
            }
            // console.log('aaa ???',heritageNoInsulationCase);
            // ##################### Left Lean ########################

            if(type === "leftLean") {
                // console.log("heritageNoInsulationCaseLeftLean---", leftLeanData)
                if(newParams.add_left_lean == true && leftLeanData != undefined &&  leftLeanData.height > 10) {
                // console.log("heritageNoInsulationCaseLeftLean---if")

                    heritageNoInsulationCase = true
                } else {
                // console.log("heritageNoInsulationCaseLeftLean---else")

                    heritageNoInsulationCase = false
                }
            }

            // ##################### Right Lean ########################

            if(type === "rightLean") {
                if(newParams.add_right_lean == true && rightLeanData != undefined &&  rightLeanData.height > 10) {
                    heritageNoInsulationCase = true
                } else {
                    heritageNoInsulationCase = false
                }
            }
            // ##################### Front Lean ########################
            if(type === "frontLean") {
                if(newParams.add_front_lean == true && frontLeanData != undefined &&  frontLeanData.height > 10) {
                    heritageNoInsulationCase = true
                } else {
                    heritageNoInsulationCase = false
                }
            }
            // ##################### Back Lean ########################
            if(type === "backLean") {
                if(newParams.add_back_lean == true && backLeanData != undefined &&  backLeanData.height > 10 ) {
                    heritageNoInsulationCase = true
                } else {
                    heritageNoInsulationCase = false
                }
            }
            // console.log('aaa ???',heritageNoInsulationCase);
        } else {
     
         let singleSlopeHeight = (const_var.c_m_a[newParams.p_b_t]!=undefined && const_var.c_m_a[newParams.p_b_t].fixed_new_leg_width!=undefined && const_var.c_m_a[newParams.p_b_t].fixed_new_leg_width.length>0 ) ? Math.floor(newParams.p_h-((newParams.p_w * newParams.p_r_p) / 12)) : Math.round(newParams.p_h-((newParams.p_w * newParams.p_r_p) / 12))
      
     
             if((
                 (const_var.crmSetting.is_Edit != true && newParams.m_s_n == 153 && 
                 (
                     (roofStyle  == 1 || roofStyle == 2) && singleSlopeHeight > 10
                 )
                 ) 
                 || 
                 (editCase == true && singleSlopeHeight > 10)
             )){
                   params.p_i_o = 0;
                  params.insulation.center.insulationId = 0;
                  params.p_c_i = false;
                  params.p_f_i = false;
                  params.p_r_o = false;  
                 heritageNoInsulationCase = true
             }
     
        }

        if( const_var.insulationJson && const_var.insulationJson.length > 0 && heritageNoInsulationCase && !params.p_c_i){
            if(type == "all" ){
                params.p_c_i = false
                params.p_f_i = false
                params.p_r_o = false
            }
            else{
                checkForInsulation()
            }
        }

   return heritageNoInsulationCase;
}

const checkForInsulation=()=>{
    let editCheckForHeritage = editCaseHeritage()

    let isinsulationApplicable= heritageNoInsulation(params, editCheckForHeritage,false, "all");
    if(isinsulationApplicable){
        params.p_c_i = false
        params.p_f_i = false
        params.p_r_o = false
    }
}

// ##################################### Edit Case For Heritage Manufacture #########################################
// ############################################################################

export const editCaseHeritage = () => {
     let heritageEditCase = const_var.crmSetting.is_Edit == true && params.m_s_n == 153 && (params.p_r_s  == 1 || params.p_r_s == 2) && const_var.editAPIDataByResponse != undefined && const_var.editAPIDataByResponse.data != undefined;

     return heritageEditCase
}

// will make an function which will calculate the number of end walls not open and not close 
// (center building and for all lean to's)*
    
//     according to that function will get the exact count and then will calulate the opricing for the dependents

export const trussCalcuate = (filterData,postData,tCost,customParams,customTotalPriceWithoutAdditionalItem,customLeantoPriceCalculation,from) => {
    if(filterData?.length > 0 && from != "compare"){
        postData['building'].truss_type_name = filterData[0]?.is_default==true?'Standard Truss':(customParams.m_s_n == 153 ? "Ladder Truss" : 'High Truss');
    }
    if(filterData?.length > 0){
        let finalCost = 0
        let priceData = filterData[0]
        if(priceData.price_type == "%" && filterData.length > 0 && filterData[0]?.price_of != null && filterData[0]?.price_of != undefined  && filterData[0]?.cost !== undefined && filterData[0]?.cost){
            let splval = 0
            if(priceData.price_of.includes("full_building_price") !== false){
                splval = parseFloat(splval) + (customTotalPriceWithoutAdditionalItem ? parseFloat(customTotalPriceWithoutAdditionalItem) : 0) +  (customLeantoPriceCalculation.totalLeanPrice ? parseFloat(customLeantoPriceCalculation.totalLeanPrice): 0)
            }
            if(priceData.price_of.includes("base_price")!=false)
            {
                splval = parseFloat(splval) + (postData['building'].roof_style_price ? parseFloat(postData['building'].roof_style_price) : 0 );
            }
            if(priceData.price_of.includes("wall_price")!=false)
            {
                if((customParams.p_u_c==true || customParams.cB_addStorage_check_left==true || customParams.cB_addStorage_check_right==true))
                {
                    splval = parseFloat(splval) + parseFloat(postData['building'].utility_price) + parseFloat(postData['building'].front_wall_price) + parseFloat(postData['building'].left_wall_price) + parseFloat(postData['building'].right_wall_price)+ parseFloat(postData['building'].back_wall_price) + parseFloat(customLeantoPriceCalculation.totalWallPrice);
                }else
                {
                    splval = parseFloat(splval) + parseFloat(postData['building'].front_wall_price) +parseFloat(postData['building'].left_wall_price) + parseFloat(postData['building'].right_wall_price) + parseFloat(postData['building'].back_wall_price) + parseFloat(customLeantoPriceCalculation.totalWallPrice);
                }
                if (postData['building'].utility_front_price != undefined && customParams.isBreezeway && customParams.cB_addStorage_check_front ) {
                    splval = parseFloat(splval) + parseFloat(postData['building'].utility_front_price);
                }
            }
            if(priceData.price_of.includes("height_price")!=false)
            {
                splval = parseFloat(splval) + parseFloat(postData['building'].height_price) + parseFloat(customLeantoPriceCalculation.totalHeightPrice);
            }
            finalCost  = (splval * priceData.cost) / 100;
        }else if(priceData.price_type == "sqft" && filterData.length > 0 && filterData[0].price_of != null && filterData[0].price_of != undefined  && filterData[0].cost !== undefined && filterData[0].cost){
            finalCost = 0
        }else{
            finalCost = priceData.cost
        }
        if(from == "compare"){
            postData.building.truss_type_name = filterData[0].is_default==true?'Standard Truss': (customParams.m_s_n == 153 ? "Ladder Truss" : 'High Truss')
            postData.building.truss_price = convertToTwoDecimalNumber(finalCost)
            postData.building.trussType = filterData?.length > 0 && filterData[0]?.name?.replace(/[0-9]/g, '')
            customParams.trussType = filterData?.length > 0 && filterData[0]?.name?.replace(/[0-9]/g, '')
            customParams.newtrussType = filterData?.length > 0 && filterData[0]?.name?.replace(/[0-9]/g, '')
            tCost = parseFloat(tCost) + (postData.building.truss_price ? convertToTwoDecimalNumber(postData.building.truss_price) : 0)
        }else{
            postData['building'].truss_price = const_var.UpdatedPriceData.truss_price_changed!=true ? convertToTwoDecimalNumber(const_var.UpdatedPriceData.truss_price?  const_var.UpdatedPriceData.truss_price : 0) : convertToTwoDecimalNumber(finalCost)
            //postData.building.trussType = filterData?.length > 0 && filterData[0]?.name.replace(/[0-9]/g, '')
            tCost = parseFloat(tCost) + (postData['building'].truss_price ? parseFloat(postData['building'].truss_price) : 0)
        }
    }else if(from != "compare"){
        postData['building'].truss_price = convertToTwoDecimalNumber(const_var.UpdatedPriceData.truss_price_changed!=true ? const_var.UpdatedPriceData.truss_price ? const_var.UpdatedPriceData.truss_price : 0 : 0)                       
        tCost = parseFloat(tCost) + (postData['building'].truss_price ? parseFloat(postData['building'].truss_price) : 0)
    }
    return tCost 
}

export const assigRWTWColors = (comparisionData,params, from) => {
    if(comparisionData != undefined && comparisionData?.paramsData){
        let defualtBuildingData = comparisionData.building_data.default_building.filter( building => params.building_type_name.includes(building.name) )[0]; 

        let defualtBuildingWallColorId = defualtBuildingData != undefined && defualtBuildingData.wall_color != undefined ? defualtBuildingData.wall_color : comparisionData.building_data.color[0] ;
        let defualtBuildingRoofColorId = defualtBuildingData != undefined ? defualtBuildingData.roof_color : comparisionData.building_data.color[0] ;
        let defualtBuildingTrimColorId = defualtBuildingData != undefined ? defualtBuildingData.trim_color : comparisionData.building_data.color[0] ;
        let defualtBuildingWainscotColorId = defualtBuildingData != undefined ? defualtBuildingData.wainscot_color : comparisionData.building_data.color[0] ;
        

        let WallColorObj = (comparisionData.building_data.color.filter(data=>data.name==params.p_w_c_name)[0]!=undefined) 
        ? comparisionData.building_data.color.filter(data=>data.name == params.p_w_c_name)[0]
        : (defualtBuildingWallColorId !== undefined && comparisionData.building_data.color.filter(data=>data.id==defualtBuildingWallColorId)[0]!= undefined) ? comparisionData.building_data.color.filter(data=>data.id==defualtBuildingWallColorId)[0]:comparisionData.building_data.color[0];

        let RoofColorObj = (comparisionData.building_data.color.filter(data=>data.name==params.p_r_c_name)[0]!=undefined)
        ? comparisionData.building_data.color.filter(data=>data.name==params.p_r_c_name)[0]
        : (defualtBuildingRoofColorId !== undefined && comparisionData.building_data.color.filter(data=>data.id==defualtBuildingRoofColorId)[0]!= undefined) ? comparisionData.building_data.color.filter(data=>data.id==defualtBuildingRoofColorId)[0]:comparisionData.building_data.color[0];

        let TrimColorObj = (comparisionData.building_data.color.filter(data=>data.name==params.p_t_c_name)[0]!=undefined)
        ? comparisionData.building_data.color.filter(data=>data.name==params.p_t_c_name)[0]
        : (defualtBuildingTrimColorId !== undefined && comparisionData.building_data.color.filter(data=>data.id==defualtBuildingTrimColorId)[0]!= undefined) ? comparisionData.building_data.color.filter(data=>data.id==defualtBuildingTrimColorId)[0]:comparisionData.building_data.color[0];
        
        let WainscotColorObj = ""
        if(defualtBuildingData != undefined && defualtBuildingData?.wainscot_color != undefined){
            WainscotColorObj = (comparisionData.building_data.color.filter(data=>data.name==params.p_w_c_c_name)[0]!=undefined)
            ? comparisionData.building_data.color.filter(data=>data.name==params.p_w_c_c_name)[0]
            : (defualtBuildingWainscotColorId !== undefined && comparisionData.building_data.color.filter(data=>data.id==defualtBuildingWainscotColorId)[0]!= undefined) ? comparisionData.building_data.color.filter(data=>data.id==defualtBuildingWainscotColorId)[0]:comparisionData.building_data.color[0];
        }else{
            WainscotColorObj = (comparisionData.building_data.color.filter(data=>data.name==params.p_w_c_c_name)[0]!=undefined)
            ? comparisionData.building_data.color.filter(data=>data.name==params.p_w_c_c_name)[0]
            : (defualtBuildingTrimColorId !== undefined && comparisionData.building_data.color.filter(data=>data.id==defualtBuildingTrimColorId)[0]!= undefined) ? comparisionData.building_data.color.filter(data=>data.id==defualtBuildingTrimColorId)[0]:comparisionData.building_data.color[0];
        }
        comparisionData.paramsData.p_r_c_name = RoofColorObj?.name
        comparisionData.paramsData.p_t_c_name = TrimColorObj.name
        comparisionData.paramsData.p_w_c_name = WallColorObj.name
        comparisionData.paramsData.p_w_c_c_name = WainscotColorObj?.name
        if(from == "comparePriceData"){
            return {WallColorObj,RoofColorObj,TrimColorObj,WainscotColorObj}
        }
    }
}
export const deleteUncheckWallsfromInsulationWalls = (postData)=> {
    if(params.p_c_i == true  && postData!=undefined){
        if(postData.insulation_type!=undefined && Object.keys(postData.insulation_type).length>0 && postData.insulation_type.insulation_wall!=undefined && Object.keys(postData.insulation_type.insulation_wall).length>0){
            Object.entries(postData.insulation_type.insulation_wall).forEach(([key,value])=>{
                if(value == false){
                     delete postData.insulation_type.insulation_wall[key];
                }
            })
        }
        if(postData.insulation_type!=undefined && (postData.insulation_type.insulation_wall==undefined || Object.keys(postData.insulation_type.insulation_wall).length == 0)){
            delete postData.insulation_type
        }
        if(postData.leanto !=undefined && postData.leanto.length>0){
            Object.entries(postData.leanto).map(([key, value])=>{
                if(value.leanto_type == 1 && value.insulation_type!=undefined && value.insulation_type.insulation_wall!=undefined && Object.keys(value.insulation_type.insulation_wall).length>0 ){
                    Object.entries(value.insulation_type.insulation_wall).forEach(([key1,val])=>{
                        if(val == false){
                            delete value.insulation_type.insulation_wall[key1]
                        }
                    })
                }
                
                if(value.leanto_type == 2 && value.insulation_type!=undefined && value.insulation_type.insulation_wall!=undefined && Object.keys(value.insulation_type.insulation_wall).length>0 ){
                    Object.entries(value.insulation_type.insulation_wall).forEach(([key1,val])=>{
                        if(val == false){
                            delete value.insulation_type.insulation_wall[key1]
                        }
                    })
                }

                if(value.leanto_type == 3 && value.insulation_type!=undefined && value.insulation_type.insulation_wall!=undefined && Object.keys(value.insulation_type.insulation_wall).length>0){
                    Object.entries(value.insulation_type.insulation_wall).forEach(([key1,val])=>{
                        if(val == false){
                            delete value.insulation_type.insulation_wall[key1]
                        }
                    })
                }

                if(value.leanto_type == 4 && value.insulation_type!=undefined && value.insulation_type.insulation_wall!=undefined && Object.keys(value.insulation_type.insulation_wall).length>0 ){
                    Object.entries(value.insulation_type.insulation_wall).forEach(([key1,val])=>{
                        if(val == false){
                            delete value.insulation_type.insulation_wall[key1]
                        }
                    })
                }
                if(value.leanto_type == 1 && value.insulation_type!=undefined && (value.insulation_type.insulation_wall == undefined || Object.keys(value.insulation_type.insulation_wall).length==0) ){
                    delete value.insulation_type
                }
                if(value.leanto_type == 2 && value.insulation_type!=undefined && (value.insulation_type.insulation_wall == undefined || Object.keys(value.insulation_type.insulation_wall).length==0) ){
                    delete value.insulation_type
                }
                if(value.leanto_type == 3 && value.insulation_type!=undefined && (value.insulation_type.insulation_wall == undefined || Object.keys(value.insulation_type.insulation_wall).length==0) ){
                    delete value.insulation_type
                }
                if(value.leanto_type == 4 && value.insulation_type!=undefined && (value.insulation_type.insulation_wall == undefined || Object.keys(value.insulation_type.insulation_wall).length==0) ){
                    delete value.insulation_type
                }
            })
        }
        
    } 
}

export const deleteInsulationKeysForLeanTo=()=>{
    if(const_var.post_data && const_var.post_data.building && const_var.post_data.building.leanto && const_var.post_data.building.leanto.length > 0){
        // console.log('const_var.post_data.building.leanto',const_var.post_data.building.leanto);
        // const updatedLeandata = const_var.post_data.building.leanto.map(({insulation_type,...rest}) => ({...rest}));
        const updatedLeandata = []
        const_var.post_data.building.leanto.map((obj) => {
            updatedLeandata.push(obj)
            let updatedTotal = 0 
            // console.log('updatedLeandata.t_c_b',obj.t_c_b);
            if(obj.t_c_b != undefined){
                updatedTotal = parseFloat(obj.t_c_b) - parseFloat(obj.insulation_price || 0)
            }
            if(obj.insulation_type != undefined){
                delete obj.insulation_type
            }
            if(obj.insulation_price != undefined){
                delete obj.insulation_price
            }
            if(updatedTotal != 0){
                obj.t_c_b = updatedTotal
            }
        });
        const_var.post_data.building.leanto = updatedLeandata
        const_var.post_data.building.leanto.insulation = ''
        // console.log('const_var.post_data.building.leanto',const_var.post_data.building.leanto);
    }
}

export const setDefaultValuesOnSalesLoginBtnClick = () => {
    const_var.tempZCode = '';
    const_var.ziperrormsg = '';
    const_var.displayerrorMessage = {}
    const_var.checkValidatePattern = false;
    const_var.state_mfg_zipcode = '';
    const_var.state_mfg_zipcode_old = '';
    const_var.resetVal = true;
    const_var.hideZipCodeField = false;
    const_var.zipManufErrMsg = '';
    setTimeout(() => {
       window.document.getElementById('username').focus()
    }, 10);
}

async function hashSHA256(apiToken, domain) {
    const encoder = new TextEncoder();
    const data = encoder.encode(apiToken + domain); // Concatenate the apiToken and domain
    const hashBuffer = await window.crypto.subtle.digest("SHA-256", data); // Hash the data using SHA-256
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // Convert the ArrayBuffer to an array of bytes
    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join(''); // Convert bytes to hex string
    return hashHex
}

export const decodeKey = async(checkoutKey, const_var) => {
    const apiToken = const_var.crmSetting.api_token;
    const domain = const_var.crmSetting.main_domain_url;
    const haskKey = await hashSHA256(apiToken,domain)
    
    // const encryptedData = await encryptString(checkoutKey, haskKey);
    // console.log("Encrypted:", encryptedData); // Log encrypted data

    const decryptedText = await decryptString(checkoutKey, haskKey);

    return decryptedText
}


async function encryptString(string, keyString) {
    const encoder = new TextEncoder();
    const data = encoder.encode(string); // Convert the string to a Uint8Array

    // Ensure the key is 256-bits (32 bytes) using SHA-256
    const key = await crypto.subtle.digest('SHA-256', encoder.encode(keyString)); // Pass keyString here

    // Generate a random 16-byte IV
    const iv = crypto.getRandomValues(new Uint8Array(16));

    // Import the key for AES encryption
    const cryptoKey = await crypto.subtle.importKey(
        "raw", 
        key, 
        { name: "AES-CBC" },
        false, 
        ["encrypt"]
    );

    // Encrypt the data using AES-256-CBC
    const encryptedData = await crypto.subtle.encrypt(
        { name: "AES-CBC", iv: iv },
        cryptoKey,
        data
    );

    // Combine the IV and encrypted data
    const combined = new Uint8Array(iv.byteLength + encryptedData.byteLength);
    combined.set(iv, 0); // Add the IV to the beginning
    combined.set(new Uint8Array(encryptedData), iv.byteLength); // Add the encrypted data

    // Return the result as a base64-encoded string
    return base64Encode(combined);
}

// Helper to convert to base64
function base64Encode(buffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
}

// Decryption Function
async function decryptString(encryptedString, keyString) {
    const decoder = new TextDecoder();
    // Decode the base64-encoded encrypted string
    const data = base64Decode(encryptedString);

    // Extract the IV and encrypted data from the combined data
    const iv = data.slice(0, 16); // The first 16 bytes are the IV
    const encryptedData = data.slice(16); // The remaining part is the encrypted data

    // Ensure the key is 256-bits (32 bytes) using SHA-256
    const encoder = new TextEncoder();
    const key = await crypto.subtle.digest('SHA-256', encoder.encode(keyString)); // Hash the key string to 256-bit

    // Import the key for AES decryption
    const cryptoKey = await crypto.subtle.importKey(
        "raw", 
        key, 
        { name: "AES-CBC" },
        false, 
        ["decrypt"]
    );

    // Decrypt the data using AES-256-CBC
    const decryptedData = await crypto.subtle.decrypt(
        { name: "AES-CBC", iv: iv },
        cryptoKey,
        encryptedData
    );

    // Convert the decrypted data back to a string and return it
    return decoder.decode(decryptedData);
}

// Helper to decode base64
function base64Decode(base64) {
    const binaryString = atob(base64); // Decode base64 string to binary string
    const byteArray = new Uint8Array(binaryString.length); // Create a byte array

    // Convert the binary string to a byte array
    for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
    }
    return byteArray;
}
export const loadStripe = (dynamicKey) => {
    if (!window.document.getElementById("stripe-script")) {
      var s = window.document.createElement("script");
      s.id = "stripe-script";
      s.type = "text/javascript";
      s.src = "https://js.stripe.com/v2/";
      s.onload = () => {
        window["Stripe"].setPublishableKey(dynamicKey);
      };
      window.document.body.appendChild(s);
    }
  };